<template>
  <div class="room-content" id="room-content">
    <myaudio ref="audio"></myaudio>
    <div class="room-box">
      <div class="title">
        <div class="info">
          <span class="logo-mark"><img src="@/assets/logo/logo.svg" alt=""></span>
          游选账号
          <span class="divide"></span>
          <span>签署合同 找回包赔</span>
        </div>
        <div class="url">
          平台唯一官网：<a :href="websiteUrl" :target="websiteUrl">{{ websiteText }}</a>
        </div>
      </div>
      <div class="room-main">
        <!--  聊天室列表  -->
        <div class="left">
          <div class="col-head">
            <span class="ch-bar"></span>
            <h3>会话</h3>
            <span class="ch-cnt">{{ toproomList.length + roomList.length }} 个会话</span>
          </div>
          <div class="search">
            <el-input placeholder="输入关键词" prefix-icon="el-icon-search" v-model="search" @focus="isSearch=true"
            clearable
            @clear="isSearch=false"
            @input="handleSearch"></el-input>
            <div v-show="isSearch" class="come-back" @click="isSearch=false">返回</div>
          </div>
          <div class="room-list" v-show="!isSearch">
            <div class="title-tip" v-if="topShow">置顶</div>
            <div class="room-item top-up" :class="{'active':roomId == item.id,'top':item.topstatus == 1}" v-for="item in toproomList"
                :key="item.id" @click="intoRoom(item)"
                @contextmenu.prevent.stop="(event)=>{roomListRight(item,event)}"
            >
              <el-badge v-if="item.shieldstatus==0" :value="item.unread" :hidden="item.unread == 0" :max="99">
                <el-image class="icon" :src="item.type == 1?item.headimg:''" :class="item.sessionstatus==0?'line-leave':item.sessionstatus==2?'line-busy':''">
                  <el-image slot="error" :src="item.type == 1 ? require('@/assets/image/CustomerSer/WechatIMG.png'):require('@/assets/image/CustomerSer/qun.png')"></el-image>
                </el-image>
              </el-badge>
              <el-badge v-if="item.shieldstatus==1" :is-dot="item.unread>0">
                <el-image class="icon" :src="item.type == 1?item.headimg:''" :class="item.sessionstatus==0?'line-leave':item.sessionstatus==2?'line-busy':''">
                  <el-image slot="error" :src="item.type == 1 ? require('@/assets/image/CustomerSer/WechatIMG.png'):require('@/assets/image/CustomerSer/qun.png')"></el-image>
                </el-image>
              </el-badge>
              <div style="margin-left: 13px;flex: 1">
                <div style="display: flex;justify-content: space-between;align-items: center">
                  <div class="room-name" :style="{'max-width': [2,3].includes(item.bs_order_status)?'70px':'140px'}">{{ item.title }}</div>
                  <div class="bs-order-status">
                    <img v-if="item.bs_order_status == 2" src="@/assets/image/CustomerSer/jyz.png" alt="">
                    <!-- <img v-if="item.bs_order_status == 4" src="@/assets/image/CustomerSer/jyqx.png" alt=""> -->
                    <img v-if="item.bs_order_status == 3" src="@/assets/image/CustomerSer/jywc.png" alt="">
                  </div>
                  <div class="msg-time">{{ item.addtime|mesTime(formatDate) }}</div>
                </div>
                <div class="room-new-msg">
                  <div class="text">
                  <!-- <div class="text" v-show="item.msg_sender !== ''"> -->
                    <!-- <span v-if="item.type != 2 && item.msg_identity !== '用户'">【{{ item.msg_identity }}】</span> -->
                    <!-- <span v-if="item.type != 2">{{ item.msg_sender }}：</span> -->
                    <span v-if="item.aite==1" style="color:#FF7272;font-weight:500;font-size:12px;">[有人@我]</span>
                    <span v-html="item.content"></span>
                  </div>
                  <div class="room-type" :class="`room-type-1`" v-if="item.type == 3||item.type == 2">
                    {{ item.type == 3||item.type == 2 ? '群聊' : '' }}
                  </div>
                  <div class="close_room">
                    <i class="el-icon-error" @click.stop="close_this_room(item)"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="title-tip">消息</div>
            <div class="room-item" :class="{'active':roomId == item.id,'top':item.topstatus == 1}" v-for="item in roomList"
                :key="item.id" @click="intoRoom(item)"
                @contextmenu.prevent.stop="(event)=>{roomListRight(item,event)}"
            >
              <el-badge v-if="item.shieldstatus==0" :value="item.unread" :hidden="item.unread == 0" :max="99">
                <el-image class="icon" :src="item.type == 1?item.headimg:''" :class="item.sessionstatus==0?'line-leave':item.sessionstatus==2?'line-busy':''">
                  <el-image slot="error" :src="item.type == 1 ? require('@/assets/image/CustomerSer/WechatIMG.png'):require('@/assets/image/CustomerSer/qun.png')"></el-image>
                </el-image>
              </el-badge>
              <el-badge v-if="item.shieldstatus==1" :is-dot="item.unread>0">
                <el-image class="icon" :src="item.type == 1?item.headimg:''" :class="item.sessionstatus==0?'line-leave':item.sessionstatus==2?'line-busy':''">
                  <el-image slot="error" :src="item.type == 1 ? require('@/assets/image/CustomerSer/WechatIMG.png'):require('@/assets/image/CustomerSer/qun.png')"></el-image>
                </el-image>
              </el-badge>
              <div style="margin-left: 13px;flex: 1">
                <div style="display: flex;justify-content: space-between;align-items: center">
                  <div class="room-name" :style="{'max-width': [2,3].includes(item.bs_order_status)?'70px':'140px'}">{{ item.title }}</div>
                  <div class="bs-order-status">
                    <img v-if="item.bs_order_status == 2" src="@/assets/image/CustomerSer/jyz.png" alt="">
                    <!-- <img v-if="item.bs_order_status == 4" src="@/assets/image/CustomerSer/jyqx.png" alt=""> -->
                    <img v-if="item.bs_order_status == 3" src="@/assets/image/CustomerSer/jywc.png" alt="">
                  </div>
                  <div class="msg-time">{{ item.addtime|mesTime(formatDate) }}</div>
                </div>
                <div class="room-new-msg">
                  <div class="text">
                    <!-- <span v-if="item.type != 2 && item.msg_identity !== '用户'">【{{ item.msg_identity }}】</span> -->
                    <!-- <span v-if="item.type != 2">{{ item.msg_sender }}：</span> -->
                    <span v-if="item.aite==1" style="color:#FF7272;font-weight:500;font-size:12px;">[有人@我]</span>
                    <span v-html="regContent(item,'list')"></span>
                  </div>
                  <div class="room-type" :class="`room-type-1`" v-if="item.type == 3||item.type == 2">
                    {{ item.type == 3||item.type == 2 ? '群聊' : '' }}
                  </div>
                  <div class="close_room">
                    <i class="el-icon-error" @click.stop="close_this_room(item)"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="search-list" v-show="isSearch">
            <template v-if="searchRes.contact.length>0">
              <div class="search-label">客服</div>
              <div class="list"
                  :style="`height: ${expansionContact?`${searchRes.contactTotal*70}px`
                  :`${searchRes.contactTotal>3?'210':searchRes.contactTotal*70}px`}`">
                <div class="item" v-for="(item,index) in searchRes.contact" :key="index" @click="intoRoom(item)">
                  <el-image class="image" :src="item.headimg">
                    <el-image slot="error" :src="require('@/assets/image/CustomerSer/WechatIMG.png')"></el-image>
                  </el-image>
                  <div class="label">
                    <div class="text1" v-html="item.nickname"></div>
                    <div class="text2">点击发起私聊</div>
                  </div>
                </div>
              </div>
              <div class="expansion-box" @click="expansionContact=!expansionContact"
                  :class="{'expansion':!expansionContact}">
                <span>{{ expansionContact ? '收起' : '查看更多' }}</span>
                <i class="el-icon-arrow-up"></i>
              </div>
            </template>
            <template v-if="searchRes.groupChat.length>0">
              <div class="search-label">群聊</div>
              <div class="list"
                  :style="`height: ${expansionGroup?`${searchRes.groupChatTotal*70}px`:
                  `${searchRes.groupChatTotal>3?'210':searchRes.groupChatTotal*70}px`}`">
                <div class="item" v-for="(item,index) in searchRes.groupChat" :key="index" @click="intoRoom(item)">
                  <el-image class="image" :src="require('@/assets/image/CustomerSer/qun.png')">
                    <el-image slot="error" :src="require('@/assets/image/CustomerSer/qun.png')"></el-image>
                  </el-image>
                  <div class="label">
                    <div class="text1" v-html="item.title?item.title:item.nickname"></div>
                    <div class="text2">点击进入房间</div>
                  </div>
                </div>
              </div>
              <div class="expansion-box" @click="expansionGroup=!expansionGroup"
                  :class="{'expansion':!expansionGroup}">
                <span>{{ expansionGroup ? '收起' : '查看更多' }}</span>
                <i class="el-icon-arrow-up"></i>
              </div>
            </template>
            <!-- <template v-if="searchRes.chatRecord.length>0">
              <div class="search-label">聊天记录</div>
              <div class="list"
                  :style="`height: ${expansionChatRecord?`${searchRes.chatRecordTotal*70}px`:
                  `${searchRes.chatRecordTotal>3?'210':searchRes.chatRecordTotal*70}px`}`">
                <div class="item" v-for="(item,index) in searchRes.chatRecord" :key="index"
                    @click="handleEnterRoom(item)">
                  <el-image class="image" :src="item.avtar">
                    <el-image slot="error" :src="require('@/assets/image/chat/active.jpg')"></el-image>
                  </el-image>
                  <div class="label">
                    <div class="text1">{{ item.name }}</div>
                    <div class="text2">{{ item.total }}条相关消息</div>
                  </div>
                </div>
              </div>
              <div class="expansion-box" @click="expansionChatRecord=!expansionChatRecord"
                  :class="{'expansion':!expansionChatRecord}">
                <span>{{ expansionChatRecord ? '收起' : '展开' }}全部聊天记录</span>
                <i class="el-icon-arrow-up"></i>
              </div>
            </template> -->
          </div>
        </div>
        <!--  聊天区域  -->
        <div class="room-chat" v-if="roomId!==''">
          <div class="chatHeader">
            <div class="currentCustomerService" v-show="roomInfo.roommanager">
              <img class="complain" src="@/assets/image/CustomerSer/chatIcon.png" alt="">
              {{roomInfo.room_type==3?`当前群主：${roomInfo.roommanager}/群人数${roomInfo.membercount}人`:`当前客服：${roomInfo.roommanager}`}}
              &emsp;&ensp;｜&ensp;&emsp;
              为您解决账号、订单、支付等问题，快速响应
            </div>
            <div class="danger-tip" v-if="roomGameDetailShow">
              <div>
                <i class="el-icon-warning-outline"></i>
                风险提醒：请勿引导外站交易,骗子套路深，交易没保障，谨防上当受骗！
              </div>
              <div class="fpzn" @click="fpznBtn"><img src="@/assets/image/CustomerSer/fptx.png" alt="">防骗指南</div>
            </div>
            <div class="historyRecord" @click="historyDialogOpen">
              点击查看历史记录
            </div>
          </div>
          <!--   消息显示区域   -->
          <div class="mes-box" @scroll="mesScroll" ref="messagesContainer">
            <!--    上拉加载动画    -->
            <div class="loading" v-loading="isGetOldMsg"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(246, 246, 246, 0.6)"
            ></div>
            <div class="old-meg-hint" v-if="!isOldMsg">没有历史消息了</div>

            <template v-for="(item) in messageList">
              <!--   消息     -->
              <div class="mes-item" v-if="item.status == 1&&(item.msgtype!=20&&item.msgtype != 19&&item.msgtype != 16&&item.msgtype != 15&&item.msgtype != 18&&item.msgtype != 24)" :key="item.id" :class="{'is-mi':isMe(item.userid)}">
                <!--    头像      -->
                <div class="avatar" @contextmenu.prevent.stop="(event)=>{isMe(item.userid)?'':headImgRight(item,event)}">
                  <el-image :src="item.headimg">
                    <el-image slot="error" :src="item.msgtype == 1||item.msgtype == 3||item.msgtype == 5||item.msgtype == 6||item.msgtype == 8||item.msgtype == 9||item.msgtype == 14||item.msgtype == 22?require('@/assets/image/CustomerSer/WechatIMG.png'):require('@/assets/image/chat/active.png')"></el-image>
                  </el-image>
                </div>
                <!--    消息框      -->
                <div class="mes">
                  <!--    用户名        -->
                  <div class="user-name">
                    <span>{{ item.nickname }}</span>
                    <span v-if="[1,3,5,6,8,9,14,22].includes(item.msgtype)&&item.nickname!='系统客服'&&item.official_icon==1"><img :src="require('@/assets/image/chat/gfkf.png')" alt=""></span>
                    <span class="add-time">{{ item.addtime|chatMesTime(formatDate) }}</span>
                  </div>
                  <!--    文本消息显示框        -->
                  <div class="text-box" v-if="item.contenttype == 1 || item.contenttype == 2 || item.contenttype == 9">
                    <div class="text" :id="item.id" style="white-space:pre-wrap" v-html="regContent(item,'room')"
                        @contextmenu.prevent.stop="(event)=>{msgRight(item,event)}"></div>
                  </div>
                  <div class="text-box send-link-box" v-if="item.contenttype == 8||item.contenttype == 5" :style="item.contenttype == 8?'flex-direction: column;':''">
                    <div :style="{width: item.contenttype == 8?'300px':''}" v-html="item.content"></div>
                    <div class="wait-pay" v-if="item.contenttype == 8&&item.order_status&&item.buy_user_id==item.user_id">
                      <el-button size="mini" :disabled="item.order_status != 1" @click="closeOrPay(item,2)">取消支付</el-button>
                      <el-button size="mini" :disabled="item.order_status != 1" v-if="item.pay_type==1" type="primary" @click="closeOrPay(item,1)">已支付</el-button>
                      <el-button size="mini" :disabled="item.order_status != 1" v-if="item.pay_type==2" type="primary" @click="closeOrPay(item,1)">前往支付</el-button>
                    </div>
                  </div>
                  <!--    合并消息显示框        -->
                  <div class="text-box" v-if="item.contenttype == 10">
                    <div class="text" :id="item.id">
                      <div class="merge-msg" @click="mergeMsg(item.content)">
                        <div class="merge-msg-title">{{ item.content.content }}的聊天记录</div>
                        <div class="merge-msg-list">
                          <div class="merge-msg-item" v-for="(mergrMsg,index) in item.content.msglist" :key="mergrMsg.id">
                            <div v-if="index<=3">
                              {{ mergrMsg.nickname }}:
                              <span style="white-space:pre-wrap">
                                {{ mergrMsg.contenttype == 1 ? mergrMsg.content : mergrMsg.contenttype == 10 ? '[聊天记录]' : mergrMsg.contenttype == 3 || mergrMsg.contenttype == 4 ? '[图片]' : mergrMsg.contenttype == 6 ? '[文件]' : mergrMsg.contenttype == 9 ? '[@消息]' : mergrMsg.contenttype == 5 ? '[链接]' : mergrMsg.contenttype == 8 ? '[订单消息]' : '' }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="merge-msg-bottom">聊天记录</div>
                      </div>
                    </div>
                  </div>
                  <!--    图片消息显示框        -->
                  <div style="display: flex" :style="isMe(item.userid)?'flex-direction: row-reverse':''"
                      v-if="item.contenttype == 4||item.contenttype == 3"
                  >
                    <div class="image" :id="item.id" @contextmenu.prevent.stop="(event)=>{msgRight(item,event)}">
                      <!-- <img :src="item.content.thumbnail" alt="" crossOrigin="anonymous" width="100" height="100"> -->
                      <el-image :src="item.content.thumbnail" :lazy="true" @click="onImagePreview(item.content.url)">
                        <el-image slot="placeholder" :src="require('@/assets/image/chat/loading.gif')"></el-image>
                      </el-image>
                    </div>
                  </div>
                  <!--    文件消息显示框        -->
                  <div style="display: flex" :style="isMe(item.userid)?'flex-direction: row-reverse':''"
                      v-if="item.contenttype == 6"
                  >
                    <div class="file" @click="downLoad(item)"
                        v-if="!item.video"
                        @contextmenu.prevent.stop="(event)=>{msgRight(item,event)}">
                      <div class="file-img">
                        <el-image :src="require('@/assets/image/chat/showFile.png')"></el-image>
                      </div>
                      <div class="file-box">
                        <div class="file-name">{{ item.content.filename }}</div>
                        <div class="file-size">{{ formatFileSize(item.content.size) }}</div>
                      </div>
                    </div>
                    <div v-else>
                      <video :src="item.content.url" @contextmenu.prevent.stop="(event)=>{msgRight(item,event)}" controls="controls" style="width: 250px;height: 150px;"></video>
                    </div>
                  </div>
                  <!-- 融云商品消息 (PX:ProductMsg) -->
                  <div class="rc-msg-card" v-if="item.contenttype === 'rc_product'" @contextmenu.prevent.stop="(event)=>{msgRight(item,event)}">
                    <el-image v-if="item.content && item.content.img" class="rc-card-img" :src="item.content.img" fit="cover"></el-image>
                    <div class="rc-card-body">
                      <div class="rc-card-title">{{ item.content && item.content.title }}</div>
                      <div class="rc-card-price" v-if="item.content && item.content.price">¥{{ item.content.price }}</div>
                    </div>
                    <div class="rc-card-footer">商品</div>
                  </div>
                  <!-- 融云订单消息 (PX:OrderMsg) -->
                  <div class="rc-msg-card" v-if="item.contenttype === 'rc_order'" @contextmenu.prevent.stop="(event)=>{msgRight(item,event)}">
                    <el-image v-if="item.content && item.content.img" class="rc-card-img" :src="item.content.img" fit="cover"></el-image>
                    <div class="rc-card-body">
                      <div class="rc-card-title">{{ item.content && item.content.title }}</div>
                      <div class="rc-card-price" v-if="item.content && item.content.price">¥{{ item.content.price }}</div>
                    </div>
                    <div class="rc-card-footer">订单 #{{ item.content && item.content.order_id }}</div>
                  </div>
                  <!-- 融云评价消息 (PX:EvaluationMsg) -->
                  <div class="rc-msg-card" v-if="item.contenttype === 'rc_evaluation'">
                    <div class="rc-card-body">
                      <div class="rc-card-title">{{ (item.content && item.content.content) || '请对本次服务进行评价' }}</div>
                      <div v-if="item.content && item.content.score" style="margin-top:4px;color:#F7BA2A;font-size:16px;letter-spacing:2px;">
                        <span v-for="n in 5" :key="n">{{ Number(item.content.score) >= n ? '★' : '☆' }}</span>
                        <span style="color:#999;font-size:12px;margin-left:4px;">{{ item.content.score }}分</span>
                      </div>
                    </div>
                    <div class="rc-card-footer">评价</div>
                  </div>
                  <!-- 融云售后消息 (PX:AfterSalesMsg) -->
                  <div class="rc-msg-card" v-if="item.contenttype === 'rc_aftersales'">
                    <div class="rc-card-body">
                      <div class="rc-card-title">{{ item.content && item.content.content }}</div>
                    </div>
                    <div class="rc-card-footer">售后申请</div>
                  </div>
                  <!--      公告          -->
                  <div class="announcement-box" v-if="item.type == 4">
                    <div class="announcement" @click="lookAnnouncement">
                      <div class="title">
                        <img src="@/assets/image/chat/announcement.png"
                            style="width: 15px;height: 12px;margin-right: 9px;">
                        群公告
                      </div>
                      <div class="content" v-html="item.message"></div>
                      <div class="look-info">
                        查看详情<i class="el-icon-caret-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="item.status == 2" :key="item.id" class="recall_wrapper">
                {{isMe(item.userid)?`我撤回了一条消息`:`${item.nickname}撤回了一条消息`}}
              </div>
              <div v-if="item.status == 1&&item.msgtype == 24" :key="item.id" class="recall_wrapper">
                {{ isMe(item.senduserid)?`您已催一催客服，正在加急处理中~`:`${item.sendnickname}已催一催客服，正在加急处理中~` }}

              </div>
              <div v-if="item.status == 1&&(item.msgtype == 20||item.msgtype == 19||item.msgtype == 16||item.msgtype == 15||item.msgtype == 18)" :key="item.id" class="recall_wrapper">
                {{item.content}}
              </div>
            </template>
            <!-- 转接消息 -->
            <div class="mes-item" v-if="jinyong">
              <!--    头像      -->
              <div class="avatar">
                <el-image :src="roomInfo.headimg">
                  <el-image slot="error" :src="require('@/assets/image/CustomerSer/WechatIMG.png')"></el-image>
                </el-image>
              </div>
              <!--    消息框      -->
              <div class="mes">
                <!--    用户名        -->
                <div class="user-name">
                  <span>{{ roomInfo.roommanager }}</span>
                  <span class="add-time">{{ transferTime|chatMesTime(formatDate) }}</span>
                </div>
                <!--    文本消息显示框        -->
                <div class="text-box" style="max-width: 300px">
                  <div class="text">{{ transferText }}<br/>请点击【<span @click="transfer" style="color: var(--primary, #FF5A1F);cursor: pointer;">转接其他客服</span>】</div>
                </div>
              </div>
            </div>
            <!-- <div class="account-tip">
              <div class="account-tip-top">
                <i class="el-icon-warning-outline"></i>
                该商品已被购买
              </div>
              <div class="account-tip-bottom">
                该商品已被其他买家下单支付，请勿在此群中交接资料！如出现纠纷后果自负！
              </div>
            </div>
            <div class="account-tip">
              <div class="account-tip-top">
                <i class="el-icon-warning-outline"></i>
                交易失败
              </div>
              <div class="account-tip-bottom">
                很遗憾您的账号交易失败，账号已暂时下架，如需继续出售，请到个人中心一键上架！
              </div>
            </div> -->
            <div class="score" id="score" ref="score" v-if="scoreShow&&this.evid_roomid == this.roomId" @click.prevent.self="scoreShow = false">
              <div class="scoreHeader">
                <span></span>
                请为客服{{roomInfo.roommanager}}的服务打分
                <span></span>
              </div>
              <div class="scoreBody">
                <el-rate v-model="score" void-icon-class="iconfont star"
                  @change="rateChange"
                  :texts="['恶劣', '较差', '一般', '较好', '满意']" show-text
                  :icon-classes="['iconfont star','iconfont star','iconfont star']"
                  :colors="['#ffd427','#ffd427','#ffd427']" :void-color="'#ebeef2'"
                  score-template="{value}"></el-rate>
              </div>
            </div>
            <div style="margin-bottom: 20px"></div>
          </div>
          <el-button class="newMsg aiteMsg" :loading="aiteBtnLoad" @click="aiteMsgClick" :style="{'display':checkAiteMsg?'flex':'none','bottom':checkNewMsg?'255px':'219px'}"><img
            src="@/assets/image/CustomerSer/aiteMsgIcon.png" alt="">有人@我
          </el-button>
          <div class="newMsg" @click="newMsgClick" :style="checkNewMsg?'display:flex':'display:none'"><img
            src="@/assets/image/CustomerSer/newMsgIcon.png" alt="">1条新消息
          </div>
          <div class="chatBtn" v-if="(roomInfo.room_type==1&&!shopInfoShow)||roomGameDetailShow">
            <div class="btn" v-for="(item,index) in btnGroup" :key="index" @click="item.click"
                 :ref="item.label==='评价客服'?'score':''"
                 :style="item.icon?'padding-left:13px':''">
              <img v-if="item.icon" :src="item.icon" alt="">
              {{ item.label }}
            </div>
          </div>
          <div class="refundCountdown" v-if="refundCountdown&&!roomGameDetailShow&&roomInfo.room_type==3">
            客服处理退款时间
            <count-down class="count_down" :endTime="this.refundEndTime" :startTime="this.refundStartTime" @countDownChange="countDownChange()"></count-down>
          </div>
          <div class="shop-link-info" v-if="shopInfoShow">
            <div class="link-left">
              <img :src="shopInfoSend.image" alt="">
            </div>
            <div class="link-right">
              <div class="link-title">{{shopInfoSend.name}}</div>
              <div class="link-price">
                <div class="link-price-left">价格：<span>¥{{shopInfoSend.price}}</span></div>
                <div class="link-send" @click="ChatProductAdd('')">发送链接</div>
              </div>
            </div>
            <div class="link-close" @click="shopLinkClose">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <div class="shop-link-info" style="margin-top: 5px;" v-if="roomGameDetailShow" @click="goGameDetail(roomGameDetail.game_id, roomGameDetail.goods_id)">
            <div class="link-left">
              <img :src="roomGameDetail.image" alt="">
            </div>
            <div class="link-right">
              <div class="link-title">{{roomGameDetail.name}}</div>
              <div class="link-price">
                <div class="link-price-left">价格：<span>¥{{roomGameDetail.price}}</span></div>
               <div v-if="roomGameDetail.buy_user_id == $store.state.userData.user_id&&!roomGameDetail.orderStatus" class="link-send" @click.stop="buyNow(roomGameDetail.game_id,roomGameDetail.goods_id)">立即购买</div>
                <div v-if="roomGameDetail.sale_user_id == $store.state.userData.user_id" style="cursor: pointer;" @click.stop="sellDetail(roomGameDetail.game_id,roomGameDetail.goods_id)">查看详情<i class="el-icon-arrow-right"></i></div>
              </div>
            </div>
            <!-- <div class="link-close" @click="shopLinkClose">
              <i class="el-icon-close"></i>
            </div> -->
          </div>
          <!--   发送消息区域   -->
          <div class="entrance-box" :class="{'is-mute':isMute}" ref="entranceBox">
            <div class="tool">
              <div class="tool-box">
                <span class="tool-item" data-title="发表情">
                  <emoji @click="emojiClick">
                    <template slot-scope="{open}">
                      <img class="tool-img" src="@/assets/image/chat/emoji.png" @click="open()">
                    </template>
                  </emoji>
                </span>
                <!-- 截图 -->
                <span class="tool-item" data-title="截图" @click="screenShot">
                  <img class="tool-img" src="@/assets/image/chat/screenshot.png" />
                </span>
                <span class="tool-item" data-title="发图片">
                  <el-upload
                    :headers="{appid:appid}"
                    action="https://wsapi.pxb7.com/api/upload/uploaddata"
                    :show-file-list="false"
                    :data="dataMsg"
                    accept=".jpg,.jpeg,.png,.bmp,.gif"
                    multiple
                    :on-success="uploadSuccess"
                    :on-error="uploadError"
                    :before-upload="beforeUploadImg"
                  >
                    <!-- <i class="iconfont upload_img"></i> -->
                    <img class="tool-img" src="@/assets/image/chat/image.png">
                  </el-upload>
                </span>
                <span class="tool-item" data-title="传文件">
                  <el-upload
                    :headers="{appid:appid}"
                    action="https://wsapi.pxb7.com/api/upload/uploaddata"
                    :show-file-list="false"
                    :data="dataMsg"
                    accept=".doc,.docx,.xls,.xlsx,.txt,.pdf,.rar,.zip,.exe,.mp4"
                    :on-success="uploadSuccess"
                    :on-error="uploadError"
                    :before-upload="beforeUpload"
                  >
                    <img class="tool-img" src="@/assets/image/chat/file.png">
                  </el-upload>
                </span>
                <div class="sendRemind" @click="sendRemindBtn">
                  <img src="@/assets/image/chat/cui.png" alt="">
                  催一催
                </div>
              </div>
              <div class="send-pc" @click="handleSendMessage">发送</div>
            </div>
            <div class="input-box" id="myTextarea">
              <my-textarea ref="myTextarea" v-model="message" :members="[...this.members,...this.userLists]" :roomType="roomInfo.room_type" :returnUserid="getUserId" :userReset="userReset" @ctrl-enter="handleSendMessage" :textareaImgApi="textareaImgApi" :textareaEncryptApi="textareaEncryptApi"></my-textarea>
              <!-- <my-textarea ref="myTextarea" v-model="message" :members="this.members" @ctrl-enter="handleSendMessage"></my-textarea> -->
            </div>
          </div>
          <!--   文件上传区域   -->
          <div class="progress" v-show="uploadFiles.length>0">
            <div style="margin-bottom: 5px" v-for="item in uploadFiles" :key="item.key">
              <div class="progress-title">
                <span class="file-name">{{ item.fileName }}</span>
                <span>{{ item.msg }}</span>
              </div>
              <el-progress :percentage="item.rate"></el-progress>
            </div>
          </div>
        </div>
        <!--  房间描述，房间成员  -->
        <!-- 群聊 -->
        <div class="room-info" v-if="roomId!==''&&roomInfo.room_type==3">
          <el-tabs v-model="activeName">
            <el-tab-pane label="群组信息" name="first"></el-tab-pane>
            <el-tab-pane v-if="orderInfo.length>0" label="交易信息" name="second"></el-tab-pane>
          </el-tabs>
          <template v-if="activeName === 'first'">
            <div style="padding:0 10px">
              <div class="text-1">
                聊天室名称
              </div>
              <div class="text-2 mt-10">
                {{ roomInfo.title }}
              </div>
              <div class="create-time">创建日期：{{ roomInfo.addtime }}</div>
              <!-- <div class="create-time">创建日期：{{ $formatDate(roomInfo.add_time,'YYYY.MM.DD hh:mm:ss') }}</div> -->
              <template v-if="medium.type == 2">
              <!-- <template v-if="roomInfo.type == 3"> -->
                <!-- <div class="room-divider"></div> -->
                <announcement :text="roomInfo.announcement" :title="roomInfo.alternatetitle" ref="announcement">
                  <template slot-scope="{open}">
                    <div class="announcement" @click="open()">
                      <div class="title">群信息</div>
                      <div class="content">
                        <div class="text">{{ roomInfo.announcement ? roomInfo.announcement : '暂无内容' }}</div>
                        <div class="icon">
                          <i class="el-icon-arrow-right"></i>
                        </div>
                      </div>
                    </div>
                  </template>
                </announcement>
              </template>
            </div>
          </template>
          <template v-else>
            <!-- <template>
              <div class="form-item">
                <div class="label">商品编号：</div>
                <div class="input">{{ medium.goods_no }}</div>
              </div>
              <div class="form-item">
                <div class="label">游戏名称：</div>
                <div class="input">{{ medium.game_name }}</div>
              </div>
              <div class="form-item">
                <div class="label">游戏大区：</div>
                <div class="input">{{ medium.area_name }}</div>
              </div>
              <div class="form-item" v-if="medium.server_name">
                <div class="label">服务器：</div>
                <div class="input">{{ medium.server_name }}</div>
              </div>
              <div class="form-item">
                <div class="label">交易价格：</div>
                <div class="input">{{ medium.goods_price }}</div>
              </div>
              <div class="form-item">
                <div class="label">服务客服：</div>
                <div class="input">{{ medium.admin_name }}</div>
              </div>
            </template> -->
            <template>
              <!-- 收款信息 -->
              <div class="order-refund" v-if="paymentShow&&paymentInfo.sale_user_id == $store.state.userData.user_id">
                <div class="refund-title">
                  <div class="title-left">收款信息</div>
                </div>
                <div class="form-item">
                  <div class="label">收款人：</div>
                  <div class="input">
                    <el-input v-model="paymentInfo.name" placeholder="请输入收款人"></el-input>
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">收款方式：</div>
                  <div class="input">
                    <el-select v-model="paymentInfo.method" placeholder="请选择收款方式">
                      <el-option
                        label="支付宝"
                        value="支付宝">
                      </el-option>
                      <el-option
                        label="微信"
                        value="微信">
                      </el-option>
                      <el-option
                        label="银行卡"
                        value="银行卡">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">收款账号：</div>
                  <div class="input">
                    <el-input v-model="paymentInfo.account" placeholder="请输入收款账号"></el-input>
                  </div>
                </div>
                <div class="refund-btn">
                  <span class="title-save" @click="savePayment">提交</span>
                </div>

              </div>
              <!-- 退款信息 -->
              <div class="order-refund" v-if="refundShow&&refundInfo.buy_user_id == $store.state.userData.user_id">
                <div class="refund-title">
                  <div class="title-left">退款信息</div>
                </div>
                <div class="form-item">
                  <div class="label">收款人：</div>
                  <div class="input">
                    <el-input v-model="refundInfo.name" placeholder="请输入收款人"></el-input>
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">收款方式：</div>
                  <div class="input">
                    <el-select v-model="refundInfo.method" placeholder="请选择收款方式">
                      <el-option
                        label="支付宝"
                        value="支付宝">
                      </el-option>
                      <el-option
                        label="微信"
                        value="微信">
                      </el-option>
                      <el-option
                        label="银行卡"
                        value="银行卡">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">收款账号：</div>
                  <div class="input">
                    <el-input v-model="refundInfo.account" placeholder="请输入收款账号"></el-input>
                  </div>
                </div>
                <div class="refund-btn">
                  <span class="title-red" @click="cancelRefundDia = true">取消退款</span>
                  <span class="title-save" @click="saveRefund">确认</span>
                </div>

              </div>
              <trading-information :orderInfo="orderInfo" :closeOrderPay="closeOrPay" :getpayDetail="payDetail" @countDowned="countDowned()"></trading-information>
            </template>
          </template>
          <!-- <div class="room-divider"></div> -->
          <div class="members-title">
            <span>设置操作</span>
          </div>
          <div class="room-set" :class="{'mb-10':roomInfo.type!=2}">
            <span>置顶</span>
            <el-switch
                v-model="roomInfo.topstatus"
                @change="handleTop(roomInfo,'info')"
                :active-value="1"
                :inactive-value="0"
                active-color="#FF5A1F"
                inactive-color="#E7EAEE">
            </el-switch>
          </div>
          <div class="room-set" v-show="roomInfo.type != 2">
            <span>屏蔽</span>
            <el-switch
                v-model="roomInfo.shieldstatus"
                @change="handleRemind(roomInfo,'info')"
                :active-value="1"
                :inactive-value="0"
                active-color="#FF5A1F"
                inactive-color="#E7EAEE">
            </el-switch>
          </div>
          <!-- <div class="room-divider"></div> -->
          <template v-if="roomInfo.type != 2">
            <div class="members-title">
              <span>群聊人员</span>
              <!-- <span class="text">群成员列表</span> -->
              <!-- <span class="pack-up" :class="{'expansion':!expansionMember}"
                  @click="expansionMember=!expansionMember"
              >{{ expansionMember ? '收起' : '展开' }}<i
                  class="el-icon-arrow-up"
              <div class="members-expansion" :style="{roomInfo.room_type==1?}">
              ></i></span> -->
            </div>
            <div v-show="expansionMember" style="padding-bottom: 60px;">
              <div class="members-expansion">
                <div class="mem-title" v-if="members.length>0">客服：</div>
                <div class="item" v-for="item in members" :key="item.user_id" @contextmenu.prevent.stop="(event)=>{isMe(item.userid)?'':headImgRight(item,event)}">
                  <el-image class="avatar" :src="item.headimg">
                    <el-image slot="error" :src="require('@/assets/image/CustomerSer/WechatIMG.png')"></el-image>
                  </el-image>
                  <div style="flex: 1">
                    <div class="name">{{ item.nickname }}</div>
                    <!-- <div class="privateChat">点击发起私聊</div> -->
                  </div>
                  <div :class="`on-line-${item.sessionstatus}`">{{ item.sessionstatus == 0 ? '离线' : item.sessionstatus == 2 ? '忙碌' : '' }}</div>
                  <!-- <div :class="`on-line-${item.isOnLine}`">{{ item.isOnLine === 1 ? '' : '离线' }}</div> -->
                </div>
                <div class="mem-title">用户：</div>
                <div class="item" v-for="item in userLists" :key="item.user_id" @contextmenu.prevent.stop="(event)=>{isMe(item.userid)?'':headImgRight(item,event)}">
                  <el-image class="avatar" :src="item.headimg">
                    <el-image slot="error" :src="require('@/assets/image/chat/active.png')"></el-image>
                  </el-image>
                  <div style="flex: 1">
                    <div class="name">{{ item.nickname }}</div>
                  </div>
                  <div :class="`on-line-${item.sessionstatus}`">{{ item.sessionstatus == 0 ? '离线' : item.sessionstatus == 2 ? '忙碌' : '' }}</div>
                  <!-- <div :class="`on-line-${item.isOnLine}`">{{ item.isOnLine === 1 ? '' : '离线' }}</div> -->
                </div>
              </div>
            </div>
            <div v-show="!expansionMember">
              <div class="members">
                <i class="el-icon-caret-left" @click="memberScroll('left')"></i>
                <div class="list" ref="members">
                  <el-image class="item" v-for="item in members" :key="item.user_id" :src="item.avtar">
                    <el-image slot="error" :src="require('@/assets/image/chat/active.jpg')"></el-image>
                  </el-image>
                </div>
                <i class="el-icon-caret-right" @click="memberScroll('right')"></i>
              </div>
            </div>
             <!-- v-show="roomInfo.type == 3" -->
            <div class="room-quit-box">
              <div class="room-quit" @click="quitVisible=true">
                退出聊天室
              </div>
            </div>
          </template>
        </div>
        <!-- 私聊 -->
        <div class="room-info" v-if="roomId!==''&&(roomInfo.room_type==1||roomInfo.room_type==2)">
          <el-tabs v-model="activeTradeCuse">
            <el-tab-pane label="客服名片" name="first"></el-tab-pane>
            <el-tab-pane label="交易信息" name="second"></el-tab-pane>
          </el-tabs>
          <template v-if="activeTradeCuse === 'first'">
            <div class="cardBody">
              <img :src="roomInfo.headimg?roomInfo.headimg:require('@/assets/image/CustomerSer/WechatIMG.png')" alt="" class="avatar">
              <div class="other">
                <div class="customer_name">{{roomInfo.roommanager}}</div>
                <div>工作时间：<span>{{complaint.complaint_phone_time}}</span></div>
              </div>
            </div>
            <div class="ratingStars">
              <span class="ratingStars_title">
                <img src="@/assets/image/chat/ratingStars.png" alt="">
                评价星级：
              </span>
              <span :title="score">
                <el-rate v-model="score" disabled disabled-void-icon-class="iconfont star"
                  :icon-classes="['iconfont star','iconfont star','iconfont star']"
                  :colors="['#ffd427','#ffd427','#ffd427']" :disabled-void-color="'#ebeef2'"
                  score-template="{value}"></el-rate>
              </span>
            </div>
          </template>
          <template v-else>
            <div class="sendLink" v-if="shopInfo.name&&orderInfo.length==0">
              <div class="link-top">
                <img :src="shopInfo.image" alt="">
                <span>{{shopInfo.name}}</span>
              </div>
              <div class="link-bottom">
                <div class="link-price">价格：<span>¥{{shopInfo.price}}</span></div>
                <div class="link-btn" @click="ChatProductAdd(shopInfo.id)">发送链接</div>
              </div>
            </div>
            <!-- 收款信息 -->
            <div class="order-refund" v-if="paymentShow&&paymentInfo.sale_user_id == $store.state.userData.user_id">
              <div class="refund-title">
                <div class="title-left">收款信息</div>
              </div>
              <div class="form-item">
                <div class="label">收款人：</div>
                <div class="input">
                  <el-input v-model="paymentInfo.name" placeholder="请输入收款人"></el-input>
                </div>
              </div>
              <div class="form-item">
                <div class="label">收款方式：</div>
                <div class="input">
                  <el-select v-model="paymentInfo.method" placeholder="请选择收款方式">
                    <el-option
                      label="支付宝"
                      value="支付宝">
                    </el-option>
                    <el-option
                      label="微信"
                      value="微信">
                    </el-option>
                    <el-option
                      label="银行卡"
                      value="银行卡">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-item">
                <div class="label">收款账号：</div>
                <div class="input">
                  <el-input v-model="paymentInfo.account" placeholder="请输入收款账号"></el-input>
                </div>
              </div>
              <div class="refund-btn">
                <span class="title-save" @click="savePayment">提交</span>
              </div>
            </div>
            <!-- 退款信息 -->
            <div class="order-refund" v-if="refundShow&&refundInfo.buy_user_id == $store.state.userData.user_id">
              <div class="refund-title">
                <div class="title-left">退款信息</div>
              </div>
              <div class="form-item">
                <div class="label">收款人：</div>
                <div class="input">
                  <el-input v-model="refundInfo.name" placeholder="请输入收款人"></el-input>
                </div>
              </div>
              <div class="form-item">
                <div class="label">收款方式：</div>
                <div class="input">
                  <el-select v-model="refundInfo.method" placeholder="请选择收款方式">
                    <el-option
                      label="支付宝"
                      value="支付宝">
                    </el-option>
                    <el-option
                      label="微信"
                      value="微信">
                    </el-option>
                    <el-option
                      label="银行卡"
                      value="银行卡">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-item">
                <div class="label">收款账号：</div>
                <div class="input">
                  <el-input v-model="refundInfo.account" placeholder="请输入收款账号"></el-input>
                </div>
              </div>
              <div class="refund-btn">
                <span class="title-red" @click="cancelRefundDia = true">取消退款</span>
                <span class="title-save" @click="saveRefund">确认</span>
              </div>
            </div>
            <trading-information :orderInfo="orderInfo" :closeOrderPay="closeOrPay" :getpayDetail="payDetail" @countDowned="countDowned()"></trading-information>
          </template>

          <el-tabs v-model="activeSetting">
            <el-tab-pane label="设置操作" name="first"></el-tab-pane>
            <el-tab-pane label="关于我们" name="second"></el-tab-pane>
          </el-tabs>
          <template v-if="activeSetting === 'first'">
            <div class="room-set" :class="{'mb-10':roomInfo.type!=2}">
            <span>置顶</span>
            <el-switch
                v-model="roomInfo.topstatus"
                @change="handleTop(roomInfo,'info')"
                :active-value="1"
                :inactive-value="0"
                active-color="#FF5A1F"
                inactive-color="#E7EAEE">
            </el-switch>
          </div>
          <!-- <div class="room-set" v-show="roomInfo.type != 2">
            <span>屏蔽</span>
            <el-switch
                v-model="roomInfo.shieldstatus"
                @change="handleRemind(roomInfo,'info')"
                :active-value="1"
                :inactive-value="0"
                active-color="#FF5A1F"
                inactive-color="#E7EAEE">
            </el-switch>
          </div>-->
          </template>
          <template v-else>
            <div class="privateChat-about">
              游严选账号<br/>
  为您的游戏交易保驾护航<br/>
  历经三年用心打磨，累计成交订单超1000000笔，为数二百万客户提供过直接服务，我们与客户的利益站在同一阵线，感谢您选择游严选账号！<br/>
  我们拥有线上线下三百人的工作团队为您全方位提供最专业的账号交易服务<br/>
  我们拥有完善成熟的“正规电子合同签署+专业售后部门+合作律师”找回包赔流程<br/>
  我们拥有让客户买得放心，卖得舒心，交易得开心的服务理念
            </div>
          </template>
          <!-- <img class="priva-img" src="@/assets/image/CustomerSer/complain.png" alt=""> -->
          <div class="priva-box">
            <div class="priva-phone" v-if="cusPhone">
              <div>
                <div class="priva-box-phone"><span>客服联系电话</span></div>
                <!-- <div class="priva-box-time">（{{complaint.complaint_phone_time}}）</div> -->
              </div>
              <div>
                <div>{{cusPhone}}</div>
                <!-- <div>{{complaint.complaint_phoneB}}</div> -->
              </div>
            </div>
            <div class="priva-phone">
              <div>
                <div class="priva-box-phone"><span>投诉邮箱</span></div>
              </div>
              <div>
                <div>{{complaint.complaint_email}}</div>
              </div>
            </div>
            <div class="priva-phone">
              <div>
                <div class="priva-box-phone"><span>工作时间</span></div>
              </div>
              <div>
                <div>{{complaint.complaint_phone_time}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="false" class="app_qrcode">
        <div class="qrcode-top">
          <img src="@/assets/image/chat/app_logo.png" alt="">
          <div class="qrcode-top-text">
            <div>游严选账号APP</div>
            <div>安全高效·找回包赔</div>
          </div>
        </div>
        <img src="@/assets/image/chat/qr_code.png" alt="" class="app-qrcode-img">
        <!-- <img src="@/assets/image/chat/qrcode.gif" alt="" class="app-qrcode-img"> -->
        <div class="qrcode-bottom">
          <img src="@/assets/image/chat/app_ss.png" alt="">
          扫码下载游严选账号APP
        </div>
      </div>
      <div class="app_qrcode wx_qrcode" v-if="wxQrcodeData.qrcode&&wxQrcodeShow">
        <div class="qrcode-top wx_qrcode_top">
          {{wxQrcodeData.wechat_float_notes}}
        </div>
        <img :src="wxQrcodeData.qrcode" alt="" class="app-qrcode-img">
        <div class="wx-qrcode-bottom wx-qrcode-bottom-none">
          <img src="@/assets/image/Home/copyright.png" alt="">
          金华博淳网络科技
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="wx-qrcode-bottom wx-qrcode-bottom-last">
          <img src="@/assets/image/Home/bannerSs.png" alt="">
          微信扫码
        </div>
      </div>
    </div>
    <!--  房间列表右键菜单  -->
    <div v-show="menuVisible" class="menu" :style="`left: ${menuLeft}px;top: ${menuTop}px;`" key="menuRight">
      <div class="contextmenu__item" @click="handleTop(roomRow,'list')">{{ roomRow.topstatus == 0 ? '置顶' : '取消置顶' }}</div>
      <!-- <div class="contextmenu__item" @click="handleClose(roomRow)">关闭对话</div> -->
      <div class="contextmenu__item" @click="handleRemind(roomRow,'list')" v-show="roomRow.type != 1">
        {{ roomRow.shieldstatus == 0 ? '屏蔽' : '取消屏蔽' }}
      </div>
    </div>
    <div v-show="msgRightVisible" class="msgRight" :style="`left: ${msgLeft}px;top: ${msgTop}px;`" key="msgRight">
      <div class="item" v-show="isShowRecall()" @click="handleRevoke(msgRow)">撤回</div>
      <div class="item" v-show="msgRow.contenttype == 4||msgRow.contenttype == 3||msgRow.contenttype == 1||msgRow.contenttype == 9" @click="handleCopy(msgRow)">复制</div>
      <div class="item" v-show="msgRow.contenttype == 4||msgRow.contenttype == 3||msgRow.contenttype == 1||msgRow.contenttype == 9||msgRow.contenttype == 6" @click="handleForward(msgRow)">转发</div>
      <div class="item" v-show="msgRow.contenttype == 6" @click="downLoad(msgRow)">下载</div>
    </div>
    <div v-show="headImgVisible&&roomInfo.room_type!=1" class="headImgRight" :style="`left: ${headImgLeft}px;top: ${headImgTop}px;`" key="headImgRight">
      <div class="item" v-show="isCutomer(headImgRow.userid)" @click="getPrivateChat(headImgRow)">发起私聊</div>
      <div class="item" @click="aiTeEvery(headImgRow)">@{{headImgRow.nickname}}</div>
    </div>
    <div v-show="quitVisible" class="quit-mark" @click="quitVisible=false">
      <div class="quit-box">
        <div class="quit-title">
          退出群聊后将删除所有聊天记录，是否退出？
        </div>
        <div class="quit-btn">
          <div class="quit" @click="handleQuitRoom">退出</div>
          <div class="retain" @click="quitVisible=false">取消</div>
        </div>
      </div>
      <div class="quit-close">
        <i class="el-icon-circle-close" @click="quitVisible=false"></i>
      </div>
    </div>
    <div v-show="quitqunVisible" class="quit-mark" @click="quitqunVisible=false">
      <div class="quit-box">
        <div class="quit-title">
          退出群聊后将删除所有聊天记录，是否退出？
        </div>
        <div class="quit-btn">
          <div class="quit" @click="handleQuitqunRoom">退出</div>
          <div class="retain" @click="quitqunVisible=false">取消</div>
        </div>
      </div>
      <div class="quit-close">
        <i class="el-icon-circle-close" @click="quitqunVisible=false"></i>
      </div>
    </div>
    <!-- 关闭会话 -->
    <div v-show="closeRoomDia" class="quit-mark" @click="closeRoomDia=false">
      <div class="quit-box">
        <div class="quit-title">
          关闭会话
        </div>
        <div class="quit-con">
          是否确认关闭当前会话
        </div>
        <div class="quit-btn">
          <div class="retain" @click="handleCloseRoom">确认关闭</div>
        </div>
      </div>
      <div class="quit-close">
        <i class="el-icon-circle-close" @click="closeRoomDia=false"></i>
      </div>
    </div>
    <!-- 取消支付弹窗 -->
    <div v-show="cancelPayDia" class="quit-mark" @click="cancelPayDia=false">
      <div class="quit-box">
        <div class="quit-title">
          提示
        </div>
        <div class="quit-con">
          是否确认取消订单支付
        </div>
        <div class="quit-btn">
          <div class="retain" @click="handleClosePay">确认</div>
        </div>
      </div>
      <div class="quit-close">
        <i class="el-icon-circle-close" @click="cancelPayDia=false"></i>
      </div>
    </div>
    <!-- 取消退款弹窗 -->
    <div v-show="cancelRefundDia" class="quit-mark" @click="cancelRefundDia=false">
      <div class="quit-box">
        <div class="quit-title">
          提示
        </div>
        <div class="quit-con">
          是否确认取消退款
        </div>
        <div class="quit-btn">
          <div class="retain" @click="handleSaveRefund">确认</div>
        </div>
      </div>
      <div class="quit-close">
        <i class="el-icon-circle-close" @click="cancelRefundDia=false"></i>
      </div>
    </div>
    <!-- 确认退款弹窗 -->
    <div v-show="confirmRefunDia" class="quit-mark" @click="confirmRefunDia=false">
      <div class="quit-box">
        <div class="quit-title">
          提示
        </div>
        <div class="quit-con">
          是否确认退款信息正确
        </div>
        <div class="quit-btn">
          <div class="retain" @click="handleRefund">确认</div>
        </div>
      </div>
      <div class="quit-close">
        <i class="el-icon-circle-close" @click="confirmRefunDia=false"></i>
      </div>
    </div>
    <!-- 确认收款弹窗 -->
    <div v-show="confirmPaymentDia" class="quit-mark" @click="confirmPaymentDia=false">
      <div class="quit-box">
        <div class="quit-title">
          提示
        </div>
        <div class="quit-con">
          是否确认收款信息正确
        </div>
        <div class="quit-btn">
          <div class="retain" @click="handlePayment">确认</div>
        </div>
      </div>
      <div class="quit-close">
        <i class="el-icon-circle-close" @click="confirmPaymentDia=false"></i>
      </div>
    </div>
    <!--  踢出弹出  -->
    <div v-if="kickOutVisible" class="quit-mark" @click="kickOutVisible=false">
      <div class="quit-box" style="width: 380px;height: 180px">
        <div class="quit-title">
          您已被踢出群聊
        </div>
        <div class="quit-btn" style="justify-content: center">
          <div class="quit" @click="handleConfirmKick">确定</div>
        </div>
      </div>
    </div>
    <!--  已被其他人购买弹窗  -->
    <div v-show="buyedVisible" class="quit-mark" @click="buyedVisible=false">
      <div class="quit-box" style="height:190px;">
        <div class="quit-title">
          消息提示
        </div>
        <div class="quit-con">
          {{ buyedData.content }}
        </div>
        <div class="quit-btn">
          <div class="retain" @click="goNewRoom(buyedData.new_room_id)">确认</div>
        </div>
      </div>
      <div class="quit-close">
        <i class="el-icon-circle-close" @click="buyedVisible=false"></i>
      </div>
    </div>
    <!--  图片预览  -->
    <el-dialog
      title=""
      :visible.sync="showViewer"
      width="50%">
      <img :src="imagesUrl" style="width:100%">
    </el-dialog>
    <!-- <el-image-viewer :z-index="2000" :initial-index="imageIndex" v-if="showViewer" :on-close="closeViewer"
        :url-list="images"/> -->
    <cropper ref="cropper" :returnUrl="getScreenShotUrls" style="z-index: 999999" @upload-img="uploadImg"></cropper>
    <!--  历史聊天记录  -->
    <el-dialog
      :visible.sync="historyDialog"
      custom-class="room_historyDialog"
      width="400px"
      :show-close="false"
      top="25vh"
      center>
      <div id="room_historyDialog">
        <div class="his_header">
          <div></div>
          <div>历史记录</div>
          <img src="@/assets/image/chat/close.png" alt="" @click="historyDialogClear">
        </div>
        <div class="his_title">
          <!-- <img src="@/assets/image/CustomerSer/WechatIMG.png"> -->
          <el-image class="icon" :src="roomInfo.room_type == 2||roomInfo.room_type == 3?require('@/assets/image/CustomerSer/qun.png'):roomInfo.headimg">
            <el-image slot="error" :src="roomInfo.room_type == 2||roomInfo.room_type == 3? require('@/assets/image/CustomerSer/qun.png'):require('@/assets/image/CustomerSer/WechatIMG.png')"></el-image>
          </el-image>
          <span>{{roomInfo.room_type == 2||roomInfo.room_type == 3?roomInfo.title:roomInfo.roommanager}}</span>
        </div>
        <el-input v-model="searchText" placeholder="输入关键词"
          @keydown.enter.native="handleGetHistory(1)">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <div class="hd_body">
          <div class="chatMain" ref="hd_Main" @scroll="scrollEvent">
            <div class="his_item" v-for="(item,index) in historyMsgList" :key="index">
              <div class="item_top user">
                <span class="user-name">{{item.nickname}}</span>
                <span class="time">{{formatDate(item.addtime)}}</span>
              </div>
              <!-- 文字显示 -->
              <div class="his_item_main" v-if="item.status == 1&&(item.contenttype==1||item.contenttype == 9)" style="white-space:pre-wrap" v-html="item.content">
              </div>
              <div class="his_item_main send_link_item" v-if="item.status == 1&&(item.contenttype == 8||item.contenttype == 5)">
                <div v-html="item.content"></div>
              </div>
              <!-- 合并消息 -->
              <div class="merge-msg" v-if="item.contenttype==10" @click="mergeMsg(item.content)">
                <div class="merge-msg-title">{{ item.content.content }}的聊天记录</div>
                <div class="merge-msg-list">
                  <div class="merge-msg-item" v-for="(mergrMsg,index) in item.content.msglist" :key="mergrMsg.id">
                    <div v-if="index<=3">
                      {{ mergrMsg.nickname }}:
                      <span style="white-space:pre-wrap">
                        {{ mergrMsg.contenttype == 1 ? mergrMsg.content : mergrMsg.contenttype == 10 ? '[聊天记录]' : mergrMsg.contenttype == 3 || mergrMsg.contenttype == 4 ? '[图片]' : mergrMsg.contenttype == 6 ? '[文件]' : mergrMsg.contenttype == 5 ? '[链接]' : mergrMsg.contenttype == 8 ? '[订单消息]' : '' }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="merge-msg-bottom">聊天记录</div>
              </div>
              <div class="his_item_main" v-if="item.status == 2">
                {{isMe(item.userid)?`我撤回了一条消息`:`${item.nickname}撤回了一条消息`}}
              </div>
              <!-- 文件显示 -->
              <div class="his_item_main file_wrapper" @click="downLoad(item)" v-if="item.contenttype == 6&&item.status == 1">
                <img class="msgFileIcon" src="@/assets/image/CustomerSer/file_img.png">
                <div class="msgFileInfo">
                  <div class="msgFileName">{{ item.content.filename }}</div>
                </div>
              </div>
              <!-- 图片显示 -->
              <div
                class="his_item_main"
                :class="item.contenttype == 4||item.contenttype == 3 ? 'imgMessage' : ''"
                v-if="(item.contenttype == 4||item.contenttype == 3)&&item.status == 1">
                <div class="msgFileInfo">
                  <el-image :src="item.content.thumbnail" :lazy="true" @click="onImagePreview(item.content.url)">
                    <el-image slot="placeholder" :src="require('@/assets/image/chat/loading.gif')"></el-image>
                  </el-image>
                </div>
              </div>
            </div>
            <!-- 滑动到底部加载中动画 -->
            <div class="loading" v-loading="loading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(246, 246, 246, 0.6)"
            ></div>
            <p v-if="noHistory" class="no_history">
              <img src="@/assets/image/CustomerSer/noHistory.png">
            </p>
            <p v-if="noMore" class="noMoreHistory">没有更多记录了～</p>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="payOrRefund == 1?'付款详情':payOrRefund == 2?'收款详情':'退款详情'"
      :visible.sync="dialogPayRefundVisible"
      custom-class="dia_pay_refund"
      center
      width="270px">
      <div class="pay_refund_item">
        <div v-if="payOrRefund==1||payOrRefund==2">成功{{payOrRefund==1?'付':'放'}}款次数：<span>{{payRefundData.num}}</span></div>
        <div>成功{{payOrRefund==1?'付':payOrRefund==2?'收':'退'}}款金额：<span>{{payRefundData.total_actual_amount}}</span></div>
      </div>
      <div v-for="item in payRefundData.invoice_list" :key="item.id" class="pay_refund_item pay_refund_detail">
        <div>创建时间：<span>{{item.add_time}}</span></div>
        <div>{{payOrRefund==1?'付':payOrRefund==2?'放':'退'}}款编号：<span>{{item.inv_no}}</span></div>
        <div>{{payOrRefund==1?'付':payOrRefund==2?'放':'退'}}款状态：<span>{{item.inv_status_enum}}</span></div>
        <div>{{payOrRefund==1?'付':payOrRefund==2?'放':'退'}}款金额：<span>{{item.amount}}</span></div>
        <div v-if="item.inv_status_enum.indexOf('成功') != -1">实{{payOrRefund==1?'付':payOrRefund==2?'放':'退'}}金额：<span>{{item.actual_amount}}</span></div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="payVisible"
      :before-close="closePayVis"
      custom-class="dia_pay_refund"
      center
      width="332px">
      <div class="pay_qrcode_wrapper">
        <div class="pay_title">
          <img src="@/assets/image/chat/ali_pay.png" alt="">
          需支付金额
        </div>
        <div class="pay_price">￥{{qr_codeorder_amount}}</div>
        <div class="pay_qrcode" ref="par_qrcode"></div>
        <div class="pay_tip">
          打开手机 <span>支付宝</span> 扫一扫
          <img src="" alt="">
        </div>
        <div class="pay_bottom">
          <div class="pay_bottom_top">为确保资金安全，支付二维码会 <span>自动刷新</span></div>
          <div class="pay_bottom_bottom">支持余额、银行卡(储蓄卡和信用卡)、花呗、花呗分期</div>
        </div>
      </div>
    </el-dialog>
    <!--  合并聊天记录  -->
    <el-dialog
      :visible.sync="mergeDialog"
      custom-class="room-merge-dialog"
      width="620px"
      :show-close="false"
      top="25vh"
      center>
      <div id="room-merge-ialog">
        <div class="his_header">
          <div></div>
          <div>{{ mergeMsgList.content }}的聊天记录</div>
          <img src="@/assets/image/chat/close.png" alt="" @click="mergeDialogClear">
        </div>
        <div class="hd_body">
          <div class="chatMain">
            <div class="his_item" v-for="(item,index) in mergeMsgList.msglist" :key="index">
              <div class="mergeImg">
                <el-image :src="item.headimg">
                  <el-image slot="error" :src="item.msgtype == 1||item.msgtype == 3||item.msgtype == 5||item.msgtype == 6||item.msgtype == 8||item.msgtype == 9||item.msgtype == 14||item.msgtype == 22?require('@/assets/image/CustomerSer/WechatIMG.png'):require('@/assets/image/chat/active.png')"></el-image>
                </el-image>
              </div>
              <div class="mergeMain">
                <div class="item_top user">
                  <span class="user-name">{{item.nickname}}</span>
                  <span class="time">{{item.chataddtime}}</span>
                </div>
                <!-- 文字显示 -->
                <div class="his_item_main" v-if="item.contenttype==1||item.contenttype == 9" style="white-space:pre-wrap" v-html="item.content">
                </div>
                <!-- 合并消息 -->
                <div class="merge-msg" v-if="item.contenttype==10" @click="mergeMsg(item.content)">
                  <div class="merge-msg-title">{{ item.content.content }}的聊天记录</div>
                  <div class="merge-msg-list">
                    <div class="merge-msg-item" v-for="(mergrMsg,index) in item.content.msglist" :key="mergrMsg.id">
                      <div v-if="index<=3">
                        {{ mergrMsg.nickname }}:
                        <span style="white-space:pre-wrap">
                          {{ mergrMsg.contenttype == 1 ? mergrMsg.content : mergrMsg.contenttype == 10 ? '[聊天记录]' : mergrMsg.contenttype == 3 || mergrMsg.contenttype == 4 ? '[图片]' : mergrMsg.contenttype == 6 ? '[文件]' : mergrMsg.contenttype == 5 ? '[链接]' : mergrMsg.contenttype == 8 ? '[订单消息]' : '' }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="merge-msg-bottom">聊天记录</div>
                </div>
                <div class="text-box send-link-box" v-if="item.contenttype == 8||item.contenttype == 5" :style="item.contenttype == 8?'flex-direction: column;':''">
                    <div :style="{width: item.contenttype == 8?'300px':''}" v-html="item.content"></div>
                    <!-- <div class="wait-pay" v-if="item.contenttype == 8&&item.order_status&&item.buy_user_id==item.user_id">
                      <el-button size="mini" :disabled="item.order_status != 1" @click="closeOrPay(item,2)">取消支付</el-button>
                      <el-button size="mini" :disabled="item.order_status != 1" v-if="item.pay_type==1" type="primary" @click="closeOrPay(item,1)">已支付</el-button>
                      <el-button size="mini" :disabled="item.order_status != 1" v-if="item.pay_type==2" type="primary" @click="closeOrPay(item,1)">前往支付</el-button>
                    </div> -->
                  </div>
                <!-- 文件显示 -->
                <div class="his_item_main" @click="downLoad(item)" v-if="item.contenttype == 6">
                  <div v-if="!item.video" class="file_wrapper">
                    <img class="msgFileIcon" src="@/assets/image/CustomerSer/file_img.png">
                    <div class="msgFileInfo">
                      <div class="msgFileName">{{ item.content.filename }}</div>
                    </div>
                  </div>
                  <div v-else>
                    <video :src="item.content.url" @contextmenu.prevent.stop="(event)=>{msgRight(item,event)}" controls="controls" style="width: 250px;height: 150px;"></video>
                  </div>
                </div>
                <!-- 图片显示 -->
                <div
                  class="his_item_main"
                  :class="item.contenttype == 4||item.contenttype == 3 ? 'imgMessage' : ''"
                  v-if="item.contenttype == 4||item.contenttype == 3">
                  <div class="msgFileInfo">
                    <el-image :src="item.content.thumbnail" :lazy="true" @click="onMergeImagePreview(item.content.url)">
                      <el-image slot="placeholder" :src="require('@/assets/image/chat/loading.gif')"></el-image>
                    </el-image>
                  </div>
                </div>
              </div>
            </div>
            <p class="noMoreHistory">没有更多了～</p>
          </div>
        </div>
      </div>
    </el-dialog>
    <!--  转发  -->
    <el-dialog
      :visible.sync="forwardDialog"
      custom-class="room_forwardDialog"
      width="540px"
      :show-close="false"
      top="15vh"
      center>
      <div id="room_forwardDialog">
        <div class="forward-left">
          <div class="forward-top">
            <el-input clearable v-model="searchForword" placeholder="输入关键词"
              @blur="soonChatShow = false"
              @clear="forwordFilter"
              @input="forwordFilter">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <div class="forword-soon">{{soonChatShow?'搜索结果':'最近聊天'}}</div>
          <div class="forword-list">
            <el-checkbox-group v-model="forwardCheckList" class="forword_checkbox" v-if="!soonChatImgShow">
              <el-checkbox :label="item.id" v-for="item in forwardList" :key="item.id">
                <!-- <img :src="require('@/assets/image/CustomerSer/qun.png')" width="20px" alt=""> -->
                <el-image class="icon" :src="item.type == 1?item.headimg:''" :class="item.sessionstatus==0?'line-leave':item.sessionstatus==2? 'line-busy' :''">
                  <el-image slot="error" :src="item.type == 1 ? require('@/assets/image/CustomerSer/WechatIMG.png'):require('@/assets/image/CustomerSer/qun.png')"></el-image>
                </el-image>
                <em>{{item.title}}</em>
                <span v-if="item.type == 3||item.type == 2">{{item.type == 3||item.type == 2 ? '群聊' : ''}}</span>
              </el-checkbox>
            </el-checkbox-group>
            <div v-else class="no-data-img">
              <img :src="require('@/assets/image/chat/forword_no.png')">
            </div>
          </div>
        </div>
        <div class="forword-right">
          <div class="right-send">发送给</div>
          <div class="right-list">
            <div class="right-list-item" v-for="item in forwardSendList" :key="item.id">
              <div>
                <el-image class="icon" :src="item.type == 1?item.headimg:''">
                  <el-image slot="error" :src="item.type == 1 ? require('@/assets/image/CustomerSer/WechatIMG.png'):require('@/assets/image/CustomerSer/qun.png')"></el-image>
                </el-image>
                <em>{{item.title}}</em>
                <span v-if="item.type == 3||item.type == 2">{{item.type == 3||item.type == 2 ? '群聊' : ''}}</span>
              </div>
              <i class="el-icon-error" @click="cancelSend(item.id)"></i>
            </div>
          </div>
          <div class="right-btn">
            <button @click="cancelSendBtn">取消</button>
            <!-- <button>发送</button> -->
            <el-button :loading="forwardSendLoad" @click="forwardSend" type="primary">发送</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-image-viewer
      style="z-index:9999"
      v-if="showImageViewer"
      :initial-index="imageIndex"
      :on-close="closeImageViewer"
      :url-list="imgList"
    />
    <el-image-viewer
      style="z-index:9999"
      v-if="showMergeImageViewer"
      :initial-index="mergeimageIndex"
      :on-close="closeMergeImageViewer"
      :url-list="mergeImg"
    />
  </div>
</template>

<script>
import chatRoom from "../../request/chat/chatRoom";
import pinyin from 'js-pinyin'
import MyTextarea from "./components/myTextarea";
import TradingInformation from "./components/tradingInformation";
import cropper from "@/components/cropper";
import sounds from '@/assets/tone.mp3';
import emoji from "./components/emoji";
import copyImg from "./copyImg";
import Announcement from "./components/announcement";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import evn from "./../../util/evn";
import {Decrypt} from '@/request/customer/util.js'
import chatApi from '@/request/customer/customerRoom'
import * as RongIMLib from '@rongcloud/imlib-next'
import { imInit } from '@/util/im'
import {removeUrlProtocol} from '@/util/strReplace'
import {
  createRoomByCode,
  createRoomByCustomercare,
  getRoomMembersApi,
  evaluationApi,
  checkEvaluationApi,
  transferRoomApi,
  silenceMemberApi,
  getGroupInfoApi,
  disbandGroupApi,
  quitRoomApi,
  inviteMemberApi,
  markGroupApi,
  shieldGroupApi,
  searchCustomerApi,
  searchGroupApi,
  searchChatHistoryApi,
  getGlobalConfigApi,
  getServiceListApi,
} from '@/request/im'
import moment from 'moment/moment'
import myaudio from '@/components/audio'
import countDown from "@/components/countDown"; //引入倒计时组件
import {
  apiGameList,
  apiRoomextInfo,
  apiProductInfo,
  apiChatProductAdd,
  apiChatOrderList,
  apiChatProductConsult,
  apiChatOrderPaidNotice,
  apiChatOrderRefundPay,
  apiChatOrdercancelstore,
  apiInvoiceList,
  apiEquipInfo,
  apiOrderDetail,
  apiPayPc,
  apiPayPcQuery,
  apiChatOrderPaymenty,
  getComplainsetting,
  apiOrderList,
  apiGetroomdetailbyroomid,
  apiProductBuyCheck,
  apiPaySwitch,
  apiPaydetail} from "@/request/API"
import QRCode from 'qrcodejs2';

String.prototype.replaceAll = function(s1,s2){
return this.replace(new RegExp(s1,"gm"),s2);
}
let prevOverflow = ''
export default {
  name: 'chatRoom',
  components: {Announcement, emoji, MyTextarea, cropper,ElImageViewer, TradingInformation,myaudio,countDown},
  data() {
    return {
      payVisible: false,
      payOrRefund: '',
      // 付款详情
      dialogPayRefundVisible: false,
      payRefundData: {},
      textareaImgApi: chatApi.uploaddata,
      textareaEncryptApi: chatApi.encryptMsg,
      // 融云历史消息分页时间戳
      rcHistoryTimestamp: 0,
      rcEvaluationMsg: null,
      // 融云消息监听已注册标记
      rcListenersRegistered: false,
      aiteBtnLoad: false,
      // @用户列表
      aite_data: [],
      // @userid列表
      userReset: [],
      soonChatShow: false,
      soonChatImgShow: false,
      // 转发搜索关键字
      searchForword: '',
      forwardSendLoad: false,
      // 选中转发接收名单列表
      forwardCheckList: [],
      // 转发最近聊天、搜索列表
      forwardList: [],
      // 转发接收列表
      forwardSendList: [],
      // 转发内容
      forwardItem: {},
      // 转发弹窗
      forwardDialog: false,
      imgUrl: '',
      showImageViewer: false,
      showMergeImageViewer: false,
      // 关闭会话
      closeRoomDia: false,
      // 取消支付提示框
      cancelPayDia: false,
      // 取消退款提示框
      cancelRefundDia: false,
      // 确认退款提示框
      confirmRefunDia: false,
      // 确认收款提示框
      confirmPaymentDia: false,
      searchText: '',
      historyDialog: false,
      btnGroup: [
        // {label: '评价客服', click: this.markScore, icon: require('@/assets/image/CustomerSer/starIcon.png')},
        {label: '咨询包赔', click: this.globalconfigZX},
        {label: '业务介绍', click: this.globalconfigYW},
        {label: '售后服务', click: this.globalconfigSH},
      ],
      score: 4,
      sound: sounds,
      //图片预览
      showViewer: false,
      imagesUrl: '',
      imageIndex: 0,
      mergeimageIndex: 0,
      //是否禁言状态
      isMute: true,
      //交易信息切换
      activeName: 'first',
      //是否关闭了聊天室，用于关闭聊天室后进入新聊天室
      isCloseRoom: false,
      //踢出群聊弹出框，
      kickOutVisible: false,
      interval: null,
      //退出聊天室弹出框
      quitVisible: false,
      roomList: [],
      toproomList: [],
      topShow: false,
      tableData: [],
      roomId: '',
      roomInfo: {},
      //房间在线人数
      onLineNum: '',
      message: '',
      identity: '',
      images: [],
      messageList: [],
      // 客服列表
      members: [],
      // 用户列表
      userLists: [],
      oldId: '',
      //是否滚动到最下面
      isScrollBottom: true,
      //是否有历史记录
      isOldMsg: true,
      //是否在查询历史记录
      isGetOldMsg: false,
      //上传的文件集合
      uploadFiles: [],
      //是否展开成员列表
      expansionMember: true,
      //是否展开联系人
      expansionContact: false,
      //是否展开群
      expansionGroup: false,
      //是否展开聊天记录
      expansionChatRecord: false,
      // 头像右键菜单是否显示
      headImgVisible: false,
      // 头像右键菜单显示位置
      headImgTop: 0,
      headImgLeft: 0,
      //房间列表右键菜单是否显示
      menuVisible: false,
      //房间列表右键菜单显示位置
      menuTop: 0,
      menuLeft: 0,
      //房间列表右键的房间信息
      roomRow: {},
      // 头像右键
      headImgRow: {},
      //消息右键
      msgRightVisible: false,
      //消息右键菜单显示位置
      msgTop: 0,
      msgLeft: 0,
      //右键的消息
      msgRow: {},
      search: '',
      //是否在搜索
      isSearch: false,
      //搜索结果
      searchRes: {
        contact: [],
        contactTotal: 0,
        groupChat: [],
        groupChatTotal: 0,
        chatRecord: [],
        chatRecordTotal: 0,
      },
      //查看@消息按钮
      checkAiteMsg: false,
      //查看新消息按钮
      checkNewMsg: false,
      memberScrollLeft: 0,
      mp3: null,
      noHistory: false,
       // 历史消息没有更多
      noMore: false,
      loading: false,
      historymore: true,
      // 聊天记录分页
      page: 1,
      pagesize: 30,
      // 历史聊天记录分页
      historyPage: 1,
      historyPagesize: 40,
      historyDialogTimestamp: 0,
      // 房间成员
      roomMember: [],
      // 初始房间成员
      oldRoomMember: [],
      appid: chatApi.appid,
      // 上传接口加密msg
      dataMsg:{
        msg:chatApi.encryptMsg({
          format: 'json',
          type: 3
        })
      },
      historyMsgList: [],
      closeRoomInfo: {},
      quitqunVisible: false,
      unreadList: [],
      // 交易信息
      medium: {},
      //评价客服元素
      scoreShow: false,
      // 评价id
      evid: '',
      evid_roomid:'',
      roomidList: [],
      grouptitle: '',
      game_name: '',
      customercareid: '',
      game_id: '',
      shopid: '',
      shopInfo: {
        game_id: '',
        image: '',
        id: '',
        name: '',
        price: 0,
        product_type: 1
      },
      shopInfoSend: {
        game_id: '',
        image: '',
        id: '',
        name: '',
        price: 0,
        product_type: 1
      },
      orderInfo: [],
      // 取消退款订单信息
      closeOrPayData: {
        order_no: '',
        payType: ''
      },
      // 退款信息
      refundInfo: {
        order_id: '',
        name: '',
        method: '',
        account: '',
        // buy_user_id: ''
      },
      // 收款信息
      paymentInfo: {
        order_id: '',
        name: '',
        method: '',
        account: '',
        // buy_user_id: ''
      },
      // 是否显示退款表单
      refundShow: false,
      // 是否显示收款表单
      paymentShow: false,
      shopInfoShow: false,
      initial_tableData: [],
      activeTradeCuse: 'first',
      activeSetting: 'first',
      userIdList: [],
      imgList: [],
      mergeImg: [],
      // 加入房间时间
      joinTime: '',
      ysdgcode: '',
      product_type: 1,
      qr_codeorder_amount: 0,
      timer: '',
      wxQrcodeData: {
        qrcode: '',
        wechat_float_notes: ''
      },
      wxQrcodeShow: false,
      errorSendTime: '',
      jinyong: false,
      // 禁用转接客服id
      transferClosed: '',
      // 禁用客服文案
      transferText: '',
      closedList: [],
      complaint:{
        complaint_phone_time: ''
      },//投诉建议,
      transferTime: '',
      // 合同消息弹窗
      mergeDialog: false,
      // 合并消息列表
      mergeMsgList: {},
      website: '',
      websiteUrl: process.env.VUE_APP_WEBSITE || '',
      websiteText: removeUrlProtocol(process.env.VUE_APP_WEBSITE || ''),
      roomGameDetail: {},
      roomGameDetailShow: false,
      buyedVisible: false,
      buyedData: {
        content: '',
        new_room_id: ''
      },
      bs_members: [],
      cusPhone: '',
      refundCountdown: false,
      refundEndTime: '',
      refundStartTime: ''
    }
  },
  filters: {
    mesTime(value, formatDate) {
      let myDate = new Date().getTime()
      let newDay = formatDate(myDate, 'YYYY-MM-DD')
      let msgDay = formatDate(value, 'YYYY-MM-DD')
      let newYear = formatDate(myDate, 'YYYY')
      let msgYear = formatDate(value, 'YYYY')
      if (newDay === msgDay) {
        //判断是否是今天 返回时间
        return formatDate(value, 'HH:mm')
      } else if (newYear === msgYear) {
        //判断是否是今年 返回月-日
        return formatDate(value, 'MM-DD')
      } else {
        //返回年月日
        return msgDay
      }
    },
    chatMesTime(value, formatDate) {
      let myDate = new Date().getTime()
      let newDay = formatDate(myDate, 'YYYY-MM-DD')
      let msgDay = formatDate(value, 'YYYY-MM-DD')
      let newYear = formatDate(myDate, 'YYYY')
      let msgYear = formatDate(value, 'YYYY')
      if (newDay === msgDay) {
        //判断是否是今天 返回时间
        return formatDate(value, 'HH:mm')
      } else if (newYear === msgYear) {
        //判断是否是今年 返回月-日
        return formatDate(value, 'MM-DD HH:mm')
      } else {
        //返回年月日
        return formatDate(value, 'YYYY-MM-DD HH:mm')
      }
    },
  },
  async created() {
    try{
      await this.getComplainsetting().then(res=>{
        if (res.data && !Array.isArray(res.data)) {
         this.complaint = res.data
         const phone = res.data.complaint_phone.split(',')
         this.$set(this.complaint, 'complaint_phoneA', phone[0] || '')
         this.$set(this.complaint, 'complaint_phoneB', phone[1] || '')
       }
      })
    }catch{}
    this.customercareid = this.$route.query?.id
    this.grouptitle = this.$route.query?.code
    this.game_id = this.$route.query?.game_id
    this.shopid = this.$route.query?.shopid
    this.initRCIM()
    this.roomId = this.$route.query?.room_id
    if(this.roomId){
      let r = {}
      r.id = this.roomId
      this.intoRoom(r)
    }
    this.ysdgcode = this.$route.query?.ysdgcode
    this.product_type = this.$route.query?.product_type
    if(this.shopid&&this.game_id){
      if(this.product_type == 1){
        apiProductInfo({
          game_id: this.game_id,
          id: this.shopid,
        }).then(res => {
          this.shopInfo = {...res.data}
          this.shopInfoSend = {...res.data}
          this.shopInfoShow = true
        })
      }else if(this.product_type == 2){
        apiEquipInfo({
          id: this.shopid
        }).then(res => {
          this.shopInfo = {...res.data}
          this.shopInfo.price = res.data.sell_price
          this.shopInfoSend = {...res.data}
          this.shopInfoSend.price = res.data.sell_price
          this.shopInfoShow = true
        })
      }
    }
  },
  mounted() {
    // 更新用户信息至融云后端
    import('@/request/im').then(({ updateUserInfo }) => {
      updateUserInfo({
        nickname: this.$store.state.userData.nickname,
        portrait: this.$store.state.userData.touxiang || 'https://images.pxb7.com/images/upload/avatar/20221009/1665300146651430.png',
      }).catch(() => {})
    })

    this.handleGetRoomList()
    document.getElementById('room-content').addEventListener('contextmenu', (e) => {
      e.preventDefault()
    })
    this.$WS.on('room_ext', (e) => {
      if(e.data.room_id == this.roomId){
        // if(e.data.id){
          this.medium = e.data.medium
          this.medium.type = e.data.type
          this.roomInfo.announcement = e.data.alternate.room_mark
          this.roomInfo.alternatetitle = e.data.alternate.room_name
        // }else{
        //   this.medium = e.data
        //   this.roomInfo.announcement = e.data.room_mark
        //   this.roomInfo.alternatetitle = e.data.room_name
        // }
      }
    })
    this.$WS.on('refresh_order', (e) => {
      this.getOrderData()
    })
    // this.$WS.on('pc_alipay_success', (e) => {
    //   clearInterval(this.timer)
    //   this.payVisible = false
    //   let room_pay ={}
    //   room_pay.id = this.roomId
    //   this.intoRoom(room_pay)
    //   // this.getOrderData()
    //   // this.handleGetOldMessage()
    // })
    this.$WS.on('online_pay_status_in_room', (e) => {
      this.buyedData = {
        content: '',
        new_room_id: ''
      }
      this.buyedData = e.data
      this.buyedVisible = true
    })
    this.$WS.on('online_pay_order_status', (e) => {
      if(e.data.room_id == this.roomId){
        apiGetroomdetailbyroomid({
          room_id: e.data.room_id,
          client: 'front'
        }).then(rre => {
          this.roomGameDetail = rre.data
          this.roomGameDetailShow = true
          if(this.roomGameDetail.orderStatus){
            this.members = this.bs_members
          }
        }).catch()
      }
      this.getRoomOrderStatus()
    })
    this.$WS.on('online_pay_product_status', (e) => {
      if(e.data.room_id == this.roomId){
        apiGetroomdetailbyroomid({
          room_id: e.data.room_id,
          client: 'front'
        }).then(rre => {
          this.roomGameDetail = rre.data
          this.roomGameDetailShow = true
          if(this.roomGameDetail.orderStatus){
            this.members = this.bs_members
          }
        }).catch()
      }
      this.getRoomOrderStatus()
    })
    // document.getElementById('myTextarea').addEventListener(
    //   "paste",
    //   (evt) => {
    //     if (
    //       evt.clipboardData &&
    //       evt.clipboardData.files &&
    //       evt.clipboardData.files.length
    //     ) {
    //       evt.preventDefault();
    //       [].forEach.call(evt.clipboardData.files, (file) => {
    //         if (!file.type.match(/^image\/(gif|jpe?g|a?png)/i)) {
    //           return;
    //         }
    //         this.uploadImg(file)
    //       });
    //     }
    //   },
    //   false
    // );

    // // 监听页面更新
    // let _this = this
    // let hiddenProperty = 'hidden' in document ? 'hidden' :
    // 'webkitHidden' in document ? 'webkitHidden' :
    // 'mozHidden' in document ? 'mozHidden' :
    // null;
    // let visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
    // let onVisibilityChange = function(){
    //   if (!document[hiddenProperty]) {
    //     _this.handleGetRoomList()
    //   }
    // }
    // document.addEventListener(visibilityChangeEvent, onVisibilityChange);
    // console.log(Decrypt('H54GcKFALTsVG2FKun+8jEWENnmtdZFspl0i6CvlnhB1lh/7xIsU10ritXCxcgkc'));
  },
  watch: {
    'forwardCheckList'(val){
      let arr = []
      for (const key in val) {
        arr.push(this.tableData.find(item => item.id == val[key]))
      }
      this.forwardSendList = arr
    }
  },
  destroyed () {
    clearTimeout(this.errorSendTime)
    RongIMLib.removeEventListener(RongIMLib.Events.MESSAGES, this.onRCMessages)
    RongIMLib.removeEventListener(RongIMLib.Events.CONNECTED, this.onRCConnected)
  },
  methods: {
    sendRemindFn(){
      const ReminderMsgClass = RongIMLib.registerMessageType('PX:ReminderMsg', true, false, ['content', 'type', 'target_id'], false)
      const target = { conversationType: RongIMLib.ConversationType.GROUP, targetId: this.roomId }
      RongIMLib.sendMessage(target, new ReminderMsgClass({ content: '催一催', type: 'remind', target_id: this.roomId }))
        .then(() => {})
        .catch(() => {
          this.$message.error(`您已催一催客服，请在10分钟以后再次点击!`)
        })
    },
    /**
     * @description: 催一催
     * @return {*}
     */
    sendRemindBtn() {
      let sendRemindData = localStorage.getItem('sendRemind'+this.roomId)
      if(sendRemindData){
        let sendReminded = JSON.parse(sendRemindData)
        if(this.isMe(sendReminded.senduserid)){
          let nowDate = new Date().getTime()
          nowDate-(1000*60*10)>=sendReminded.addtime
          ? this.sendRemindFn()
          : this.$message.error(`您已催一催客服，请在${Math.ceil((1000*60*10+sendReminded.addtime-nowDate)/1000/60)}分钟以后再次点击!`)
        }else{
          this.sendRemindFn()
        }
      }else{
        this.sendRemindFn()
      }
    },
    //屏蔽手机号
    regContent(item,type){
      let reg = /(\d{3})\d{4}(\d{4})/; //正则表达式
      let regPhone=/^(?:(?:\+|00)86)?1\d{10}$/
        if(!this.isMe(type==='list'?item.msguserid:item.userid) && regPhone.test(item.content)&&item.msgtype!=1){
          item.content=item.content.replace(reg, "$1****$2")
        }
      return item.content
    },
    /**
     * @description: 跳转商品详情
     * @param {*} game_id
     * @param {*} id
     * @return {*}
     */
    goGameDetail(game_id,id){
      let routeUrl = this.$router.resolve({
        name: 'GameDetails',
        query: {
          game_id: game_id,
          id: id,
          source_page: this.$route.path.slice(1)
        },
      });
      window.open(routeUrl.href, '_blank');
    },
    /**
     * @description: 已被其他买家购买，卖家跳转新房间
     * @return {*}
     */
    goNewRoom(room_id) {
      let r = {}
      r.id = room_id
      this.intoRoom(r)
    },
    /**
     * @description: 防骗指南
     * @return {*}
     */
    fpznBtn() {
      getGlobalConfigApi().then(res => {
        const automsg = res?.data?.automsg
        if (automsg && automsg[4]) {
          this.messageList.push({
            content: automsg[4],
            msgtype: 1,
            roomid: this.roomId,
            status: 1,
            nickname: '系统客服',
            headimg: require('@/assets/image/chat/system.png'),
            contenttype: 1
          })
          this.$nextTick(() => {
            this.scrollBottom()
          })
        }
      }).catch(() => {})
    },
    /**
     * @description: 立即购买
     * @return {*}
     */
    buyNow(game_id,id) {
      apiProductBuyCheck({
        game_id: game_id,
        id: id,
      }).then(res=>{
        let routeUrl = this.$router.resolve({
          name: 'OnlineDeal',
          query: {
            id: id,
            game_id: game_id
          }
        });
        window.open(routeUrl.href, '_blank');
        // this.$router.push({name:'OnlineDeal',query:{id:this.id,game_id:this.game_id}})
      })
    },
    /**
     * @description: 查看详情
     * @return {*}
     */
    sellDetail(game_id,id){
      let routeUrl = this.$router.resolve({
        name: 'SellerDetail',
        query: {
          id: id,
          game_id: game_id
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    /**
     * @description: 合并转发消息显示
     * @param {*} item
     * @return {*}
     */
    mergeMsg(item){
        item.msglist.forEach((items,index) => {
          if(typeof items == 'string'){
            item.msglist[index] = JSON.parse(items)
          }
          if(items.contenttype == 10){
            items.content.msglist.forEach((v,i) => {
              if(typeof v == 'string'){
                items.content.msglist[i] = JSON.parse(v)
              }
            })
          } else if (items.contenttype == 4||items.contenttype == 3) {
            let content = items.content
            const image = new Image()
            image.src = content.url
            image.onload = function() {
              content.width = content.width?content.width:image.width
              content.height = content.height?content.height:image.height

                items.content = content
              if (items.content.width > items.content.height && items.content.width > 200) {
                items.content.w = items.content.width
                items.content.h = items.content.height
                //图片宽比高长并且宽超过200px
                items.content.height = items.content.height / (items.content.width / 183)
                items.content.width = 183
              } else if (items.content.height > 200) {
                items.content.w = items.content.width
                items.content.h = items.content.height
                //图片高比宽长并且宽超过200px
                items.content.width = items.content.width / (items.content.height / 200)
                items.content.height = 200
              }
              if (items.content.url.indexOf('https://images-kefu.pxb7.com') !== -1) {
                //缩略图?x-oss-process=image/resize,m_lfit,h_100,w_100
                items.content.thumbnail = `${items.content.url}?x-oss-process=image/resize,m_lfit,h_${Math.round(items.content.height)},w_${Math.round(items.content.width)}`
                // items.content.thumbnail = `${items.content.url}?width=${Math.round(items.content.width)}&height=${Math.round(items.content.height)}`
              } else {
                //缩略图
                items.content.thumbnail = `${items.content.url}`
              }
            }
            items.content = content
            if (items.content.width > items.content.height && items.content.width > 200) {
              //图片宽比高长并且宽超过200px
              items.content.height = items.content.height / (items.content.width / 183)
              items.content.width = 183
            } else if (items.content.height > 200) {
              //图片高比宽长并且宽超过200px
              items.content.width = items.content.width / (items.content.height / 200)
              items.content.height = 200
            }
            if (items.content.url.indexOf('https://images-kefu.pxb7.com') !== -1) {
              //缩略图
              items.content.thumbnail = `${items.content.url}?x-oss-process=image/resize,m_lfit,h_${Math.round(items.content.height)},w_${Math.round(items.content.width)}`
            } else {
              //缩略图
              items.content.thumbnail = `${items.content.url}`
            }
            this.mergeImg.push(items.content.url)
          } else if(items.contenttype == 6){
            if(items.content.filetype == 'video/mp4'){
              items.video = true
            }else {
              items.video = false
            }
          } else if(items.contenttype == 9) {
            items.content = items.content.content
          }
          //  else if(items.contenttype == 8) {
          //   let con = JSON.parse(items.content)
          //   if(con.content.indexOf('div')!=-1){
          //     let patt = /onclick=['"]([^""]+)['"]+/g
          //     let patts = /openExternal['(]([^""]+)[')]+/g
          //     if(patts.exec(items.content)){
          //     let linka = patts.exec(con.content)[1]
          //     let sp = con.content.split(patt.exec(con.content)[0])
          //     con.content = sp[0]+`onclick="window.open(${linka},'_blank')"`+sp[1]
          //     items.content = con.content
          //     }

          //     let input = items.content.match(/<input.*?>/gi)[0]
          //     let pay_type_input = items.content.match(/<input.*?>/gi)[1]
          //     let order = {}
          //     let key = input.replace(/.*id="(.+?)".*/, "$1")
          //     order[key] = input.replace(/.*value="(.+?)".*/, "$1")
          //     let payType = pay_type_input.replace(/.*value="(.+?)".*/, "$1")
          //     // 1 线下 2 在线
          //     items.pay_type = payType
          //     apiOrderDetail({client:'front',order_id:order[key]}).then(res=> {
          //       this.$set(items,'order_status',res.data.order_status)
          //       this.$set(items,'order_no',res.data.order_no)
          //       this.$set(items,'order_id',res.data.id)
          //       this.$set(items,'order_amount',res.data.order_amount)
          //       this.$set(items,'buy_user_id',res.data.buy_user_id)
          //       this.$set(items,'user_id',this.$store.state.userData.user_id)
          //     })
          //   }else{
          //     items.content = con.content
          //     if(items.content.match(/<input.*?>/gi)){
          //       let input = items.content.match(/<input.*?>/gi)[0]
          //       let user = {}
          //       let key = input.replace(/.*id="(.+?)".*/, "$1")
          //       user[key] = input.replace(/.*value="(.+?)".*/, "$1")
          //       if(user[key] == this.$store.state.userData.user_id){
          //         //处理文本上的链接
          //         // let reg = /((http|https):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|])/g;
          //         // let urls = k.content.match(reg)
          //         // if(urls){
          //         //   let sp = k.content.split(urls[0])
          //         //   k.content = sp[0]+`<a href="${urls}"style="text-decoration: underline; color: var(--primary, #FF5A1F);" target="_blank">${urls}</a>`+sp[1]
          //         // }
          //       }
          //     }else{
          //       let reg = /((http|https):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|])/g;
          //       let urls = items.content.match(reg)
          //       if(urls){
          //         let sp = items.content.split(urls[0])
          //         items.content = sp[0]+`<a href="${urls}"style="text-decoration: underline; color: var(--primary, #FF5A1F);" target="_blank">${urls}</a>`+sp[1]
          //       }
          //     }
          //   }
          // } else if(items.contenttype == 5) {
          //   let patt = /onclick=['"]([^""]+)['"]+/g
          //   let patts = /openExternal['(]([^""]+)[')]+/g
          //   if(patts.exec(items.content)){
          //     let linka = patts.exec(items.content)[1]
          //     let sp = items.content.split(patt.exec(items.content)[0])
          //     items.content = sp[0]+`onclick="window.open(${linka},'_blank')"`+sp[1]
          //   }
          // }
        })
      this.mergeMsgList = item
      this.mergeDialog = true
    },

    errorSend() {
      this.wxQrcodeShow = true
      localStorage.setItem('errorTime'+this.roomId,new Date().getTime()+1000*60*60*24)
      this.errorSendTime = setTimeout(()=>{
        this.wxQrcodeShow = false
      }, 1000*60*60*24)
    },
    //获取投诉建议配置
    getComplainsetting(){
      return new Promise ((reject,resolve)=>{
        getComplainsetting().then(res => {
          reject(res)
        }).catch(e=>{
          resolve(e)
        })
      })
    },
    /**
     * @description: 点击'@'跳转
     * @param {*} id 消息id
     * @param {*} block
     * @return {*}
     */
    scrollIntoView(id, block = "center") {
      this.aiteBtnLoad = true
      Promise.resolve().then(() => {
        let msgid = document.getElementById(id)
        if (msgid) {
          msgid.scrollIntoView({
            behavior: "smooth",
            block: block,
          });
          this.aiteBtnLoad = false
          this.aite_data.splice(0,1)
          if(this.aite_data.length==0){
            this.checkAiteMsg = false
          }
        }else{
          this.page +=1
          this.handleGetOldMessage()
          setTimeout(() => {
            this.scrollIntoView(id)
          },500)
        }
      });
    },
    // 获取输入框@用户id
    getUserId(user) {
      this.userIdList = user
    },
    /**
     * @description: 转发搜索
     * @return {*}
     */
    forwordFilter() {
      if(this.searchForword == ''){
        this.soonChatImgShow = false
        this.forwardList = JSON.parse(JSON.stringify(this.tableData))
      }else{
        this.soonChatShow = true
        this.forwardList = JSON.parse(JSON.stringify(this.tableData)).filter(item => {
          if(item.title&&item.title.indexOf(this.searchForword)!=-1){
            return item
          }
        })
        if(this.forwardList.length==0){
          this.soonChatImgShow = true
        }else{
          this.soonChatImgShow = false
        }
      }
    },
    /**
     * @description: 转发发送按钮事件
     * @return {*}
     */
    forwardSend() {
      if(this.forwardCheckList.length==0){
        this.$message.error('请选择需要转发的聊天会话')
        return
      }
      let a = 0
      const total = this.forwardCheckList.length
      const done = () => {
        a++
        if (a === total) {
          this.forwardSendLoad = false
          this.forwardDialog = false
          this.searchForword = ''
          this.isScrollBottom = true
        }
      }
      for (const key in this.forwardCheckList) {
        const targetId = this.forwardCheckList[key]
        const target = { conversationType: RongIMLib.ConversationType.GROUP, targetId }
        const item = this.forwardItem
        let msg
        if (item.contenttype === 1 || item.contenttype === 9) {
          msg = new RongIMLib.TextMessage({ content: typeof item.content === 'string' ? item.content : (item.content?.content || '') })
        } else if (item.contenttype === 4 || item.contenttype === 3) {
          const url = item.content?.url || ''
          msg = new RongIMLib.ImageMessage({ content: url, imageUri: url })
        } else if (item.contenttype === 6) {
          msg = new RongIMLib.FileMessage({ name: item.content?.filename, size: item.content?.size, type: item.content?.filetype, fileUrl: item.content?.url })
        } else {
          done(); continue
        }
        RongIMLib.sendMessage(target, msg)
          .then(({ code, data: rcMsg }) => {
            if (code === 0 && rcMsg && targetId === this.roomId) {
              const value = this.adaptRCMessage(rcMsg)
              if (value) this.getIpList(value)
            }
            done()
          })
          .catch(() => done())
      }
    },
    /**
     * @description: 取消发送按钮点击事件
     * @return {*}
     */
    cancelSendBtn() {
      this.forwardDialog = false
      this.forwardItem = {}
      this.forwardCheckList = []
      this.searchForword = ''
    },
    /**
     * @description: 取消转发发送
     * @param {*} roomid
     * @return {*}
     */
    cancelSend(roomid) {
      this.forwardCheckList.splice(this.forwardCheckList.findIndex(i => i==roomid),1)
    },
    /**
     * @description: 转发
     * @return {*}
     */
    handleForward(item) {
      this.forwardItem = {}
      this.forwardCheckList = []
      this.forwardList = JSON.parse(JSON.stringify(this.tableData))
      this.forwardItem = JSON.parse(JSON.stringify(item))
      if(item.contenttype != 6&&item.contenttype != 4){
        //处理文本上的链接
        let con = this.forwardItem.content.replaceAll(/<a.*?>|<\/a>/g, '')
        this.forwardItem.content = con
      }
      this.forwardDialog = true
      this.soonChatImgShow = false
    },
    /**
     * @description: 复制图片/文字
     * @return {*}
     */
    handleCopy(item) {
      if(item.contenttype==4||item.contenttype==3){
        copyImg(item.content.url,() => {
          this.$message.success('复制成功')
        },item.content.w,item.content.h)
      }
      if(item.contenttype == 1||item.contenttype == 9){
        //处理文本上的链接
        let con = item.content.replaceAll(/<a.*?>|<\/a>/g, '')
        let input = document.createElement('input')
        input.setAttribute('readonly', 'readonly')
        input.setAttribute('value', con)
        document.body.appendChild(input)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
          this.$message.success('复制成功')
        }
        document.body.removeChild(input)
      }
    },
    /**
     * @description: 头像右键发起私聊
     * @return {*}
     */
    getPrivateChat(item) {
      createRoomByCustomercare({ customercare_id: item.userid })
        .then(() => {
          this.shopInfoShow = false
          this.refundShow = false
          this.paymentShow = false
          this.messageList = []
          this.userReset = []
          this.roomGameDetailShow = false
          this.roomGameDetail = {}
          this.buyedData = { content: '', new_room_id: '' }
        }).catch(() => {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: `<div>当前客服暂时不在</div>(工作时间：${this.complaint.complaint_phone_time})`,
            center: true,
            duration: 3000,
            offset: 300,
            customClass: 'customer-offline-msg'
          })
        })
    },
    //是否是客服
    isCutomer(id) {
      if(id){
        return id.length>11
      }
      return false
    },
    /**
     * @description: @
     * @return {*}
     */
    aiTeEvery(item) {
      this.userIdList.push(item.userid)
      // this.userReset.push(item.userid)
      this.message = this.message + `<span class="at-text">@${item.nickname}</span> `
    },
    // 点击查看图片
    onImagePreview(url) {
      // this.imgUrl = url;
      this.imageIndex = 0
      const srcIndex = this.imgList.indexOf(url)
      if (srcIndex >= 0) {
        this.imageIndex = srcIndex;
      }
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.showImageViewer = true;
    },
    closeImageViewer() {
      document.body.style.overflow = prevOverflow;
      this.showImageViewer = false;
    },
    // 点击查看图片
    onMergeImagePreview(url) {
      // this.imgUrl = url;
      this.mergeimageIndex = 0
      const srcIndex = this.mergeImg.indexOf(url)
      if (srcIndex >= 0) {
        this.mergeimageIndex = srcIndex;
      }
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.showMergeImageViewer = true;
    },
    closeMergeImageViewer() {
      document.body.style.overflow = prevOverflow;
      this.showMergeImageViewer = false;
    },
    /**
     * @description: 付款详情
     * @return {*}
     */
    payDetail(id,type) {
      apiInvoiceList({
        client: 'front',
        order_id: id,
        inv_type: type
      }).then(res => {
        this.payOrRefund = type
        this.payRefundData = res.data
        this.dialogPayRefundVisible = true
      })
    },
    /**
     * @description: 提交退款信息
     * @return {*}
     */
    handleRefund() {
      apiChatOrderRefundPay({
        client: 'front',
        ...this.refundInfo
      }).then(res => {
        this.refundShow = false
        this.$message.success('提交成功！')
      })
    },
    /**
     * @description: 提交收款信息
     * @return {*}
     */
    handlePayment() {
      apiChatOrderPaymenty({
        client: 'front',
        ...this.paymentInfo
      }).then(res => {
        this.paymentShow = false
        this.$message.success('提交成功！')
      })
    },
    /**
     * @description: 确定退款
     * @return {*}
     */
    saveRefund() {
      if(this.refundInfo.name==''){
        this.$message.error('请输入收款人！')
        return
      }
      if(this.refundInfo.method == ''){
        this.$message.error('请选择收款方式！')
        return
      }
      if(this.refundInfo.account == ''){
        this.$message.error('请输入收款账号！')
        return
      }
      this.confirmRefunDia = true
    },
    /**
     * @description: 确定收款
     * @return {*}
     */
    savePayment() {
      if(this.paymentInfo.name==''){
        this.$message.error('请输入收款人！')
        return
      }
      if(this.paymentInfo.method == ''){
        this.$message.error('请选择收款方式！')
        return
      }
      if(this.paymentInfo.account == ''){
        this.$message.error('请输入收款账号！')
        return
      }
      this.confirmPaymentDia = true
    },
    /**
     * @description: 取消退款
     * @return {*}
     */
    handleSaveRefund() {
      this.refundShow = false
      apiChatOrdercancelstore({
        method: 2,
        order_id: this.refundInfo.order_id,
        client: 'front'
      }).then(res=> {
        this.$message.success('取消成功')
      }).catch(() => {
        this.$message.error('退款信息提交失败，请联系客服！')
      })
    },
    /**
     * @description: 取消支付
     * @return {*}
     */
    handleClosePay() {
      apiChatOrderPaidNotice({
        client: 'front',
        room_id: this.roomId,
        order_no: this.closeOrPayData.order_no,
        type: 2
      }).then(res => {
        // this.getOrderData()
        this.messageList = []
        this.page = 1
        if(this.closeOrPayData.trade_type != 1){
          this.getOrderData()
          this.handleGetOldMessage()
        }else{
          this.handleGetOldMessage()
        }
        // this.handleSendText(`用户取消支付订单编号${this.closeOrPayData.order_no}`)
      })
    },
    closePayVis() {
      clearInterval(this.timer)
      this.timer = ''
      this.payVisible = false
    },
    countDowned() {
      this.closePayVis()
      this.handleGetOldMessage()
      this.scrollBottom()
    },
    /**
     * @description: 查询支付状态
     * @return {*}
     */
    getPayPcQuery(id) {
      let count = 0
      this.timer = setInterval(() => {
        count++
        apiPayPcQuery({id:index>=0?item.id:item.order_id}).then(res => {
          if(res.data.code == 200){
            clearInterval(this.timer)
            this.payVisible = false
            let room_pay ={}
            room_pay.id = this.roomId
            this.intoRoom(room_pay)
          }
        }).catch(err => {
          clearInterval(this.timer)
          this.payVisible = false
          this.$message.error(err.msg)
        })
        if(count>=450){
          clearInterval(this.timer)
        }
      },4000)
    },
    /**
     * @description: 用户点击取消支付，已支付
     * @param {*} order_no 订单编号
     * @param {*} val 1支付，2取消支付
     * @return {*}
     */
    closeOrPay(item,val,index){
      if(val == 2){
        this.closeOrPayData.order_no = item.order_no
        this.closeOrPayData.payType = 2
        this.closeOrPayData.trade_type = item.trade_type
        this.cancelPayDia = true

      }else{
        if(item.pay_type == 2){
          this.qr_codeorder_amount = item.order_amount
          if(this.$refs.par_qrcode) this.$refs.par_qrcode.innerHTML = ""
          let routeData = this.$router.resolve({
            name: 'MethodOfPayment',
            query: {
              type: 1,
              orderid: index>=0?item.id:item.order_id,
              id: index>=0?item.order_info[0]?.goods_id:item.product_id,
              gameid: item.game_id,
              amount: item.order_amount
            }
          })
          window.open(routeData.href, '_blank')
/*          apiPaySwitch({
            game_id: item.game_id,
            type: 1
          }).then(ress => {
            if(ress.data.is_lianlian_pay == 1){
              // this.getPayPcQuery(index>=0?item.id:item.order_id)
              let routeData = this.$router.resolve({
                name: 'MethodOfPayment',
                query: {
                  type: 1,
                  orderid: index>=0?item.id:item.order_id,
                  id: index>=0?item.order_info[0]?.goods_id:item.product_id,
                  gameid: item.game_id,
                  amount: item.order_amount
                }
              })
              window.open(routeData.href, '_blank')
            } else {
              this.payAli(index>=0?item.id:item.order_id,index>=0?item.order_info[0]?.goods_id:item.product_id,item.game_id)
              // this.payVisible = true
              // apiPayPc({id: index>=0?item.id:item.order_id}).then(res => {
              //   setTimeout(() => {
              //     new QRCode(this.$refs.par_qrcode, {
              //       text: res.data.qr_code,
              //       width: 200,
              //       height: 200,
              //       colorDark: "#333333", //二维码颜色
              //       colorLight: "#ffffff", //二维码背景色
              //       correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
              //     })
              //   },400)
              //   this.getPayPcQuery(index>=0?item.id:item.order_id)
              // }).catch(err => {
              //   this.payVisible = false
              //   this.$message.error(err.msg)
              // })
            }
          })*/
        }else{
          apiChatOrderPaidNotice({
            client: 'front',
            room_id: this.roomId,
            order_no: item.order_no,
            type: 1
          }).then(res => {
            // this.getOrderData()
            this.messageList = []
            this.page = 1
            if(index&&this.orderInfo[index].trade_type != 1){
              this.getOrderData()
              this.handleGetOldMessage()
            }else{
              this.handleGetOldMessage()
            }

            // this.$set(item,'order_status',2)
            // if(val == 2){
            //   this.handleSendText(`用户取消支付订单编号${order_no}`)
            // }else {
              // this.handleSendText(`用户已支付订单编号${item.order_no}`)
            // }
          })
        }
      }
    },
    /**
     * 生成订单跳转支付宝收银台
     * @param orderid 订单id
     */
     payAli(id,product_id,game_id){
      apiPaydetail({
        id: id,
        return_url:`${process.env.VUE_APP_WEBSITE}/payment?orderid=${id}&id=${product_id}&game_id=${game_id}`
      }).then(res=>{
        let ali_form = res.data.from_data
        let form_data = ali_form.substr(0,6) + "target='_blank' " + ali_form.substr(6,ali_form.length)
        const div = document.createElement("divform");
        div.innerHTML = form_data
        document.body.appendChild(div);
        document.forms[0].acceptCharset = "GBK"; // 保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
        document.forms[0].submit();
        div.remove();
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
    /**
     * @description: 咨询商品发送链接
     * @return {*}
     */
    ChatProductAdd(id) {
      apiChatProductAdd({
        client: 'front',
        room_id: this.roomId,
        game_id: id?this.shopInfo.game_id:this.shopInfoSend.game_id,
        product_id: id?id:this.shopid,
        product_type: this.product_type?this.product_type:1
      }).then(res => {
        id?'':this.shopInfoShow = false
        //发送链接
        // require('electron').shell.openExternal(`${process.env.VUE_APP_WEBSITE}/gamedetails?game_id=${this.shopInfo.game_id}&id=${this.shopInfo.id}`)
        // window.open(`${process.env.VUE_APP_WEBSITE}/gamedetails?game_id=${this.shopInfo.game_id}&id=${this.shopInfo.id}`,'_blank')
        // 发送商品链接（使用 PX:ProductMsg 融云自定义消息）
        const shopData = id ? this.shopInfo : this.shopInfoSend
        const productMsgContent = {
          product_id: shopData.id || this.shopid,
          title: shopData.name || shopData.title || '',
          img: shopData.image || '',
          price: shopData.price || '',
          game_id: shopData.game_id || this.game_id,
          product_type: this.product_type || 1,
          url: `${process.env.VUE_APP_WEBSITE}/${this.product_type==1?'gamedetails':'equipmentdetails'}?game_id=${shopData.game_id}&id=${shopData.id}`,
        }
        const RCProductMsg = RongIMLib.registerMessageType('PX:ProductMsg', true, true, ['product_id', 'title', 'img', 'price', 'game_id'])
        const target = { conversationType: RongIMLib.ConversationType.GROUP, targetId: this.roomId }
        RongIMLib.sendMessage(target, new RCProductMsg(productMsgContent))
          .then(({ code, data: rcMsg }) => {
            if (code !== 0) return
            const value = this.adaptRCMessage(rcMsg)
            if (value) this.getIpList(value)
          })
          .catch(() => {})
      })
    },
    /**
     * @description: 关闭聊天窗口发送账号链接
     * @return {*}
     */
    shopLinkClose() {
      this.shopInfoShow = false
    },
    /**
     * @description: 根据分组标识获取客服列表
     * @return {*}
     */
    getcustomercarelist() {
      if(this.grouptitle){
        getServiceListApi({ game_code: this.grouptitle })
          .then(res => {
            const customercarelist = res?.data || []
            for(let i = 0; i < customercarelist.length; i++){
              if(customercarelist[i].nickname == this.roomInfo.roommanager){
                this.score = customercarelist[i].score
                return
              }
            }
          })
          .catch(() => {})
      } else {
        this.gameData()
      }
    },
    gameData() {
      if(this.game_id){
        apiGameList({
          game_id:this.game_id
        }).then(res => {
          this.game_name = res.data[0].game_name
          this.grouptitle = res.data[0].game_alias
        })
      }
    },
    /**
     * @description: 创建房间
     * @return {*}
     */
    roomCreatCus() {
      if(this.game_id) {
        apiGameList({ game_id: this.game_id }).then(res => {
          this.game_name = res.data[0].game_name
          this.grouptitle = res.data[0].game_alias
          this.creatRoom()
        })
      } else if(this.ysdgcode) {
        this.creatRoom()
      } else {
        this.creatRoomPoint()
      }
    },
    // 通过客服组code创建会话（对应旧 creatRoom → chatApi.createConversation）
    creatRoom() {
      const groupCode = this.ysdgcode || this.grouptitle
      createRoomByCode({
        customercare_group_code: groupCode,
        is_must_online: false,
        type: Number(this.product_type) || 1,
        product_id: this.shopid ? Number(this.shopid) : undefined,
      }).then(res => {
        if (res && res.data) {
          const groupId = res.data.id || res.data.group_id
          this.roomId = groupId
          this.pointCRoom()
          this.getOrderData()
        }
      }).catch(() => {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: `<div>当前客服暂时不在</div>(工作时间：${this.complaint.complaint_phone_time})`,
          center: true,
          duration: 3000,
          offset: 300,
          customClass: 'customer-offline-msg'
        })
      })
    },
    // 通过指定客服ID创建会话（对应旧 creatRoomPoint → chatApi.createappoint）
    creatRoomPoint() {
      createRoomByCustomercare({
        customercare_id: this.customercareid,
      }).then(res => {
        if (res && res.data) {
          const groupId = res.data.id || res.data.group_id
          this.roomId = groupId
          this.shopInfoShow = false
          this.refundShow = false
          this.paymentShow = false
          this.messageList = []
          this.userReset = []
          this.roomGameDetailShow = false
          this.roomGameDetail = {}
          this.pointCRoom()
        }
      }).catch(() => {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: `<div>当前客服暂时不在</div>(工作时间：${this.complaint.complaint_phone_time})`,
          center: true,
          duration: 3000,
          offset: 300,
          customClass: 'customer-offline-msg'
        })
      })
    },
    countDownChange(countDown,index) {
      this.refundCountdown = false
      this.refundStartTime = ''
      this.refundEndTime = ''
    },
    /**
     * @description: 获取跟房间绑定得订单
     * @return {*}
     */
    getOrderData() {
      // 获取跟房间绑定订单列表
      apiChatOrderList({
        client: 'front',
        room_id: this.roomId,
        room_type: this.roomInfo.room_type
      }).then(res => {
        this.orderInfo = [...res.data]
        this.orderInfo.forEach(item => {
          item.countDown = false
          // item.add_time = Number(new Date(item.add_time).setMinutes(new Date(item.add_time).getMinutes()+29))/1000
          if(item.tmp_refund_id&&item.tmp_refund_id!=0){
            this.refundShow = true
            this.refundInfo.order_id = item.id
            this.refundInfo.buy_user_id = item.buy_user_id
            this.refundInfo.tmp_refund_id = item.tmp_refund_id
            // return
          }
          // if(item.tmp_payment_id&&item.tmp_payment_id!=0){
          //   this.paymentShow = true
          //   this.paymentInfo.order_id = item.id
          //   this.paymentInfo.sale_user_id = item.sale_user_id
          //   this.paymentInfo.tmp_payment_id = item.tmp_payment_id
          //   // return
          // }
          if(item.onlineRefund){
            this.refundCountdown = true
            this.refundStartTime = item.onlineRefund.create_time
            this.refundEndTime = item.onlineRefund.expire_time
          }
        })
      }).catch(() => {
        this.orderInfo = []
      })
      // 私聊房间正在咨询的商品
      apiChatProductConsult({
        client: 'front',
        room_id: this.roomId
      }).then(res => {
        if(res.data.toString().length>2){
        this.shopInfo = {...res.data}
        }
        // this.shopInfoShow = true
      })
    },
    /**
     * @description: 提交评价
     * @param {*} val 评价分数
     * @return {*}
     */
    rateChange(val) {
      if (this.rcEvaluationMsg) {
        RongIMLib.updateMessageExpansion({ score: String(val) }, this.rcEvaluationMsg)
          .then(({ code }) => {
            if (code === 0) {
              this.scoreShow = false
              this.$message.success('评价成功！')
            }
          })
          .catch(() => {})
      } else {
        this.scoreShow = false
        this.$message.success('评价成功！')
      }
    },
    /**
     * @description: 生成唯一标识
     * @return {*}
     */
    uuid() {
        let s = [];
        let hexDigits = "0123456789abcdef";
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";
        let uuid = s.join("");
        return uuid;
    },
    /**
     * @description: 上传截图
     * @param {*} file
     * @return {*}
     */
    uploadImg(file) {
      let blob_file = new File([file],this.uuid()+".png",{type:file.type,lastModified: Date.now()})
      let form = new FormData();
      form.append("file", blob_file);
      form.append("msg", this.dataMsg.msg);
      chatApi.uploaddata(form).then(resp => {
        let result = JSON.parse(Decrypt(resp.result))
        this.getScreenShotUrl(result.url,result)
      })
    },
    /**
     * @description: 群聊信息
     * @return {*}
     */
    roomextInfo() {
      apiRoomextInfo({
        room_id:this.roomId,
        client: 'front'
      }).then(res => {
        this.medium = res.data.medium
        this.medium.type = res.data.type
        this.roomInfo.announcement = res.data.alternate.room_mark
        this.roomInfo.alternatetitle = res.data.alternate.room_name
      }).catch(err => {
        this.medium = {}
        this.roomInfo.announcement = ''
        this.roomInfo.alternatetitle = ''
      })
    },
    /**
     * @description: 客服消息 未读 =》 已读
     * @return {*}
     */
    goRead() {
      if(this.roomId) {
        const conversation = { conversationType: RongIMLib.ConversationType.GROUP, targetId: this.roomId }
        RongIMLib.sendSyncReadStatusMessage(conversation, +new Date())
        RongIMLib.clearMessagesUnreadStatus(conversation)
        for (const key in this.tableData) {
          if (this.tableData[key].id == this.roomId) {
            this.tableData[key].unread = 0
            this.$set(this.tableData[key], 'aite', 0)
          }
        }
        this.getDataList()
      }
    },
    /**
     * @description: 关闭会话
     * @return {*}
     */
    close_this_room(item) {
      this.closeRoomInfo = item
      // if(item.type == 3){
      //   this.quitqunVisible=true
      // }else{
        this.closeRoomDia = true
      // }
    },
    /**
     * @description: 关闭会话
     * @return {*}
     */
    handleCloseRoom() {
      disbandGroupApi({ group_id: this.closeRoomInfo.id })
        .then(res => {
          if (res && res.code === 200) {
            this.$message.success('关闭成功！')
            this.toggleTap()
          }
        }).catch(() => {
          this.$message.error('关闭失败！')
          this.closeRoomInfo = {}
        })
    },
    /**
     * @description: 关闭房间时切换房间
     * @return {*}
     */
    toggleTap() {
      let index
      let tabIndex = this.tableData.findIndex(item => item.id == this.closeRoomInfo.id)
      this.tableData.splice(tabIndex,1)
      // this.tableData[tabIndex].status = 0
      // this.$set(this.tableData[tabIndex],'status',0)
      // this.getDataList()
      let roomIndex = this.roomidList.findIndex(item => item == this.closeRoomInfo.id)
      this.roomidList.splice(roomIndex,1)
      if(this.closeRoomInfo.topstatus == 1&&this.toproomList.length>1){
        index = this.toproomList.findIndex(item => item.id == this.closeRoomInfo.id)
        if(this.closeRoomInfo.id == this.roomId&&index!=this.toproomList.length-1){
          this.toproomList.splice(index,1)
          this.intoRoom(this.toproomList[index])
        }else if(this.closeRoomInfo.id == this.roomId&&index==this.toproomList.length-1){
          this.toproomList.splice(index,1)
          this.intoRoom(this.toproomList[0])
        }else{
          this.toproomList.splice(index,1)
        }
        this.closeRoomInfo = {}
      }
      if(this.closeRoomInfo.topstatus == 1&&this.toproomList.length==1){
        this.toproomList.splice(0,1)
        if(this.roomList.length>=1){
          this.intoRoom(this.roomList[0])
        }else{
          this.$router.push({name: 'Home'})
        }
      }
      if(this.closeRoomInfo.topstatus == 0&&this.roomList.length>1){
        index = this.roomList.findIndex(item => item.id == this.closeRoomInfo.id)
        if(this.closeRoomInfo.id == this.roomId&&index!=this.roomList.length-1){
          this.roomList.splice(index,1)
          this.intoRoom(this.roomList[index])
        }else if(this.closeRoomInfo.id == this.roomId&&index==this.roomList.length-1){
          this.roomList.splice(index,1)
          this.intoRoom(this.roomList[0])
        }else{
          this.roomList.splice(index,1)
        }
        this.closeRoomInfo = {}
      }
      if(this.closeRoomInfo.topstatus == 0&&this.roomList.length==1){
        this.roomList.splice(0,1)
        if(this.toproomList.length>=1){
          this.intoRoom(this.toproomList[0])
        }else{
          this.$router.push({name: 'Home'})
        }
        this.closeRoomInfo = {}
      }
    },
    /**
     * @description: 列表关闭群聊
     * @return {*}
     */
    handleQuitqunRoom() {
      quitRoomApi({ group_id: this.roomId })
        .then(res => {
          if (res && res.code === 200) {
            this.$message.success('退出成功！')
            this.toggleTap()
          }
        }).catch(() => {
          this.$message.error('退出失败！')
          this.closeRoomInfo = {}
        })
    },
    /**
     * @description: 查询咨询包赔配置
     * @return {*}
     */
    globalconfigZX() {
      this.globalconfig('咨询包赔',0)
    },
    /**
     * @description: 查询业务介绍配置
     * @return {*}
     */
    globalconfigYW() {
      this.globalconfig('业务介绍',1)
    },
    /**
     * @description: 查询售后服务配置
     * @return {*}
     */
    globalconfigSH() {
      this.globalconfig('售后服务',2)
    },
    /**
     * @description: 查询全局配置
     * @return {*}
     */
    globalconfig(text,index) {
      let nick = this.roomMember.find(v => v.userid == this.$store.state.userData.telphone)
      this.messageList.push({
        content: text,
        msgtype: 2,
        roomid: this.roomId,
        userid: this.$store.state.userData.telphone,
        nickname: nick.nickname,
        status: 1,
        contenttype: 1})
      this.$nextTick(() => {
        this.scrollBottom()
      })
      getGlobalConfigApi().then(res => {
        const automsg = res?.data?.automsg
        if (automsg && automsg[index] !== undefined) {
          this.messageList.push({
            content: automsg[index],
            msgtype: 1,
            roomid: this.roomId,
            status: 1,
            contenttype: 1
          })
          this.$nextTick(() => {
            this.scrollBottom()
          })
        }
      }).catch(() => {})
    },
    /**
     * @description: 上传图片/文件前调用
     * @param {*} file
     * @return {*}
     */
    beforeUploadImg(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
       if (!isLt10M) {
          this.$message.error('上传图片大小不能超过 10MB!');
        }
      return isLt10M
    },
    /**
     * @description: 上传图片/文件前调用
     * @param {*} file
     * @return {*}
     */
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 100;
       if (!isLt10M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
      return isLt10M
    },
    /**
     * @description: 上传文件/图片成功回调
     * @param {*} response
     * @param {*} file
     * @param {*} fileList
     * @return {*}
     */
    uploadSuccess(response, file, fileList) {
      let resData = JSON.parse(Decrypt(response.result))
      this.isScrollBottom = true
      const target = { conversationType: RongIMLib.ConversationType.GROUP, targetId: this.roomId }
      let sendPromise
      if(file.raw.type.indexOf('image') != -1){
        const imgUrl = resData.url || ''
        sendPromise = RongIMLib.sendMessage(target, new RongIMLib.ImageMessage({ content: imgUrl, imageUri: imgUrl }))
      } else {
        sendPromise = RongIMLib.sendMessage(target, new RongIMLib.FileMessage({
          name: file.name,
          size: file.size,
          type: file.raw.type,
          fileUrl: resData.url || '',
        }))
      }
      sendPromise
        .then(({ code, data: rcMsg }) => {
          if (code !== 0) { this.errorSend(); return }
          const value = this.adaptRCMessage(rcMsg)
          if (value) this.getIpList(value)
        })
        .catch(() => this.errorSend())
      // }else{
      //   if(file.raw.type.indexOf('image') != -1){
      //     // 离线
      //     chatApi.sendOffline({
      //       content: JSON.stringify({
      //         filename:file.name,
      //         url:resData.url,
      //         width:resData.width,
      //         height: resData.height
      //       }),
      //       contenttype: 4,
      //       format: 'json',
      //       groupcode: this.grouptitle
      //     }).then(res => {
      //       let msg = JSON.parse(Decrypt(res.msg))
      //       msg.userid = this.$store.state.userData.telphone
      //       msg.msgtype = 2
      //       this.getIpList(msg)
      //     }).catch(err => {
      //       this.$message.error('当前存在客服在线，请返回与在线客服沟通')
      //     })
      //   } else {
      //     // 离线
      //     chatApi.sendOffline({
      //       content: JSON.stringify({
      //         filename:file.name,
      //         url:resData.url,
      //         filetype:file.raw.type,
      //         size: file.size
      //       }),
      //       contenttype: 6,
      //       format: 'json',
      //       groupcode: this.grouptitle
      //     }).then(res => {
      //       let msg = JSON.parse(Decrypt(res.msg))
      //       msg.userid = this.$store.state.userData.telphone
      //       msg.msgtype = 2
      //       this.getIpList(msg)
      //     }).catch(err => {
      //       this.$message.error('当前存在客服在线，请返回与在线客服沟通')
      //     })
      //   }
      // }
    },
    uploadError(err, file, fileList) {
    },
    /**
     * @description: 13位时间戳转时间
     * @param {*} time
     * @param {*} format
     * @return {*}
     */
    formatDate(time, format) {
      if(!time) return ''
      format = format || 'YYYY-MM-DD HH:mm:ss';
      return moment(time).format(format);
    },
    /**
     * @description: 进入房间
     * @return {*}
     */
    intoRoom(item) {
      this.shopInfoShow = false
      this.refundShow = false
      this.paymentShow = false
      this.messageList = []
      this.userReset = []
      this.roomGameDetailShow = false
      this.roomGameDetail = {}
      this.buyedData = {
        content: '',
        new_room_id: ''
      }
      this.refundCountdown = false
      this.refundStartTime = ''
      this.refundEndTime = ''

      getGroupInfoApi({ group_id: item.id }).then(async res => {
        this.customercareid = ''
        this.grouptitle = ''
        this.ysdgcode = ''
        this.isSearch = false
        this.search = ''
        const room_data = res?.data || {}
        this.activeName = 'first'
        // type: 'private'→1, 'group'/'business'→3
        const typeMap = { private: 1, group: 3, business: 3 }
        this.$set(this.roomInfo, 'room_type', typeMap[room_data.type] || 1)
        this.$set(this.roomInfo, 'topstatus', room_data.topstatus || 0)
        this.$set(this.roomInfo, 'shieldstatus', room_data.shieldstatus || 0)
        this.$set(this.roomInfo, 'addtime', room_data.created_at || '')
        this.$set(this.roomInfo, 'membercount', room_data.member_count || 0)
        this.rcHistoryTimestamp = 0
        this.roomId = item.id
        if(localStorage.getItem('errorTime'+this.roomId)&&localStorage.getItem('errorTime'+this.roomId)>new Date().getTime()){
          this.wxQrcodeShow = true
        }else{
          this.wxQrcodeShow = false
        }
        if(room_data.type == 3){
          this.roomextInfo()
          try {
            await apiGetroomdetailbyroomid({
              room_id: item.id,
              client: 'front'
            }).then(rre => {
              this.roomGameDetail = rre.data
              this.roomGameDetailShow = true
            }).catch()
          } catch {}
        }
        this.$router.push({
          name: 'chatRoom',
          query: {
            room_id: item.id,
          }
        })
        this.selectRoomList('handleGetOldMessage')
        this.page = 1
        // this.handleGetOldMessage()
        this.noHistory = false
        this.noMore = false
        this.loading = false
        this.historymore = true
        setTimeout(() => {
          if(this.roomidList.indexOf(item.id) == -1){
            let room_info = this.initial_tableData.find(v => v.id == item.id)
            if(room_info){
              room_info.status = 0
              this.tableData.unshift(room_info)
              this.getDataList()
            }else{
              // 会话列表尚未就绪（如融云尚未连接完成，getConversationList 返回为空），重新拉取
              this.handleGetRoomList()
            }
          }
        },1000)
        this.getOrderData()
      })

    },
    /**
     * @description: 获取聊天token
     * @return {*}
     */
    // getCusToken() — 旧 WS 认证流程，已由 imInit() 替代，废弃
    pointCRoom() {
      this.messageList = []
      this.selectRoomList('handleGetOldMessage_getcustomercarelist')
      this.isSearch=false
      this.activeName = 'first'
      this.$set(this.roomInfo,'room_type',1)
      this.$set(this.roomInfo,'topstatus',0)
      this.$set(this.roomInfo,'shieldstatus',0)
      this.page = 1
      this.noHistory = false
      this.noMore = false
      this.loading = false
      this.historymore = true
      this.$router.push({
        name: 'chatRoom',
        query: {
          room_id: this.roomId,
        }
      })
      this.grouptitle = ''
      this.customercareid = ''
      this.game_id = ''
      this.handleGetRoomList()
    },
    // 融云IM初始化入口（替换旧 initWebSocket）
    async initRCIM() {
      await imInit()
      this.registerRCListeners()
      const needCreate = (this.customercareid || this.grouptitle || this.game_id || this.ysdgcode)
      if (needCreate && !this.roomId) {
        this.roomCreatCus()
      }
    },
    // 注册融云全局消息事件（只注册一次）
    registerRCListeners() {
      if (this.rcListenersRegistered) return
      this.rcListenersRegistered = true
      RongIMLib.addEventListener(RongIMLib.Events.MESSAGES, this.onRCMessages)
      RongIMLib.addEventListener(RongIMLib.Events.CONNECTED, this.onRCConnected)
    },
    // 融云连接成功后补加载：首次进入页面时，连接（imInit 防抖 600ms + connect）可能晚于
    // 会话列表 / 历史消息请求，导致 getConversationList、getHistoryMessages 返回为空
    // （表现为会话列表为空、历史记录不显示）。连接完成后在此重新拉取一次。
    onRCConnected() {
      this.handleGetRoomList()
      if (this.roomId && this.messageList.length === 0) {
        this.rcHistoryTimestamp = 0
        this.page = 1
        this.selectRoomList('handleGetOldMessage')
      }
    },
    // 融云消息接收统一入口
    onRCMessages(evt) {
      const messages = evt.messages || []
      messages.forEach(rcMsg => {
        const { messageType, content, targetId, senderUserId } = rcMsg
        // RC:GrpNtf 群邀请（在 im.js 的 imInit 中已处理）
        if (messageType === 'RC:GrpNtf') return

        // 更新会话列表未读数
        this.handleGetRoomList()

        // 仅处理当前房间的消息
        if (targetId !== this.roomId) return

        const adapted = this.adaptRCMessage(rcMsg)
        if (!adapted) return

        if (messageType === 'RC:RcNtf') {
          // 撤回通知
          this.recreadCall(adapted)
          return
        }
        // PX:SpeakMsg 禁言/解禁
        if (messageType === 'PX:SpeakMsg') {
          const myPhone = this.$store.state.userData.telphone
          if (content.action === 'silence' && content.target_id === myPhone) {
            this.isMute = true
            this.message = `<div style="color:#8B8B8B;">您已经被禁言～</div>`
          } else if (content.action === 'cancel_silence' && content.target_id === myPhone) {
            this.isMute = false
            this.message = `<div></div>`
          }
          return
        }
        this.getIpList(adapted)
        this.$store.commit('set_updateMsgListFlag', +new Date())
      })
    },
    // 将融云消息对象转换为旧系统 UI 所需格式
    adaptRCMessage(rcMsg) {
      const { messageType, content, senderUserId, sentTime, messageUId, targetId } = rcMsg
      const member = (this.roomMember || []).find(m => m.userid === senderUserId) || {}
      const base = {
        id: messageUId,
        roomid: targetId,
        userid: senderUserId,
        nickname: member.nickname || senderUserId,
        headimg: member.headimg || member.portrait || '',
        official_icon: member.official_icon || '',
        addtime: new Date(sentTime).toISOString().replace('T', ' ').slice(0, 19),
        msgtype: 1,
        status: 1,
        _rcMsg: rcMsg,
      }
      switch (messageType) {
        case 'RC:TxtMsg':
          return { ...base, contenttype: 1, content: content.content || '' }
        case 'RC:ImgMsg': {
          const imgUrl = content.imageUri || content.content || ''
          return { ...base, contenttype: 4, content: JSON.stringify({ url: imgUrl, width: 183, height: 200 }) }
        }
        case 'RC:GIFMsg':
          return { ...base, contenttype: 4, content: JSON.stringify({ url: content.remoteUrl || '', width: 183, height: 200 }) }
        case 'RC:FileMsg':
          return { ...base, contenttype: 6, content: JSON.stringify({
            filetype: content.type || 'application/octet-stream',
            url: content.fileUrl || '',
            name: content.name || '',
            size: content.size || 0,
          }) }
        case 'RC:HQVoiceMsg':
          return { ...base, contenttype: 6, content: JSON.stringify({
            filetype: 'audio/mp3', url: content.remoteUrl || '', name: '语音', size: content.duration || 0
          }) }
        case 'RC:RcNtf':
          return { ...base, msgtype: 7, status: 0, contenttype: 1, content: '撤回了一条消息', recalledMsgId: content.messageUId }
        case 'PX:OrderMsg':
          return { ...base, contenttype: 'rc_order', content }
        case 'PX:ProductMsg':
          return { ...base, contenttype: 'rc_product', content }
        case 'PX:EvaluationMsg':
          return { ...base, msgtype: 10, contenttype: 'rc_evaluation', content, _rcMsg: rcMsg }
        case 'PX:ReminderMsg':
          return { ...base, msgtype: 23, contenttype: 1, content: content.content || '' }
        case 'PX:AfterSalesMsg':
          return { ...base, contenttype: 'rc_aftersales', content }
        default:
          return null
      }
    },
    // 旧 initWebSocket 已废弃，保留空函数防止模板引用报错
    initWebSocket() {
      if(localStorage.getItem('cusetomerTokens') !== null && localStorage.getItem('cusetomerTokens') !== ''){
        this.$WSIM.createSocket()
        this.$WSIM.on('loginok',(e) => {
          localStorage.setItem('cusetomerSid', e.data.sid)
          if((this.customercareid!=''&&this.grouptitle!=''&&this.customercareid!=undefined&&this.grouptitle!=undefined)||(this.game_id!=''&&this.game_id!=undefined)||(this.ysdgcode!=''&&this.ysdgcode!=undefined)||(this.customercareid!=''&&this.customercareid!=undefined)){
            this.roomCreatCus()
          }
        })
        this.$WSIM.on('createroom',(e) => {
          this.roomId = e.data.id
          this.pointCRoom()
          this.getOrderData()
        })
        this.$WSIM.on('chat',(e) => {
          let value = e.data
          let t = [1,2,3,4,5,8,9,10,11,12,14,18,22]
          if(t.includes(value.msgtype)){
            if(value.roomid==this.roomId&&!(value.msgtype == 10||value.msgtype == 11||value.msgtype == 12||value.msgtype == 18||value.msgtype == 4)){
              if(value.userid != "appoint_000000000000000000000001"){
                let nick = this.roomMember.find(v => v.userid == value.userid)
                value.nickname = nick.nickname
                value.headimg = decodeURIComponent(nick.headimg)
                value.official_icon = nick.official_icon
              }else{
                value.nickname = "系统客服"
                value.headimg = require('@/assets/image/chat/system.png')
              }
            }
            this.getIpList(value)
          }
          // 催一催
          if(value.msgtype == 24){
            let con = JSON.parse(value.content)
            value.senduserid = con.userid
            if(this.isMe(value.senduserid)&&value.roomid==this.roomId){
              localStorage.setItem('sendRemind'+this.roomId,JSON.stringify({addtime: value.addtime, senduserid: value.senduserid}))
              this.getIpList(value)
            }
          }
          // 禁言
          if(value.msgtype == 20){
            let con = JSON.parse(value.content)
            if(value.roomid == this.roomId){
              if(con.type == 1&&con.userid == this.$store.state.userData.telphone){
                this.isMute = true
                this.message = `<div style="color:#8B8B8B;">您已经被禁言～</div>`
                value.content = con.content
                value.contenttype = 1
                this.getIpList(value)
              }
              if(con.type == 0&&con.userid == this.$store.state.userData.telphone){
                this.isMute = false
                this.message = `<div></div>`
                value.content = con.content
                value.contenttype = 1
                this.getIpList(value)
              }
              if(con.userid != this.$store.state.userData.telphone){
                value.contenttype = 1
                value.content = con.content
                this.getIpList(value)
              }
            }else{
              value.contenttype = 1
              value.content = con.content
              this.getIpList(value)
            }
          }
          // 踢出群成员
          if(value.msgtype == 19){
            let con = JSON.parse(value.content)
            if(con.userid == this.$store.state.userData.telphone){
              let room = this.tableData.find(item => item.id == value.roomid)
              let forwardIndex = this.forwardList.findIndex(item => item.id == value.roomid)
              this.forwardList.splice(forwardIndex,1)
              this.forwardCheckList.splice(this.forwardCheckList.findIndex(i => i==value.roomid),1)
              this.closeRoomInfo.topstatus = room.topstatus
              this.closeRoomInfo.id = value.roomid
              this.$message.info('您已被踢出'+room.title)
              this.toggleTap()
            }else{
              this.selectRoomList()
              value.content = con.content
              value.contenttype = 1
              this.getIpList(value)
            }
          }
          // 解散群聊
          if(value.msgtype == 17){
            let room = this.tableData.find(item => item.id == value.roomid)
            let forwardIndex = this.forwardList.findIndex(item => item.id == value.roomid)
            this.forwardList.splice(forwardIndex,1)
            this.forwardCheckList.splice(this.forwardCheckList.findIndex(i => i==value.roomid),1)
            this.closeRoomInfo.topstatus = room.topstatus
            this.closeRoomInfo.id = value.roomid
            this.$message.info('群聊'+room.title+'已解散')
            this.toggleTap()
          }
          // 邀请新的群成员
          if(value.msgtype == 16){
            let con = JSON.parse(value.content)
            let users = con.userid.split(',');
            users.forEach(item => {
              if(item == this.$store.state.userData.telphone){
                this.handleGetRoomList()
              }else{
                value.content = con.content
                value.contenttype = 1
                this.getIpList(value)
                this.selectRoomList()
              }
            })
          }
          // 创建群聊
          if(value.msgtype == 15){
            this.handleGetRoomList()
          }
          // 强制转接
          if(value.msgtype == 6){
            this.handleGetRoomList('selectRoomList',value)
          }
        })
        this.$WSIM.on('offline',(e) => {
          let value = e.data
          // if(value.type == 1){
            this.roomMember.forEach(item => {
              if(item.type == 1&&item.userid == value.userid){
                this.$set(item,'sessionstatus',0)
                // this.$message.info('当前客服已离线！')
                this.handleGetRoomList()
              }
              if(item.type == 2&&item.userid == value.userid){
                this.$set(item,'sessionstatus',0)
                // this.$message.info('当前客服已离线！')
                // this.handleGetRoomList()
              }
            })
            this.forwardList.forEach(i => {
              if(i.type == 1&&i.userid == value.userid){
                this.$set(i,'sessionstatus',0)
              }
            })
          // }
        })
        this.$WSIM.on('tempoffline',(e) => {
          let value = e.data
          // if(value.type == 1){
            this.roomMember.forEach(item => {
              if(item.type == 1&&item.userid == value.userid){
                this.$set(item,'sessionstatus',2)
                // this.$message.info('客服忙碌中，请稍等～')
                this.handleGetRoomList()
              }
              if(item.type == 2&&item.userid == value.userid){
                this.$set(item,'sessionstatus',2)
              }
            })
            this.forwardList.forEach(i => {
              if(i.type == 1&&i.userid == value.userid){
                this.$set(i,'sessionstatus',2)
              }
            })
          // }
        })
        this.$WSIM.on('online',(e) => {
          let value = e.data
          // if(value.type == 1){
            this.roomMember.forEach(item => {
              if(item.type == 1&&item.userid == value.userid){
                this.$set(item,'sessionstatus',1)
                // this.$message.info('客服'+ item.nickname +'已上线！')
                this.handleGetRoomList()
              }
              if(item.type == 2&&item.userid == value.userid){
                this.$set(item,'sessionstatus',1)
                // this.$message.info('客服'+ item.nickname +'已上线！')
                // this.handleGetRoomList()
              }
            })
            this.forwardList.forEach(i => {
              if(i.type == 1&&i.userid == value.userid){
                this.$set(i,'sessionstatus',1)
              }
            })
          // }
        })
        // 已读同步
        this.$WSIM.on('roomread',(e) => {
          for (const key in this.tableData) {
            if(this.tableData[key].id == e.data.roomid){
              if(this.tableData[key].id != this.roomId&&e.data.userid!=this.$store.state.userData.telphone){
                this.$set(this.tableData[key],'unread','0')
                this.$set(this.tableData[key],'aite',0)
              }
            }
          }
        })
        // 撤回
        this.$WSIM.on('recall',(e) => {
          let recall_id = e.data
          this.recreadCall(recall_id)
        })
        // 屏蔽
        this.$WSIM.on('shield',(e) => {
          this.handleGetRoomList()
          if(e.data.roomid == this.roomId){
            this.$set(this.roomInfo,'shieldstatus',Number(e.data.status))
          }
        })
        // 置顶
        this.$WSIM.on('top',(e) => {
          this.handleGetRoomList()
          if(e.data.roomid == this.roomId){
            this.$set(this.roomInfo,'topstatus',Number(e.data.status))
          }
        })
        // 关闭房间同步
        this.$WSIM.on('close',(e) => {
          this.handleGetRoomList()
        })
        // 修改群名同步
        this.$WSIM.on('updatetitle',(e) => {
          let upaRoom = this.tableData.findIndex(item => item.id == e.data.roomid)
          this.$set(this.tableData[upaRoom],'title',e.data.title)
        })
      }else {
        this.getCusToken()
      }
    },
    /**
     * @description: 查询成员信息
     * @return {*}
     */
    // 加载群成员信息（替换旧 selectRoomList + chatApi.querymember）
    async selectRoomList(fn, msg) {
      this.isMute = true
      this.jinyong = false
      this.transferClosed = ''
      this.message = `<div></div>`
      this.members = []
      this.bs_members = []
      this.userLists = []
      this.roomMember = []
      this.closedList = []
      this.joinTime = new Date().getTime()
      this.cusPhone = ''
      let mute = false

      const res = await getRoomMembersApi({ group_id: this.roomId }).catch(() => null)
      if (!res || !res.data) return

      // 规范化成员数据（im-chat-backend → 旧 UI 格式）
      // user_type: 'customercare'=1, 'customer'=2
      const rawList = Array.isArray(res.data) ? res.data : (res.data.list || [])
      const list = rawList.map(item => {
        const info = item.userInfo || item
        const isCC = item.user_type === 'customercare' || info.user_type === 'customercare'
        return {
          userid: item.user_id || item.userid,
          nickname: info.nickname || info.name || item.user_id,
          headimg: info.portrait || info.headimg || '',
          official_icon: info.official_icon || '',
          type: isCC ? 1 : 2,
          roommanager: item.member_type === 'manager' || item.member_type === 'administrator' ? 1 : 0,
          prohibitstatus: item.is_silence || 0,
          sessionstatus: item.session_status ?? 1,
          jointime: item.created_at || new Date().toISOString(),
          isdel: item.is_del || 0,
          closed: item.closed || '',
          _raw: item,
        }
      })

      this.oldRoomMember = list
      list.forEach(item => {
        if (!item.isdel) this.roomMember.push(item)
      })

      const myPhone = this.$store.state.userData.telphone
      const joinItem = this.roomMember.find(m => m.userid === myPhone)
      if (joinItem) {
        this.joinTime = new Date(joinItem.jointime.replace(/-/g, '/')).getTime()
      }

      // 群组信息
      const groupInfo = await getGroupInfoApi({ group_id: this.roomId }).catch(() => null)
      const groupData = groupInfo?.data || {}
      const isGroup = (groupData.type || 'private') !== 'private'

      if (isGroup) {
        this.$set(this.roomInfo, 'title', groupData.title || this.roomId)
        this.$set(this.roomInfo, 'membercount', this.roomMember.length)
        for (const key in this.roomMember) {
          if (this.roomMember[key].type === 1) {
            this.bs_members.push(this.roomMember[key])
            if (!this.roomGameDetailShow) this.members.push(this.roomMember[key])
            if (this.roomGameDetailShow && this.roomGameDetail.orderStatus) this.members = this.bs_members
            if (this.roomMember[key].roommanager === 1) {
              this.$set(this.roomInfo, 'roommanager', this.roomMember[key].nickname)
            }
          } else {
            this.userLists.push(this.roomMember[key])
          }
          if (this.roomMember[key].prohibitstatus === 1 && this.isMe(this.roomMember[key].userid)) {
            mute = true
            this.message = `<div style="color:#8B8B8B;">您已经被禁言～</div>`
          }
        }
      } else {
        // 私聊
        for (const key in this.roomMember) {
          if (this.roomMember[key].type === 1) {
            this.$set(this.roomInfo, 'roommanager', this.roomMember[key].nickname)
            this.$set(this.roomInfo, 'headimg', this.roomMember[key].headimg)
            const ss = this.roomMember[key].sessionstatus
            if (ss === 0) {
              this.$message({
                dangerouslyUseHTMLString: true,
                message: `<div>客服暂时不在，如有问题请留言~</div>(工作时间：${this.complaint.complaint_phone_time})`,
                center: true, duration: 3000, offset: 300, customClass: 'customer-offline-msg'
              })
            } else if (ss === 2) {
              this.$message({
                message: `客服忙碌中，请稍等～`,
                center: true, duration: 3000, offset: 300, customClass: 'customer-offline-msg'
              })
            }
          }
        }
      }

      if (fn === 'handleGetOldMessage') {
        this.isGetOldMsg = true
        setTimeout(() => {
          this.handleGetOldMessage(this.jinyong || mute || '')
        }, 500)
      }
      if (fn === 'handleGetOldMessage_getcustomercarelist') {
        this.handleGetOldMessage(this.jinyong || mute || '')
        this.getcustomercarelist()
      }
      if (fn === 'msg') {
        if (msg.id === this.roomId) {
          const nick = this.roomMember.find(v => v.userid === msg.userid)
          if (nick) {
            msg.nickname = nick.nickname
            msg.headimg = nick.headimg
          }
        }
        this.getIpList(msg)
      }
    },
    /**
     * @description: 邀请禁用客服
     * @return {*}
     */
     async closedinviteCurs() {
      let arr = this.members.map(item => item.userid)
      for (const key in this.closedList) {
        if(arr.indexOf(this.closedList[key].closed)==-1){
          inviteMemberApi({
            group_id: this.roomId,
            transfer_customercare_id: this.closedList[key].userid,
          }).then(res => {
            if(key==this.closedList.length-1){
              this.selectRoomList()
            }
          })
        }
      }
    },
    /**
     * @description: 转接
     * @return {*}
     */
    transfer() {
      transferRoomApi({
        group_id: this.roomId,
        transfer_customercare_id: this.transferClosed,
      }).then(() => {
        this.shopInfoShow = false
        this.refundShow = false
        this.paymentShow = false
        this.messageList = []
        this.userReset = []
        this.roomGameDetailShow = false
        this.roomGameDetail = {}
        this.buyedData = {
          content: '',
          new_room_id: ''
        }
      })
    },
    /**
     * @description: 添加会话信息
     * @return {*}
     */
    async pushMsg(msg) {
      if(this.roomidList.indexOf(msg.roomid) == -1){
        let room_info = this.initial_tableData.find(v => v.id == msg.roomid)
        if(room_info){
          room_info.status = 0
          this.tableData.unshift(room_info)
          this.getDataList()
        }else{
          this.handleGetRoomList()
        }
      }
      if(msg.roomid == this.roomId){
        // 推送当前房间
        let msgindexOf = await this.messageList.indexOf(msg.id) == -1
        if(msgindexOf){
          //处理文本上的链接
          if (msg.contenttype === 1 || msg.contenttype === 9) {
            let reg = /((http|https):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|])/g;
            let urls = msg.content.match(reg)
            if(urls){
              let sp = msg.content.split(urls[0])
              msg.content = sp[0]+`<a href="${urls}" style="text-decoration: underline; color: var(--primary, #FF5A1F);" target="_blank">${urls}</a>`+sp[1]
            }
          }
          this.messageList.push(msg)
          if(msg.userid!=this.$store.state.userData.telphone&&(msg.shouldusers?msg.shouldusers.length>0:false)){
            msg.shouldusers.forEach(v => {
              if(v.userid == this.$store.state.userData.telphone){
                this.unreadList.push(msg.id)
              }
            })
          }
          this.goRead()
        }
      }
      let messageRoom = this.tableData.find(item => item.id == msg.roomid)
      let noAudio = [11,12,13,14,16,18,19,21]
      if(msg.userid!=this.$store.state.userData.telphone&&msg.roomid != this.roomId&&messageRoom.shieldstatus != 1&&noAudio.indexOf(msg.msgtype) == -1){
          // this.$refs.audio.currentTime = 0;
          this.$refs.audio.play();
        }
      for (const key in this.tableData) {
        if(this.tableData[key].id == msg.roomid){
          if(this.roomidList.indexOf(this.tableData[key].id) == -1){
            this.tableData[key].status=0
            this.roomList.unshift(this.tableData[key])
          }
          this.$set(this.tableData[key],'addtime',msg.addtime)
          this.$set(this.tableData[key],'msgtype',msg.msgtype)
          this.$set(this.tableData[key],'msguserid',msg.userid)
          if(this.tableData[key].id != this.roomId&&msg.userid!=this.$store.state.userData.telphone){
            this.$set(this.tableData[key],'unread',++this.tableData[key].unread)
          }
          if(this.tableData[key].id != this.roomId&&msg.userid==this.$store.state.userData.telphone){
            this.$set(this.tableData[key],'unread',0)
          }
          // lastData[0].contenttype == 1?lastData[0].content:JSON.parse(lastData[0].content).content
          if(msg.contenttype == 1||msg.contenttype == 9||msg.contenttype == 7){
            this.$set(this.tableData[key],'content',msg.contenttype == 1?msg.content:msg.msgtype==24?'[催一催消息]':msg.msgtype==23?'':JSON.parse(msg.content).content)
            // this.$set(this.tableData[key],'content',msg.content)
            if(msg.aite == 1){
              this.$set(this.tableData[key],'aite',1)
            }
          } else if(msg.contenttype == 3||msg.contenttype == 4||msg.contenttype == 5){
            this.$set(this.tableData[key],'content','[图片]')
          } else if(msg.contenttype == 5) {
            this.$set(this.tableData[key],'content','[链接]')
          } else if(msg.contenttype == 8) {
            this.$set(this.tableData[key],'content','[订单消息]')
          } else if(msg.contenttype == 6&&msg.video) {
            this.$set(this.tableData[key],'content','[视频]')
          } else if(msg.contenttype == 6&&!msg.video) {
            this.$set(this.tableData[key],'content','[文件]')
          } else if(msg.contenttype == 10) {
            this.$set(this.tableData[key],'content','[聊天记录]')
          }
        }
      }
      this.tableData = this.tableData.sort((a, b) => {
        if (a.addtime && b.addtime && a.addtime !== b.addtime) {
          return b.addtime - a.addtime;
        }
      })
      // this.roomList = this.roomList.sort((a, b) => {
      //   if (a.addtime && b.addtime && a.addtime !== b.addtime) {
      //     return b.addtime - a.addtime;
      //   }
      // })
    },
    imageFlag(text,content) {
      text.content = content
      if (text.content.width > text.content.height && text.content.width > 200) {
        text.content.w = text.content.width
        text.content.h = text.content.height
        //图片宽比高长并且宽超过200px
        text.content.height = text.content.height / (text.content.width / 183)
        text.content.width = 183
      } else if (text.content.height > 200) {
        text.content.w = text.content.width
        text.content.h = text.content.height
        //图片高比宽长并且宽超过200px
        text.content.width = text.content.width / (text.content.height / 200)
        text.content.height = 200
      }
      if (text.content.url.indexOf('https://images-kefu.pxb7.com') !== -1) {
      // if (text.content.url.indexOf('https://wsapi.pxb7.com/api/upload/') !== -1) {
        //缩略图
        text.content.thumbnail = `${text.content.url}?x-oss-process=image/resize,m_lfit,h_${Math.round(text.content.height)},w_${Math.round(text.content.width)}`
      } else {
        //缩略图
        text.content.thumbnail = `${text.content.url}`
      }
      this.pushMsg(text)
      this.imgList.unshift(text.content.url)
    },
    /**
     * 获取新消息
     */
    getIpList(text) {
      if(text){
        // if(text.msgtype == 1 || text.msgtype == 2 || text.msgtype == 5 || text.msgtype == 8){
        if(text.msgtype !== 10 || text.msgtype !== 11 || text.msgtype !== 12){
          if(text.contenttype == 1){
            if(text.msgtype == 5){
              this.handleGetRoomList('selectRoomList')
              this.pushMsg(text)
            } else {
              this.pushMsg(text)
            }
          } else if(text.contenttype == 8) {
            text.content = JSON.parse(text.content).content
            if(text.content.indexOf('div')!=-1){
              let patt = /onclick=['"]([^""]+)['"]+/g
              let patts = /openExternal['(]([^""]+)[')]+/g
              let linka = patts.exec(text.content)[1]
              let sp = text.content.split(patt.exec(text.content)[0])
              text.content = sp[0]+`onclick="window.open(${linka},'_blank')"`+sp[1]

              let input = text.content.match(/<input.*?>/gi)[0]
              let pay_type_input = text.content.match(/<input.*?>/gi)[1]
              let order = {}
              let key = input.replace(/.*id="(.+?)".*/, "$1")
              order[key] = input.replace(/.*value="(.+?)".*/, "$1")
              let payType = pay_type_input.replace(/.*value="(.+?)".*/, "$1")
              // 1 线下 2 在线
              this.$set(text,'pay_type',payType)
              apiOrderDetail({client:'front',order_id:order[key]}).then(res=> {
                this.$set(text,'order_status',res.data.order_status)
                this.$set(text,'order_no',res.data.order_no)
                this.$set(text,'order_id',res.data.id)
                this.$set(text,'order_amount',res.data.order_amount)
                this.$set(text,'buy_user_id',res.data.buy_user_id)
                this.$set(text,'user_id',this.$store.state.userData.user_id)
                this.$set(text,'product_id',res.data.order_info[0]?.goods_id)
                this.$set(text,'game_id',res.data.game_id)
                // let ss = res.data.buy_user_id == this.$store.state.userData.user_id?true:false
                // console.log(ss);
                // this.$set(text,'btn_show',ss)
                // text.order_status = res.data.order_status
                // text.order_no = res.data.order_no
              })
              this.getOrderData()
              this.pushMsg(text)
            }else{
              if(text.content.match(/<input.*?>/gi)){
                let input = text.content.match(/<input.*?>/gi)[0]
                let user = {}
                let key = input.replace(/.*id="(.+?)".*/, "$1")
                user[key] = input.replace(/.*value="(.+?)".*/, "$1")
                if(user[key] == this.$store.state.userData.user_id){
                  // let reg = /((http|https):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|])/g;
                  // let urls = text.content.match(reg)
                  // if(urls){
                  //   let sp = text.content.split(urls[0])
                  //   text.content = sp[0]+`<a href="${urls}" style="text-decoration: underline; color: var(--primary, #FF5A1F);" target="_blank">${urls}</a>`+sp[1]
                  // }
                  this.pushMsg(text)
                }
              } else{
                let reg = /((http|https):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|])/g;
                let urls = text.content.match(reg)
                if(urls){
                  let sp = text.content.split(urls[0])
                  text.content = sp[0]+`<a href="${urls}"style="text-decoration: underline; color: var(--primary, #FF5A1F);" target="_blank">${urls}</a>`+sp[1]
                  this.pushMsg(text)
                }else{
                  this.pushMsg(text)
                }
              }
            }
          }else if(text.contenttype == 5){
            let patt = /onclick=['"]([^""]+)['"]+/g
            let patts = /openExternal['(]([^""]+)[')]+/g
            let linka = patts.exec(text.content)[1]
            let sp = text.content.split(patt.exec(text.content)[0])
            text.content = sp[0]+`onclick="window.open(${linka},'_blank')"`+sp[1]
            this.pushMsg(text)
          } else if(text.contenttype == 4||text.contenttype == 3) {
            let content = JSON.parse(text.content)
            const image = new Image()
            let _this = this
            image.src = content.url
            image.onload = function() {
              content.width = content.width?content.width:image.width
              content.height = content.height?content.height:image.height
              _this.imageFlag(text,content)
            }
          }else if(text.contenttype == 6){
            let content = JSON.parse(text.content)
            text.content = content
            if(text.content.filetype == 'video/mp4'){
              text.video = true
            }else {
              text.video = false
            }
            this.pushMsg(text)
          }else if(text.contenttype == 7&&(text.msgtype == 20||text.msgtype == 19||text.msgtype == 24)){
            if(text.msgtype == 24){
              let nick = this.roomMember.find(v => v.userid == text.senduserid)
              text.sendnickname = nick.nickname
              this.pushMsg(text)
            }else{
              this.pushMsg(text)
            }
          } else if(text.contenttype == 9){
            let content = JSON.parse(text.content)
            text.content = content.content
            if(content.userlist.indexOf(this.$store.state.userData.telphone)!=-1){
              text.aite = 1
            }
            this.pushMsg(text)
          } else if(text.contenttype == 10){
            let content = JSON.parse(text.content)
            text.content = content
            text.content.msglist.forEach((item,index) => {
              text.content.msglist[index] = JSON.parse(item)
            })
            this.pushMsg(text)
          } else if(text.contenttype === 'rc_product' || text.contenttype === 'rc_order' || text.contenttype === 'rc_aftersales') {
            // 融云商品/订单/售后消息（content 已是对象，无需 JSON.parse）
            this.pushMsg(text)
          }
        }
        if(text.msgtype == 10) {
          if(text.roomid==this.roomId){
            this.rcEvaluationMsg = text._rcMsg || null
            this.evid_roomid = text.roomid
            this.scoreShow = true
          }
        }
        if(text.msgtype == 12) {
          // console.log('评价超时',text);
          this.scoreShow = false
        }
        // this.isScrollBottom = false
        this.$nextTick(() => {
          this.scrollBottom()
        })
      }
    },
    scrollEvent(e) {
      if ((e.srcElement.offsetHeight + e.srcElement.scrollTop) - e.srcElement.scrollHeight === 0&&!this.loading) {
        e.srcElement.scrollTop = e.srcElement.scrollHeight - e.srcElement.offsetHeight - 1
        this.historyPage += 1;
        this.loading = true
        this.historymore = true
        this.handleGetHistory(2);
      }
    },
    /**
     * 合并消息弹窗关闭
     */
     mergeDialogClear() {
      this.mergeDialog = false
      this.mergeMsgList = {}
    },
    /**
     * 历史聊天记录弹窗关闭
     */
    historyDialogClear() {
      this.historyDialog = false
      this.searchText = ''
      this.historyMsgList = []
      this.historyDialogTimestamp = 0
    },
    /**
     * 历史聊天记录弹窗打开
     */
    historyDialogOpen() {
      this.historyDialog = true
      this.historyPage = 1
      this.historyDialogTimestamp = 0
      this.historymore = true
      this.handleGetHistory(1)
    },
    /**
     * @description: 搜索历史记录
     * @return {*}
     */
    handleGetHistory(p) {
      this.noMore = false
      this.noHistory = false
      p == 1 ? this.imgList = [] : ''
      if (this.roomId && (p == 1 ? true : this.historymore)) {
        this.loading = true
        RongIMLib.getRemoteHistoryMessages(
          { conversationType: RongIMLib.ConversationType.GROUP, targetId: this.roomId },
          { timestamp: this.historyDialogTimestamp || 0, count: this.historyPagesize || 40, order: 0 }
        ).then(({ code, data }) => {
          this.loading = false
          // 融云 getRemoteHistoryMessages 返回 { list, hasMore }，消息数组在 data.list
          const list = (data && data.list) || []
          if (code !== 0 || list.length === 0) {
            this.historymore = false
            if (p == 1) {
              this.noHistory = true
            } else {
              this.noMore = true
            }
            return
          }
          // order:0 返回升序（旧→新），取最早一条 sentTime 作为下一页（更早消息）游标
          this.historyDialogTimestamp = list[0].sentTime

          const adapted = list.map(rcMsg => this.adaptRCMessage(rcMsg)).filter(Boolean)
          const arr = []
          adapted.forEach(k => {
            if (k.contenttype == 1) {
              if (k.msgtype != 7) {
                if (this.searchText) {
                  k.content = k.content.split(this.searchText).join("<span style='color:#FF5A1F;'>" + this.searchText + "</span>")
                }
                arr.push(k)
              }
            } else if (k.contenttype == 4 || k.contenttype == 3) {
              let content = typeof k.content === 'string' ? JSON.parse(k.content) : k.content
              if (content.width > content.height && content.width > 200) {
                content.h = content.height
                content.w = content.width
                content.height = content.height / (content.width / 183)
                content.width = 183
              } else if (content.height > 200) {
                content.h = content.height
                content.w = content.width
                content.width = content.width / (content.height / 200)
                content.height = 200
              }
              content.thumbnail = content.url.indexOf('https://images-kefu.pxb7.com') !== -1
                ? `${content.url}?x-oss-process=image/resize,m_lfit,h_${Math.round(content.height)},w_${Math.round(content.width)}`
                : content.url
              k.content = content
              arr.push(k)
              this.imgList.push(content.url)
            } else if (k.contenttype == 6) {
              let content = typeof k.content === 'string' ? JSON.parse(k.content) : k.content
              k.content = content
              k.video = content.filetype == 'video/mp4'
              arr.push(k)
            }
          })

          // 弹窗按时间倒序展示（新→旧），arr 为升序，反转后再拼接（向下滚动加载更早消息）
          arr.reverse()
          if (p == 1) {
            this.historyMsgList = [...arr]
          } else {
            this.historyMsgList = [...this.historyMsgList, ...arr]
          }
          if (!data.hasMore || list.length < (this.historyPagesize || 40)) {
            this.historymore = false
            this.noMore = true
          }
          if (this.historyMsgList.length <= 0) {
            this.historymore = false
            this.noHistory = true
          }
        }).catch(() => {
          this.loading = false
        })
      }
    },
    /**
     * @description: 开启截图
     * @return {*}
     */
    screenShot() {
      this.$refs.cropper.tailoring()
    },
    getScreenShotUrls(url) {
    },
    /**
     * 获取截取后的图片
     * @param url
     */
    getScreenShotUrl(url,val) {
      this.message = this.message + `<img src="${url}" filename="${val.filename}" widths="${val.width}" heights="${val.height}" style="max-width:100px"/>`
    },
    //打开图片预览
    openViewer(src) {
      this.imagesUrl = src
      this.showViewer = true;
    },
    //关闭图片预览
    closeViewer() {
      document.body.style.overflow = prevOverflow;
      this.showViewer = false;
    },
    //查看公告详情
    lookAnnouncement() {
      this.$refs['announcement'].open()
    },
    //用户确认踢出群聊
    handleConfirmKick() {
      chatRoom.confirmKick({
        client_id: this.$store.state.client_id,
        room_id: this.roomId
      }).then(res => {
        this.roomInfo = {}
      })
    },
    isShowRecall() {
      if (this.msgRow && this.isMe(this.msgRow.userid)) {
        let nowTime = Number(new Date().getTime())
        let ss = nowTime - (this.msgRow._rcMsg?.sentTime || new Date(this.msgRow.addtime).getTime())
        let leavel2 = ss % (3600 * 1000); // 计算剩余小时后剩余的毫秒数
        let minutes = Math.floor(leavel2 / (60 * 1000)); // 计算剩余的分钟数
        return minutes <= 2
      } else {
        return false
      }
    },
    //表情
    emojiClick(val) {
      this.$refs.myTextarea.insertText(val)
    },
    //退出房间
    handleQuitRoom() {
      this.closeRoomInfo.topstatus = this.roomInfo.topstatus
      this.closeRoomInfo.id = this.roomId
      quitRoomApi({ group_id: this.roomId })
        .then(res => {
          if (res && res.code === 200) {
            this.$message.success('退出成功！')
            this.toggleTap()
          }
        }).catch(() => {
          this.$message.error('退出失败！')
        })
    },
    //搜索
    handleSearch() {
      if (this.search !== '') {
        // 用户搜索
        searchCustomerApi({ keyword: this.search })
          .then(res => {
            const list = (res?.data?.list || []).map(item => ({
              ...item,
              nickname: item.nickname
                ? item.nickname.split(this.search).join(`<span style='color:#FF5A1F;'>${this.search}</span>`)
                : item.nickname
            }))
            this.searchRes.contact = list
            this.searchRes.contactTotal = list.length
          })
          .catch(() => {})
        // 群聊搜索
        searchGroupApi({ keyword: this.search })
          .then(res => {
            const list = (res?.data?.list || []).map(item => ({
              ...item,
              nickname: item.nickname
                ? item.nickname.split(this.search).join(`<span style='color:#FF5A1F;'>${this.search}</span>`)
                : item.nickname,
              title: item.title
                ? item.title.split(this.search).join(`<span style='color:#FF5A1F;'>${this.search}</span>`)
                : item.title,
            }))
            this.searchRes.groupChat = list
            this.searchRes.groupChatTotal = list.length
          })
          .catch(() => {})
      } else {
        this.searchRes = {
          contact: [],
          groupChat: [],
          chatRecord: []
        }
      }
    },
    //置顶
    handleTop(item, type) {
      if (type === 'list') {
        item.topstatus = item.topstatus == 0 ? 1 : 0
      }
      const groupId = type === 'list' ? item.id : this.roomId
      markGroupApi({ group_id: groupId, is_mark: item.topstatus })
        .then(() => {
          if (type === 'list' && item.id == this.roomId) {
            this.roomInfo.topstatus = item.topstatus
          }
          this.handleGetRoomList()
        })
    },
    //屏蔽
    handleRemind(item, type) {
      if (type === 'list') {
        item.shieldstatus = item.shieldstatus == 0 ? 1 : 0
      }
      const groupId = type === 'list' ? item.id : this.roomId
      shieldGroupApi({ group_id: groupId, is_shield: item.shieldstatus })
        .then(() => {
          if (type === 'list' && item.id == this.roomId) {
            this.roomInfo.shieldstatus = item.shieldstatus
          }
        })
    },
    //关闭
    handleClose(item) {
      if (item.id === this.roomId) {
        this.isCloseRoom = true
      }
      if (this.roomList.length === 1) {
        window.close()
      }
      chatRoom.close(item.id)
    },
    //撤回
    handleRevoke(item) {
      const target = { conversationType: RongIMLib.ConversationType.GROUP, targetId: item.roomid || this.roomId }
      const sentTime = item._rcMsg?.sentTime || +new Date(item.addtime)
      RongIMLib.recallMessage(target, { messageUId: item.id, sentTime })
        .then(({ code }) => {
          if (code === 0) this.recreadCall(item)
        })
        .catch(() => {})
    },
    recreadCall(item) {
      if(item.roomid == this.roomId){
        let aiteRecreadIndex = this.aite_data.findIndex(k => k.messageid == item.id)
        this.aite_data.splice(aiteRecreadIndex,1)
        if(this.aite_data.length==0){
          this.checkAiteMsg = false
        }

        let index = this.messageList.findIndex(val => val.id === item.id)
        let msg = this.messageList.find(i => i.id === item.id)
        this.messageList.splice(index,1,{
          contenttype: 1,
          content: '撤回了一条消息',
          userid: msg.userid,
          nickname: msg.nickname,
          status: 2
        })

        if(item.id == this.forwardItem.id){
          this.$message.info('消息已被撤回')
          this.forwardDialog = false
          this.forwardItem = {}
          this.forwardCheckList = []
        }
      }
      for (const key in this.tableData) {
        if(this.tableData[key].id == item.roomid){
          this.$set(this.tableData[key],'content','撤回了一条消息')
          this.$set(this.tableData[key],'aite',0)
        }
      }
    },
    //聊天室列表右键
    roomListRight(item, event) {
      this.menuLeft = event.clientX
      this.menuTop = event.clientY
      this.menuVisible = false
      this.menuVisible = true
      this.roomRow = item
      setTimeout(() => {
        document.getElementById('room-content').addEventListener('click', this.foo)
        document.getElementById('room-content').addEventListener('contextmenu', this.foo)
      }, 50)
    },
    //头像右键
    headImgRight(item, event) {
      this.headImgLeft = event.clientX
      this.headImgTop = event.clientY
      this.headImgVisible = false
      this.headImgVisible = true
      this.headImgRow = item
      setTimeout(() => {
        document.getElementById('room-content').addEventListener('click', this.foo)
        document.getElementById('room-content').addEventListener('contextmenu', this.foo)
      }, 50)
    },
    //消息区域右键
    msgRight(item, event) {
      // if (this.isMe(item.userid) || item.contenttype == 6) {
        this.msgLeft = event.clientX
        this.msgTop = event.clientY
        this.msgRightVisible = false
        this.msgRightVisible = true
        this.msgRow = item
        setTimeout(() => {
          document.getElementById('room-content').addEventListener('click', this.foo)
          document.getElementById('room-content').addEventListener('contextmenu', this.foo)
        }, 50)
      // }
    },
    //关闭右键菜单
    foo(e) {
      e.preventDefault()
      // 取消鼠标监听事件 菜单栏
      this.menuVisible = false
      this.msgRightVisible = false
      this.headImgVisible = false
      document.getElementById('room-content').removeEventListener('click', this.foo)// 关掉监听，
      document.getElementById('room-content').removeEventListener('contextmenu', this.foo)// 关掉监听，
    },
    //收起后的成员列表滚动
    memberScroll(type) {
      let scrollWidth = this.$refs.members.scrollWidth - this.$refs.members.clientWidth
      if (type === 'right') {
        this.memberScrollLeft = this.memberScrollLeft + this.$refs.members.clientWidth > scrollWidth ? scrollWidth : this.memberScrollLeft + this.$refs.members.clientWidth
      } else {
        this.memberScrollLeft = this.memberScrollLeft - this.$refs.members.clientWidth < 0 ? 0 : this.memberScrollLeft - this.$refs.members.clientWidth
      }
      this.$refs.members.scrollTo({
        top: 0,
        left: this.memberScrollLeft,
        behavior: 'smooth'
      })
    },
    //是否是自己
    isMe(id) {
      return id == this.$store.state.userData.telphone
    },
    //获取房间列表（使用融云 + im-chat-backend）
    async handleGetRoomList(fn, msg) {
      const { getConversationList } = await import('@/util/im')
      const result = await getConversationList(50, 1).catch(() => null)
      if (!result) return

      // 将融云 + im-chat-backend 的会话列表规范化为旧系统 tableData 格式
      this.tableData = (result.data || []).map(item => {
        const lastMsg = item.latestMessage
        let content = ''
        let addtime = item.sentTime ? new Date(item.sentTime).toISOString().replace('T',' ').slice(0,19) : ''
        if (lastMsg) {
          addtime = new Date(lastMsg.sentTime).toISOString().replace('T',' ').slice(0,19)
          const t = lastMsg.messageType
          if (t === 'RC:TxtMsg') content = lastMsg.content?.content || ''
          else if (t === 'RC:ImgMsg' || t === 'RC:GIFMsg') content = '[图片]'
          else if (t === 'RC:FileMsg') content = '[文件]'
          else if (t === 'PX:OrderMsg') content = '[订单消息]'
          else if (t === 'PX:ProductMsg') content = '[商品链接]'
          else if (t === 'PX:EvaluationMsg') content = '[评价消息]'
          else if (t === 'PX:ReminderMsg') content = lastMsg.content?.content || '[提醒消息]'
          else if (t === 'RC:RcNtf') content = '撤回了一条消息'
          else content = '[消息]'
        }
        // type: 'private'→1, 'group'/'business'→3
        const rawType = item.type || 'private'
        const type = rawType === 'private' ? 1 : 3
        return {
          id: item.targetId,
          title: item.title || item.group_name || item.targetId,
          type,
          topstatus: item.topstatus || 0,
          shieldstatus: item.shieldstatus || 0,
          status: 0,
          unread: item.unreadMessageCount || 0,
          content,
          addtime,
          group_type: item.group_type || '',
          _rcConversation: item,
        }
      })

      this.getRoomOrderStatus()
      this.initial_tableData = JSON.parse(JSON.stringify(this.tableData))
      this.getDataList()

      if (fn === 'selectRoomList') {
        msg ? this.selectRoomList('msg', msg) : this.selectRoomList()
      }
    },
    getDataList() {
      let toparr = []
      let notoparr = []
      this.roomidList = []
      for (const k in this.tableData) {
        if(this.tableData[k].shieldstatus == 1){
          // this.tableData[k].unread = 0
        }
        if(this.tableData[k].topstatus == 1&&this.tableData[k].status == 0){
          toparr.push(this.tableData[k])
          this.roomidList.push(this.tableData[k].id)
        }
        if(this.tableData[k].topstatus == 0&&this.tableData[k].status == 0){
          notoparr.push(this.tableData[k])
          this.roomidList.push(this.tableData[k].id)
        }
      }
      this.toproomList = [...toparr]
      this.roomList = [...notoparr]
      this.topShow = toparr.length>0?true:false
    },
    /**
     * @description: 获取房间的订单交易状态
     * @return {*}
     */
    getRoomOrderStatus() {
      apiOrderList().then(rr => {
        let order_room_info = rr.data
        this.tableData.forEach(item => {
          this.$set(item, 'bs_order_status', order_room_info.find(v => v.group_room_id == item.id)?.status)
          // item.bs_order_status = order_room_info.find(v => v.group_room_id == item.id)?.status
        })
      })
    },
    //滚动到最上面加载历史消息
    mesScroll({srcElement}) {
      this.msgRightVisible = false
      if (srcElement.scrollHeight - srcElement.scrollTop < 1000) {
        this.isScrollBottom = true
      }else{
        this.isScrollBottom = false
      }
      if (srcElement.scrollTop === 0) {
        srcElement.scrollTop = 1
        if (!this.isGetOldMsg && this.messageList.length > 0) {
          this.page +=1
          this.handleGetOldMessage()
        }
      }
    },
    //获取历史消息
    handleGetOldMessage(v) {
      // if(this.roomId){
        this.loading = true
        this.isGetOldMsg = true
        this.unreadList = []
        this.checkAiteMsg = false
        this.aite_data = []
        this.page == 1?this.imgList = []: ''

        RongIMLib.getHistoryMessages(
          { conversationType: RongIMLib.ConversationType.GROUP, targetId: this.roomId },
          { timestamp: this.rcHistoryTimestamp || 0, count: this.pagesize || 20, order: 0 }
        ).then(({ code, data }) => {
          if(v!=''){
            this.isMute = v
          }else{
            this.isMute = false
          }
          // 融云 getHistoryMessages 返回 { list, hasMore }，消息数组在 data.list
          const list = (data && data.list) || []
          if (code !== 0 || list.length === 0) {
            this.isOldMsg = false
            this.isGetOldMsg = false
            return
          }
          // order:0 返回的 list 为时间升序（旧→新），取最早一条 sentTime 作为下一页（更早消息）游标
          this.rcHistoryTimestamp = list[0].sentTime
          this.isOldMsg = !!data.hasMore

          // 将融云消息转为 UI 格式并过滤不可见消息
          const adapted = list.map(rcMsg => this.adaptRCMessage(rcMsg)).filter(Boolean)
          const arr = []
          adapted.forEach((k, index) => {
              if(k.contenttype == 1){
                if(k.msgtype!=7){
                  //处理文本上的链接
                  let reg = /((http|https):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|])/g;
                  let urls = k.content.match(reg)
                  if(urls){
                    let sp = k.content.split(urls[0])
                    k.content = sp[0]+`<a href="${urls}" style="text-decoration: underline; color: var(--primary, #FF5A1F);" target="_blank">${urls}</a>`+sp[1]
                  }
                  arr.push(k)
                }
              } else if(k.contenttype === 'rc_order' || k.contenttype === 'rc_product' || k.contenttype === 'rc_evaluation' || k.contenttype === 'rc_aftersales') {
                // 融云自定义消息（结构化对象，直接推送）
                arr.push(k)
              } else if(k.contenttype == 4||k.contenttype == 3) {
                let content = JSON.parse(k.content)
                const image = new Image()
                let _this = this
                image.src = content.url
                image.onload = function() {
                  content.width = content.width?content.width:image.width
                  content.height = content.height?content.height:image.height

                   k.content = content
                  if (k.content.width > k.content.height && k.content.width > 200) {
                    k.content.w = k.content.width
                    k.content.h = k.content.height
                    //图片宽比高长并且宽超过200px
                    k.content.height = k.content.height / (k.content.width / 183)
                    k.content.width = 183
                  } else if (k.content.height > 200) {
                    k.content.w = k.content.width
                    k.content.h = k.content.height
                    //图片高比宽长并且宽超过200px
                    k.content.width = k.content.width / (k.content.height / 200)
                    k.content.height = 200
                  }
                  if (k.content.url.indexOf('https://images-kefu.pxb7.com') !== -1) {
                    //缩略图?x-oss-process=image/resize,m_lfit,h_100,w_100
                    k.content.thumbnail = `${k.content.url}?x-oss-process=image/resize,m_lfit,h_${Math.round(k.content.height)},w_${Math.round(k.content.width)}`
                    // k.content.thumbnail = `${k.content.url}?width=${Math.round(k.content.width)}&height=${Math.round(k.content.height)}`
                  } else {
                    //缩略图
                    k.content.thumbnail = `${k.content.url}`
                  }
                }
                k.content = content
                if (k.content.width > k.content.height && k.content.width > 200) {
                  k.content.w = k.content.width
                  k.content.h = k.content.height
                  //图片宽比高长并且宽超过200px
                  k.content.height = k.content.height / (k.content.width / 183)
                  k.content.width = 183
                } else if (k.content.height > 200) {
                  k.content.w = k.content.width
                  k.content.h = k.content.height
                  //图片高比宽长并且宽超过200px
                  k.content.width = k.content.width / (k.content.height / 200)
                  k.content.height = 200
                }
                if (k.content.url.indexOf('https://images-kefu.pxb7.com') !== -1) {
                  //缩略图?x-oss-process=image/resize,m_lfit,h_100,w_100
                  k.content.thumbnail = `${k.content.url}?x-oss-process=image/resize,m_lfit,h_${Math.round(k.content.height)},w_${Math.round(k.content.width)}`
                  // k.content.thumbnail = `${k.content.url}?width=${Math.round(k.content.width)}&height=${Math.round(k.content.height)}`
                } else {
                  //缩略图
                  k.content.thumbnail = `${k.content.url}`
                }
                arr.push(k)
                this.imgList.unshift(k.content.url)
              } else if(k.contenttype == 6){
                let content = JSON.parse(k.content)
                k.content = content
                if(k.content.filetype == 'video/mp4'){
                  k.video = true
                }else {
                  k.video = false
                }
                arr.push(k)
              } else if(k.contenttype == 7){
                if(k.msgtype==15||k.msgtype==16||k.msgtype==18||k.msgtype==19||k.msgtype==20||k.msgtype==24){
                  let con = JSON.parse(k.content)
                  if(k.msgtype==24){
                    k.senduserid = con.userid
                    if(this.isMe(k.senduserid)){
                      k.content = '您已催一催客服，正在加急处理中~'
                    }else{
                      let nick = this.roomMember.find(v => {
                        if(v.userid.indexOf(k.senduserid)>-1){
                          return v
                        }
                      })
                      k.sendnickname = nick.nickname
                      k.content = k.sendnickname+'已催一催客服，正在加急处理中~'
                    }
                  }else{
                    k.content = con.content
                  }
                  arr.push(k)
                }
                // if(k.msgtype == 10) {
                //   if(k.roomid==this.roomId){
                //     this.evid = JSON.parse(k.content).evid
                //     this.scoreShow = true
                //   }
                // }
              } else if(k.contenttype == 9) {
                let content = JSON.parse(k.content)
                k.content = content.content
                //处理文本上的链接
                let reg = /((http|https):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|])/g;
                let urls = k.content.match(reg)
                if(urls){
                  let sp = k.content.split(urls[0])
                  k.content = sp[0]+`<a href="${urls}" style="text-decoration: underline; color: var(--primary, #FF5A1F);" target="_blank">${urls}</a>`+sp[1]
                }
                arr.push(k)
              } else if(k.contenttype == 8) {
                let con = JSON.parse(k.content)
                if(con.content.indexOf('div')!=-1){
                  let patt = /onclick=['"]([^""]+)['"]+/g
                  let patts = /openExternal['(]([^""]+)[')]+/g
                  let linka = patts.exec(con.content)[1]
                  let sp = con.content.split(patt.exec(con.content)[0])
                  con.content = sp[0]+`onclick="window.open(${linka},'_blank')"`+sp[1]
                  k.content = con.content

                  let input = k.content.match(/<input.*?>/gi)[0]
                  let pay_type_input = k.content.match(/<input.*?>/gi)[1]
                  let order = {}
                  let key = input.replace(/.*id="(.+?)".*/, "$1")
                  order[key] = input.replace(/.*value="(.+?)".*/, "$1")
                  let payType = pay_type_input.replace(/.*value="(.+?)".*/, "$1")
                  // 1 线下 2 在线
                  k.pay_type = payType
                  apiOrderDetail({client:'front',order_id:order[key]}).then(res=> {
                    this.$set(k,'order_status',res.data.order_status)
                    this.$set(k,'order_no',res.data.order_no)
                    this.$set(k,'order_id',res.data.id)
                    this.$set(k,'order_amount',res.data.order_amount)
                    this.$set(k,'buy_user_id',res.data.buy_user_id)
                    this.$set(k,'user_id',this.$store.state.userData.user_id)
                    this.$set(k,'product_id',res.data.order_info[0]?.goods_id)
                    this.$set(k,'game_id',res.data.game_id)
                  })
                  arr.push(k)
                  this.$forceUpdate()
                }else{
                  k.content = con.content
                  if(k.content.match(/<input.*?>/gi)){
                    let input = k.content.match(/<input.*?>/gi)[0]
                    let user = {}
                    let key = input.replace(/.*id="(.+?)".*/, "$1")
                    user[key] = input.replace(/.*value="(.+?)".*/, "$1")
                    if(user[key] == this.$store.state.userData.user_id){
                      //处理文本上的链接
                      // let reg = /((http|https):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|])/g;
                      // let urls = k.content.match(reg)
                      // if(urls){
                      //   let sp = k.content.split(urls[0])
                      //   k.content = sp[0]+`<a href="${urls}"style="text-decoration: underline; color: var(--primary, #FF5A1F);" target="_blank">${urls}</a>`+sp[1]
                      // }
                      arr.push(k)
                    }
                  }else{
                    let reg = /((http|https):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|])/g;
                    let urls = k.content.match(reg)
                    if(urls){
                      let sp = k.content.split(urls[0])
                      k.content = sp[0]+`<a href="${urls}"style="text-decoration: underline; color: var(--primary, #FF5A1F);" target="_blank">${urls}</a>`+sp[1]
                      arr.push(k)
                    }else{
                      arr.push(k)
                    }
                  }
                }
              } else if(k.contenttype == 5) {
                let patt = /onclick=['"]([^""]+)['"]+/g
                let patts = /openExternal['(]([^""]+)[')]+/g
                // if(patts.exec(k.content)){
                  let linka = patts.exec(k.content)[1]
                  let sp = k.content.split(patt.exec(k.content)[0])
                  k.content = sp[0]+`onclick="window.open(${linka},'_blank')"`+sp[1]
                  arr.push(k)
                // }
              } else if(k.contenttype == 10){
                let content = JSON.parse(k.content)
                k.content = content
                k.content.msglist.forEach((item,index) => {
                  k.content.msglist[index] = JSON.parse(item)
                })
                arr.push(k)
              }
            });
            // arr 为时间升序（旧→新），更早的整页消息直接前插，保持顺序
            this.messageList = [ ...arr,...this.messageList]
            if(this.page == 1){
              setTimeout(() => {
                this.$nextTick(() => {
                  this.scrollBottom()
                })
              },400)
            }

            setTimeout(() => {
              this.messageList.forEach(item => {
                if(item.shouldusers&&item.shouldusers.length>0){
                  item.shouldusers.forEach(v => {
                    if(v.userid == this.$store.state.userData.telphone){
                      this.unreadList.push(item.id)
                    }
                  })
                }
              })
              this.goRead()
            },1500)
          this.isGetOldMsg = false
        }).catch(() => {
          this.isGetOldMsg = false
        })
      // }
    },
    handleSendMessage() {
      let msg = this.message.replaceAll(/<div><\/div>|<div><br\/><\/div>|<div><br><\/div>|<div>|<\/div>|<span class="at-text">|<\/span>/g, ' ')
      if (msg.match(/^[ ]*$/)) {
        this.$message.error('不能发空消息！')
        return
      }
      let div = document.createElement('div')
      div.innerHTML = msg
      this.editText(msg)
      this.message = `<div></div>`
    },
    /**
     * @description: 检测是否base64
     * @param {*} s
     * @return {*}
     */
    validDataUrl(s) {
      let str = s.toString()
      if(str.indexOf(';base64,')==-1){
        return true;
      }else{
        return false
      }
    },
    editText(msg){
      // msg
      let text = msg
      let s=text.match(/<img\s*src=\"([^\"]*?)\"[^>]*>/gi);
      if(s == null){
        this.handleSendText(text)
      } else {
        for(let i= 0;i<s.length;i++){
          text=text.replace(s[i],'<split>'+s[i]+'<split>')
        }
        let list = text.split('<split>');
        list.map(item=>{
          if(s.includes(item)){
            let content = {};
            let separate = item.split(' ')
            separate.map(val => {
              if(val.indexOf('src') !== -1) {
                content.url= val.replace('src=','').replaceAll('"','')
              } else if(val.indexOf('filename') !== -1){
                content.filename= val.replace('filename=','').replaceAll('"','')
              } else if(val.indexOf('widths') !== -1) {
                content.width= val.replace('widths=','').replaceAll('"','')
              } else if(val.indexOf('heights') !== -1) {
                content.height= val.replace('heights=','').replaceAll('"','')
              }
            })
              if(this.validDataUrl(item)){
                this.isScrollBottom = true
                const target = { conversationType: RongIMLib.ConversationType.GROUP, targetId: this.roomId }
                const imgUrl = content.url || ''
                RongIMLib.sendMessage(target, new RongIMLib.ImageMessage({ content: imgUrl, imageUri: imgUrl }))
                  .then(({ code, data: rcMsg }) => {
                    if (code !== 0) { this.errorSend(); return }
                    const value = this.adaptRCMessage(rcMsg)
                    if (value) this.getIpList(value)
                  })
                  .catch(() => this.errorSend())
              }
            // } else {
            //   // 离线
            //   chatApi.sendOffline({
            //     content: JSON.stringify({
            //       filename:content.filename,
            //       url:content.url,
            //       width:content.width,
            //       height:content.height
            //     }),
            //     contenttype: 4,
            //     format: 'json',
            //     groupcode: this.grouptitle
            //   }).then(res => {
            //     let msg = JSON.parse(Decrypt(res.msg))
            //     msg.userid = this.$store.state.userData.telphone
            //     msg.msgtype = 2
            //     this.getIpList(msg)
            //   }).catch(err => {
            //     this.$message.error('当前存在客服在线，请返回与在线客服沟通')
            //   })
            // }
          }else{
            if(item !== ''){
              let msg = this.message.replaceAll(/<div><\/div>|<div><br\/><\/div>|<div><br><\/div>|<div>|<\/div>|<span class="at-text">|<\/span>/g, ' ')
              if (msg.match(/^[ ]*$/)) {
                return
              }else{
                this.handleSendText(item)
              }
            }
          }
        })
      }
    },
    //发送文本消息（使用融云 SDK）
    handleSendText(text) {
      if (!text || text.match(/^[ ]*$/)) return
      this.isScrollBottom = true
      const target = { conversationType: RongIMLib.ConversationType.GROUP, targetId: this.roomId }
      RongIMLib.sendMessage(target, new RongIMLib.TextMessage({ content: text }))
        .then(({ code, data: rcMsg }) => {
          if (code !== 0) { this.errorSend(); return }
          const value = this.adaptRCMessage(rcMsg)
          if (value) this.getIpList(value)
        })
        .catch(() => this.errorSend())
    },
    //文件上传
    async upload(data, key) {
      return chatRoom.sendMsg(data, (e) => this.progressFun(e, key)).then(res => {
        let index = this.uploadFiles.findIndex(item => item.key === key)
        this.uploadFiles[index].rate = 100
        this.uploadFiles[index].msg = '上传成功'
        setTimeout(() => {
          let index = this.uploadFiles.findIndex(item => item.key === key)
          this.uploadFiles.splice(index, 1)
        }, 2000)
      }).catch(err => {
        let index = this.uploadFiles.findIndex(item => item.key === key)
        this.uploadFiles[index].rate = 100
        this.uploadFiles[index].msg = '上传失败'
        setTimeout(() => {
          let index = this.uploadFiles.findIndex(item => item.key === key)
          this.uploadFiles.splice(index, 1)
        }, 2000)
      })
    },
    //文件下载
    downLoad(item) {
      const x = new window.XMLHttpRequest();
      x.open('GET', item.content.url, true);
      x.responseType = 'blob';
      x.onload = () => {
          const url = window.URL.createObjectURL(x.response);
          const a = document.createElement('a');
          a.href = url;
          a.download = item.content.filename;
          a.click();
      };
      x.send();
      // let link = document.createElement('a')
      // link.href = item.content.url
      // link.target = '_black'
      // link.setAttribute('download', item.content.filename) //指定下载后的文件名，防跳转
      // link.click()
    },
    //文件上传进度条
    progressFun(e, key) {
      if (e.lengthComputable) {
        let file = this.uploadFiles.find(item => item.key === key)
        let rate = e.loaded / e.total * 100 //已上传的比例
        if (rate < 100) {
          //这里的进度只能表明文件已经上传到后台，但是后台有没有处理完还不知道
          //因此不能直接显示为100%，不然用户会误以为已经上传完毕，关掉浏览器的话就可能导致上传失败
          //等响应回来时，再将进度设为100%
          file.rate = rate
        } else {
          file.rate = 99
        }
      }
    },
    //消息框滚动到最下面
    scrollBottom() {
      if (this.isScrollBottom) {
        // 聊天定位到底部
        let chatMain = this.$refs.messagesContainer    //通过$refs获取到该元素
        if(chatMain){
          setTimeout(() => {
            chatMain.scrollTop = chatMain.scrollHeight
          },100)
          this.checkNewMsg = false
        }
      } else {
        this.checkNewMsg = true
      }
    },
    /**
     * 查看新消息点击事件
     */
    newMsgClick() {
      this.isScrollBottom = true
      this.scrollBottom()
    },
    /**
     * @description: 查看'@'消息点击事件
     * @return {*}
     */
    aiteMsgClick() {
      if(this.aite_data.length>0){
        this.scrollIntoView(this.aite_data[0].messageid)
      }
    },
    //文件格式转换
    formatFileSize(fileSize) {
      if (fileSize < 1024) {
        return fileSize + 'B'
      } else if (fileSize < (1024 * 1024)) {
        let temp = fileSize / 1024
        temp = temp.toFixed(2)
        return temp + 'KB'
      } else if (fileSize < (1024 * 1024 * 1024)) {
        let temp = fileSize / (1024 * 1024)
        temp = temp.toFixed(2)
        return temp + 'MB'
      } else {
        let temp = fileSize / (1024 * 1024 * 1024)
        temp = temp.toFixed(2)
        return temp + 'GB'
      }
    },
    //计算时间
    intervalTime(startTime, endTime) {
      let timestamp = (Date.parse(new Date())) / 1000;//计算当前时间戳 (毫秒级)
      let date1 = ""; //开始时间
      if (timestamp < startTime) {
        date1 = startTime;
      } else {
        date1 = timestamp; //开始时间
      }
      let date2 = endTime; //结束时间
      // var date3 = date2.getTime() - date1.getTime(); //时间差的毫秒数
      let date3 = (date2 - date1) * 1000; //时间差的毫秒数
      //计算出相差天数
      let days = Math.floor(date3 / (24 * 3600 * 1000));
      //计算出小时数

      let leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      let hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      let minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数
      let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      let seconds = Math.round(leave3 / 1000);
      if (days > 0) {
        return days + "天" + hours + "小时 " + minutes + "分钟"
      } else if (hours > 0) {
        return hours + "小时" + minutes + "分钟"
      } else if (minutes > 0) {
        return minutes + "分钟"
      } else if (seconds > 0) {
        return "1分钟"
      } else {
        return false
      }
    },
  }
}
</script>

<style scoped>
.mes-item >>> p, .room-new-msg >>> p {
  margin: 0;
}
</style>
<style lang="less">
.customer-offline-msg {
  min-width: 110px !important;
  min-height: 40px;
  max-width: 245px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.70) !important;
  border-radius: 4px !important;
  padding: 10px;

  .el-message__content {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: #ffffff !important;
  }

  .el-message__icon {
    display: none;
  }
}
.room_forwardDialog{
  border-radius: 4px !important;
  padding: 0;
  height: 420px;
  .el-dialog__header {
    display: none;
    padding: 0;
  }

  .el-dialog__body {
    padding: 0 !important;
    background: transparent;
  }
  #room_forwardDialog{
    display: flex;
    justify-content: space-between;
    align-items: center;
    >div{
      flex: 1;
      height: 420px;
      box-sizing: border-box;
    }
    .forward-left{
      background: #F8F8F8;
      border-radius: 4px 0 0 4px;
      .forward-top{
        padding: 10px;
      }
      .forword-soon{
        margin: 0 25px 5px;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
      }
      .forword-list{
        .no-data-img{
          display: flex;
          justify-content: center;
          margin-top: 10px;
          img{
            width: 130px;
            height: 114px;
          }
        }
      }
      .el-input__inner{
        border-radius: 4px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        // margin: 10px;
        width: 250px;
      }
      .el-input__icon{
        line-height: 40px;
      }
      .forword_checkbox{
        padding: 0 25px;
        overflow-y: auto;
        height: 335px;
        .el-checkbox{
          display: flex;
          justify-content: space-between;
          flex-direction: row-reverse;
          align-items: center;
          margin: 0;
          flex: 1;
          .el-checkbox__label{
            padding: 0;
            display: flex;
            align-items: center;
            margin: 5px 0;
            .line-leave{
              position: relative;
              -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
              filter: grayscale(100%);
              &::after{
                position: absolute;
                bottom: 5px;
                left: 0;
                content: '离线';
                display: block;
                width: 40px;
                height: 18px;
                background: rgba(0, 0, 0, 0.35);
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                line-height: 18px;
                text-align: center;
                font-size: 12px;
                border-radius: 0 0 4px 4px;
              }
            }
            .line-busy{
              position: relative;
              // -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
              // filter: grayscale(100%);
              &::after{
                position: absolute;
                bottom: 5px;
                left: 0;
                content: '忙碌';
                display: block;
                width: 40px;
                height: 18px;
                background: rgba(0, 0, 0, 0.35);
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                line-height: 18px;
                text-align: center;
                font-size: 12px;
                border-radius: 0 0 4px 4px;
              }
            }
            img{
              width: 40px;
              height: 40px;
              margin-right: 10px;
              border-radius: 4px;
            }
            em{
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              max-width: 85px;
              font-style: normal;
            }
            span{
              width: 28px;
              display: inline-block;
              height: 16px;
              background: #F0EDE8;
              border-radius: 4px 4px 4px 4px;
              font-size: 12px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 16px;
              text-align: center;
              margin-left: 5px;
            }
          }
        }
      }
    }
    .forword-right{
      .right-send{
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        height: 40px;
        line-height: 40px;
        margin: 10px 25px;
      }
      .right-list{
        padding: 0 25px;
        overflow-y: auto;
        height: 300px;
        .right-list-item{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 10px 0;
          div{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            em{
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              max-width: 85px;
              font-style: normal;
            }
            span{
              width: 28px;
              display: inline-block;
              height: 16px;
              background: #F0EDE8;
              border-radius: 4px 4px 4px 4px;
              font-size: 12px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 16px;
              text-align: center;
              margin-left: 5px;
            }
            img{
              margin-right: 10px;
              width: 40px;
              height: 40px;
              border-radius: 4px;
            }
          }
          i{
            color: #d9d9d9;
            cursor: pointer;
            &:hover{
              color: #F56B6C;
            }
          }
        }
      }
      .right-btn{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 10px;
        border-top: 1px solid #D4DAE3;
        padding: 15px 12px;
        button{
          width: 106px;
          height: 30px;
          border-radius: 4px;
          border: 1px solid var(--primary, #FF5A1F);
          cursor: pointer;
          &:first-child{
            background: #fff;
            color: var(--primary, #FF5A1F);
          }
          &:last-child{
            background: var(--primary, #FF5A1F);
            color: #fff;
          }
        }
        .el-button{
          padding: 0;
        }
      }
    }
  }
}
.room_historyDialog{
  border-radius: 4px !important;
  padding: 15px;
  height: 450px;
  .el-dialog__header {
    display: none;
    padding: 0;
  }

  .el-dialog__body {
    padding: 0 !important;
    background: transparent;
  }
  #room_historyDialog{
    .his_header{
      display: flex;
      justify-content: space-between;
      div{
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
      }
      img{
        width: 18px;
        height: 18px;
      }
    }
    .his_title{
      margin: 9px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img{
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 13px;
      }
      span{
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow:ellipsis;
      }
    }
    .hd_body{
      .chatMain{
        height: 315px;
        overflow-y: auto;
        .his_item{
          padding: 10px 14px;
          border-bottom: 1px solid #F2F2F2;
          .item_top{
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
            .user-name{
              font-size: 12px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
            }
            .time{
              font-size: 12px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #C3CBD2;
            }
          }
          .merge-msg{
            max-width: 300px;
            width: 300px;
            border: 1px solid #EBEEF3;
            padding: 8px;
            border-radius: 4px;
            cursor: pointer;
            .merge-msg-title{
              font-size: 14px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #191919;
              margin-bottom: 5px;
            }
            .merge-msg-list{
              .merge-msg-item{
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #B2B2B2;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
              }
            }
            .merge-msg-bottom{
              font-size: 12px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #B2B2B2;
              border-top: 1px solid #EBEEF3;
              margin-top: 8px;
              padding-top: 8px;
            }
          }
          .user{
            color: var(--text-main, #1A1D24);
          }
          .customer{
            color: #17B67C;
          }
          .his_item_main{
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #1A1D24;
          }
          .send_link_item{
            a{
              border: 1px solid #E9E9E9;
            }
          }
          .file_wrapper{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
            img{
              width: 16px;
              height: 16px;
              margin-right: 6px;
            }
          }
        }
        .no_history{
          text-align: center;
          padding-top: 40px;
          img{
            width: 150px;
            height: 128.5px;
          }
        }
        .noMoreHistory{
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #C9CCD0;
          text-align: center;
        }
      }
    }
    .el-input__inner{
      border-radius: 4px;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
    }
    .el-input__icon{
      line-height: 30px;
    }
  }
}
.room-merge-dialog{
  border-radius: 4px !important;
  padding: 15px;
  height: 450px;
  .el-dialog__header {
    display: none;
    padding: 0;
  }

  .el-dialog__body {
    padding: 0 !important;
    background: transparent;
  }
  #room-merge-ialog{
    .his_header{
      display: flex;
      justify-content: space-between;
      div{
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
      }
      img{
        width: 18px;
        height: 18px;
      }
    }
    .hd_body{
      .chatMain{
        height: 410px;
        overflow-y: auto;
        .his_item{
          padding: 10px 14px;
          border-bottom: 1px solid #F2F2F2;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          .mergeImg{
            margin-right: 10px;
            img{
              width: 30px;
              height: 30px;
              border-radius: 50%;
            }
          }
          .mergeMain{
            flex: 1;
          }
          .item_top{
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
            .user-name{
              font-size: 12px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
            }
            .time{
              font-size: 12px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #C3CBD2;
            }
          }
          .merge-msg{
            max-width: 300px;
            width: 300px;
            border: 1px solid #EBEEF3;
            padding: 8px;
            border-radius: 4px;
            cursor: pointer;
            .merge-msg-title{
              font-size: 14px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #191919;
              margin-bottom: 5px;
            }
            .merge-msg-list{
              .merge-msg-item{
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #B2B2B2;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
              }
            }
            .merge-msg-bottom{
              font-size: 12px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #B2B2B2;
              border-top: 1px solid #EBEEF3;
              margin-top: 8px;
              padding-top: 8px;
            }
          }
          .user{
            color: #B6B6B6;
          }
          .customer{
            color: #17B67C;
          }
          .his_item_main{
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #1A1D24;
          }
          .file_wrapper{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
            img{
              width: 16px;
              height: 16px;
              margin-right: 6px;
            }
          }
        }
        .no_history{
          text-align: center;
          padding-top: 40px;
          img{
            width: 150px;
            height: 128.5px;
          }
        }
        .noMoreHistory{
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #C9CCD0;
          text-align: center;
        }
      }
    }
  }
}
</style>
<style scoped lang="less">
.mt-10 {
  margin-top: 10px;
}

.mb-10 {
  margin-bottom: 10px;
}

.room-content {
  // 独立聊天页(chatRoom)不在 Layout 下,body 回落 serif/Times;显式套用设计字体栈(theme.css / DESIGN 基线)
  font-family: "HarmonyOS Sans SC", -apple-system, "PingFang SC", "Microsoft YaHei", sans-serif;
  user-select: text;
  position: relative;
  width: 100vw;
  // max-width: 1140px;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: stretch;
  background: var(--bg-page, #F7F5F2);

  ::-webkit-scrollbar {
    width: 8px; /*对垂直流动条有效*/
    height: 10px; /*对水平流动条有效*/
  }

  /*定义滚动条的轨道颜色、内阴影及圆角*/

  ::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0);
    border-radius: 3px;
  }


  /*定义滑块颜色、内阴影及圆角*/

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #F7F5F2;
  }

  .audio {
    position: fixed;
    z-index: -1;
  }

  .room-box {
    background-color: transparent;
    position: relative;
    width: 1240px;
    max-width: calc(100% - 32px);
    height: calc(100vh - 24px);
    margin: 12px 0;
    display: flex;
    flex-direction: column;
    min-height: 0;
    >.title {
      flex: none;
      height: 56px;
      background: var(--bg-dark, #1A1D24);
      opacity: 1;
      border-radius: 4px;
      padding: 0 24px 0 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .info {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 700;
        color: #FFFFFF;
        letter-spacing: 1px;

        .logo-mark {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 38px;
          height: 38px;
          margin: 0 16px 0 0;
          padding: 5px;
          background: #FFFFFF;
          transform: skewX(-12deg);
          box-sizing: border-box;

          img {
            width: 100%;
            height: 100%;
            transform: skewX(12deg);
          }
        }

        span {
          font-size: 13px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
        }

        .divide {
          margin: 0 12px;
          width: 1px;
          height: 14px;
          display: inline-block;
          background: var(--text-muted, #9AA0AC);
          opacity: .55;
        }
      }

      .url, .url * {
        font-size: 13px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        color: var(--text-muted, #9AA0AC);
        line-height: 15px;
      }
      .url a {
        color: #FFFFFF;
        text-decoration: none;
        &:hover { color: var(--primary, #FF5A1F); }
      }
    }
    .room-main{
      display: flex;
      gap: 12px;
      margin-top: 12px;
      flex: 1;
      min-height: 0;
      width: auto;
      box-shadow: none;
    }
    .col-head {
      flex: none;
      display: flex;
      align-items: center;
      gap: 9px;
      padding: 13px 16px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);

      .ch-bar {
        width: 3px;
        height: 16px;
        background: var(--primary, #FF5A1F);
        transform: skewX(-12deg);
        display: block;
        flex: none;
      }
      h3 {
        margin: 0;
        font-size: 15px;
        font-weight: 800;
        color: var(--text-main, #1A1D24);
        letter-spacing: -.3px;
      }
      .ch-cnt {
        margin-left: auto;
        font-size: 12px;
        color: var(--text-muted, #9AA0AC);
        font-weight: 700;
      }
    }
    .left {
      position: relative;
      z-index: 2;
      flex: 0 0 280px;
      min-width: 280px;
      max-width: 280px;
      height: 100%;
      display: flex;
      flex-direction: column;
      min-height: 0;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      overflow: hidden;

      .search {
        flex: none;
        margin: 12px 12px 6px;
        display: flex;
        align-items: center;

        .come-back {
          width: 60px;
          height: 30px;
          background: var(--bg-tag, #F0EDE8);
          border-radius: 4px;
          font-size: 16px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          text-align: center;
          line-height: 30px;
          margin-left: 10px;
          cursor: pointer;
        }

        ::v-deep.el-input__prefix {
          line-height: 40px;
          color: var(--text-muted, #9AA0AC);
        }

        ::v-deep.el-input__inner {
          border-radius: 4px;
          border-color: var(--border-soft, #E8E4DE);
          background: var(--bg-tag, #F0EDE8);

          &::placeholder {
            color: var(--text-muted, #9AA0AC);
          }

          &:focus {
            border-color: var(--primary, #FF5A1F);
          }
        }
      }

      .room-list {
        overflow-y: auto;
        flex: 1;
        min-height: 0;

        .title-tip{
          height: 28px;
          background: var(--bg-page, #F7F5F2);
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          line-height: 28px;
          margin-top: 5px;
          text-indent: 20px;
        }
        &::-webkit-scrollbar {
          width: 0px; /*对垂直流动条有效*/
        }

        &:hover {
          &::-webkit-scrollbar {
            // width: 8px; /*对垂直流动条有效*/
          }

          .room-item {
            // padding-right: 12px;
          }
        }

        .room-item {
          &:hover {
            background: var(--bg-tag, #F0EDE8);
            .room-new-msg{
              .close_room{
                i{
                  display: block;
                }
              }
            }
          }

          &.active {
            position: relative;
            background-color: var(--primary-soft, #FCEDE5);

            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 3px;
              height: 100%;
              background: var(--primary, #FF5A1F);
            }

            &::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 0;
              height: 0;
              border-top: 7px solid var(--primary, #FF5A1F);
              border-right: 7px solid transparent;
            }

            .room-name {
              color: var(--primary, #FF5A1F);
            }
          }

          &.top {
            position: relative;

            // &::after {
            //   content: '';
            //   position: absolute;
            //   width: 30px;
            //   height: 15px;
            //   background: #53E3B9;
            //   transform: rotate(135deg);
            //   top: -2px;
            //   left: -9px;
            // }
          }

          display: flex;
          align-items: center;
          padding: 10px;
          overflow: hidden;
          cursor: default;

          .icon {
            width: 48px;
            height: 48px;
            border-radius: 4px;
            background: var(--bg-tag, #F0EDE8);
          }
          .line-leave{
            position: relative;
            -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
            filter: grayscale(100%);
            &::after{
              position: absolute;
              bottom: 0;
              left: 0;
              content: '离线';
              display: block;
              width: 48px;
              height: 18px;
              border-radius: 0 0 4px 4px;
              background: rgba(0, 0, 0, 0.35);
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              line-height: 18px;
              text-align: center;
              font-size: 12px;
            }
          }
          .line-busy{
            position: relative;
            // -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
            // filter: grayscale(100%);
            &::after{
              position: absolute;
              bottom: 0;
              left: 0;
              content: '忙碌';
              display: block;
              width: 48px;
              height: 18px;
              border-radius: 0 0 4px 4px;
              background: rgba(0, 0, 0, 0.35);
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              line-height: 18px;
              text-align: center;
              font-size: 12px;
            }
          }
          ::v-deep.el-badge__content {
            border: 0;
          }

          .room-name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 140px;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 600;
            color: #282828;
            line-height: 19px;
          }
          .bs-order-status{
            max-width: 73px;
            img{}
          }

          .room-new-msg {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 5px;
            height: 20px;
            .close_room{
              width: 14px;
              color: #F56B6C;
              i{
                display: none;
              }
            }
            .text {
              display: flex;
              width: 108px;
              margin-top: 4px;
              font-size: 13px;
              font-family: PingFang SC-Light, PingFang SC;
              font-weight: 300;
              color: #A5ACB4;
              line-height: 16px;
              max-height: 16px;
              max-width: 108px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .room-type {
              // padding: 3px 7px;
              width: 32px;
              height: 17px;
              font-size: 12px;
              border-radius: 4px 4px 4px 4px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              text-align: center;
              color: #ffffff;
            }

            .room-type-1 {
              background-color: #F0EDE8;
            }

            // .room-type-2 {
            //   background-color: #11CB5B;
            // }

            // .room-type-3 {
            //   background-color: #F7F5F2;
            // }
          }

          .msg-time {
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #A5ACB4;
            line-height: 14px;
          }
        }
        .top-up{
          background: var(--bg-page, #F7F5F2);
        }
      }

      .search-list {
        overflow-y: auto;
        flex: 1;
        min-height: 0;

        .search-label {
          font-size: 14px;
          font-family: PingFang SC-Light, PingFang SC;
          font-weight: 300;
          color: #A5ACB4;
          line-height: 16px;
          padding-left: 20px;
        }

        .list {
          // padding-left: 20px;
          overflow: hidden;
          transition: height 0.3s linear;

          .item {
            display: flex;
            align-items: center;
            padding: 10px 0 10px 20px;
            cursor: default;

            &:hover {
              background: #E6E9EF;
            }

            .image {
              width: 50px;
              height: 50px;
              background: #F0F2F4;
              border-radius: 50%;
              /deep/ img{
                width: 50px;
                height: 50px;
              }
            }

            .label {
              margin-left: 15px;
              width: 200px;
              overflow: hidden;

              .text1 {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 16px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #282828;
                line-height: 19px;
              }

              .text2 {
                font-size: 14px;
                font-family: PingFang SC-Light, PingFang SC;
                font-weight: 300;
                color: #A5ACB4;
                line-height: 16px;
                padding-left: 3px;
                margin-top: 2px;
              }
            }
          }
        }

        .expansion-box {
          margin-bottom: 17px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
          height: 33px;
          line-height: 33px;
          background: #F7F7F8;
          font-size: 14px;
          font-family: PingFang SC-Light, PingFang SC;
          font-weight: 300;
          color: #A5ACB4;

          &:hover {
            color: #F0EDE8;
          }

          i {
            transition: transform 0.2s linear;
          }

          &.expansion {
            i {
              transform: rotate(180deg);
            }
          }
        }
      }
    }

    .room-chat {
      position: relative;
      height: 100%;
      background-color: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      flex: 1;
      min-width: 0;
      .chatHeader {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px 18px 0;

        .currentCustomerService {
          width: calc(100% - 17px);
          display: flex;
          align-items: center;
          height: 38px;
          background: var(--bg-tag, #F0EDE8);
          border-radius: 4px;
          opacity: 1;
          border: 1px solid var(--border-soft, #E8E4DE);
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          color: var(--text-secondary, #5A5F6B);

          .complain {
            padding: 5px 14px;
            background: var(--bg-dark, #1A1D24);
            border-radius: 4px;
            margin: 0 20px 0 0;
          }
        }

        .danger-tip{
          width: calc(100% - 17px);
          height: 35px;
          background: var(--danger, #FF2D55);
          border-radius: 4px;
          margin-top: 10px;
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          text-indent: 9px;
          line-height: 35px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          i{
            font-size: 16px;
          }
          .fpzn{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 94px;
            height: 27px;
            background: #FFFFFF;
            border-radius: 4px;
            margin-right: 6px;
            font-size: 12px;
            font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
            font-weight: normal;
            color: #696969;
            line-height: 27px;
            cursor: pointer;
            img{
              width: 15px;
              height: 15px;
              margin-right: -3px;
            }
          }
        }

        .historyRecord {
          margin: 10px 0 0;
          width: 140px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          font-size: 12px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: var(--text-secondary, #5A5F6B);
          cursor: pointer;
          background: var(--bg-tag, #F0EDE8);
          border-radius: 4px;
        }

      }
      // .room-title {
      //   position: relative;
      //   z-index: 1;
      //   height: 24px;
      //   background: #FFDB51;
      //   box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
      //   color: #000000;
      //   text-align: center;
      //   padding: 8px 0;

      //   .room-remark {
      //     font-size: 14px;
      //     font-family: PingFang SC-Regular, PingFang SC;
      //     font-weight: 400;
      //     line-height: 21px;
      //   }

      //   .room-name {
      //     font-size: 18px;
      //     font-family: PingFang SC-Regular, PingFang SC;
      //     font-weight: 400;
      //     line-height: 16px;
      //     margin-top: 4px;
      //   }
      // }

      .mes-box {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow-y: auto;

        .old-meg-hint {
          font-size: 14px;
          text-align: center;
          padding-top: 10px;
        }

        .loading {
          position: absolute;
          top: 90px;
          min-height: 40px;
          width: 100%;

          ::v-deep.el-loading-spinner {
            line-height: 40px;

            .el-icon-loading {
              color: black;
            }
          }
        }


        .prompt {
          margin: 20px auto 0 auto;
          width: 330px;
          min-height: 39px;
          line-height: 39px;
          background: #f0f0f0;
          border-radius: 4px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: CENTER;
          color: #c2c2c2;
        }

        .revoke_message {
          display: flex;
          justify-content: center;
          font-size: 14px;
          font-family: PingFang SC-Light, PingFang SC;
          font-weight: 300;
          color: #C2C2C2;
          margin-bottom: 10px;
        }

        .mes-item {
          padding: 0 20px;
          margin-top: 20px;
          display: flex;
          flex-shrink: 0;

          .avatar {
            cursor: pointer;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            overflow: hidden;
            .el-image{
              width: 100%;
              height: 100%;
            }
          }

          .mes {
            margin-left: 12px;
            width: 80%;

            .user-name {
              user-select: none;
              font-size: 12px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 300;
              color: #7F7F7F;
              img{
                vertical-align: bottom;
                width: 75px;
                height: 19px;
                margin-left: 5px;
              }

              .add-time {
                margin-left: 10px;
              }
            }

            .text-box {
              position: relative;
              z-index: 6;
              margin-top: 3px;
              display: flex;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;

              .text {
                word-break: break-word;
                word-wrap: break-word;
                min-height: 16px;
                position: relative;
                z-index: 6;
                display: inline;
                padding: 8px 12px;
                border-radius: 4px;
                line-height: 17px;
                background: #FFFFFF;
                border: 1px solid var(--border-soft, #E8E4DE);
                color: var(--text-main, #1A1D24);

                ::v-deep img {
                  max-width: 400px;
                }

                .merge-msg{
                  max-width: 300px;
                  width: 300px;
                  cursor: pointer;
                  .merge-msg-title{
                    font-size: 14px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #191919;
                    margin-bottom: 5px;
                  }
                  .merge-msg-list{
                    .merge-msg-item{
                      font-size: 12px;
                      font-family: PingFang SC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #B2B2B2;
                      display: -webkit-box;
                      -webkit-box-orient: vertical;
                      -webkit-line-clamp: 3;
                      overflow: hidden;
                    }
                  }
                  .merge-msg-bottom{
                    font-size: 12px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #B2B2B2;
                    border-top: 1px solid #EBEEF3;
                    margin-top: 8px;
                    padding-top: 8px;
                  }
                }
              }
            }

            .text-box::before, .file::before {
              position: absolute;
              content: '';
              z-index: 1;
              width: 0;
              height: 0;
              top: 10px;
              left: -8px;
              border-top: 5px solid transparent;
              border-right: 10px solid #FFFFFF;
              border-bottom: 5px solid transparent;
            }
            .send-link-box{
              // flex-direction: column;
              .wait-pay{
                border-radius: 0 0 4px 4px;
                box-sizing: border-box;
                display: flex;
                background: #fff;
                max-width: 300px;
                padding: 10px 15px 6px 0;
                justify-content: flex-end;
                align-items: center;
                margin-top: -4px;
                // &:last-child{
                //   margin-right: 15px;
                // }
                .countdown{
                  margin-left: 10px;
                  font-weight: 400;
                }
              }
            }
            .image {
              margin-top: 10px;
              max-width: 60%;
            }

            .file {
              cursor: pointer;
              position: relative;
              display: flex;
              margin-top: 4px;
              padding: 14px 0;
              padding-right: 30px;
              background-color: #FFFFFF;
              border: 1px solid var(--border-soft, #E8E4DE);
              border-radius: 4px;
              width: 300px;

              .file-img {
                display: inline-block;
                width: 42px;
                margin-left: 18px;
                .el-image{
                  width: 42px;
                }
              }

              .file-box {
                display: inline-block;
                margin-left: 18px;
                white-space:pre-wrap;
                word-break:break-all;

                .file-name {
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: var(--text-main, #1A1D24);
                }

                .file-size {
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  margin-top: 3px;
                  font-weight: 400;
                  color: #CFD3D7;
                }
              }
            }

            .announcement-box {
              display: flex;
              margin-top: 8px;

              .announcement {
                min-width: 240px;
                background-color: white;
                padding: 7px 10px;
                border: 1px solid var(--border-soft, #E8E4DE);
                border-radius: 4px;
                cursor: pointer;

                .title {
                  display: flex;
                  align-items: center;
                  font-size: 12px;
                  font-family: PingFang SC, PingFang SC-Medium;
                  font-weight: bold;
                  text-align: LEFT;
                  color: #555555;
                  padding-bottom: 7px;
                  border-bottom: 1px solid #ececec;
                }

                .content {
                  padding: 6px;
                  font-size: 14px;
                  font-family: PingFang SC, PingFang SC-Regular;
                  font-weight: 400;
                  text-align: LEFT;
                  color: #595e63;
                  border-bottom: 1px solid #ececec;
                  display: -webkit-box; //谷歌
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2; //显示几行
                  word-break: break-all;
                }

                .look-info {
                  text-align: right;
                  font-size: 12px;
                  font-family: PingFang SC, PingFang SC-Medium;
                  font-weight: bold;
                  color: #555555;
                  margin-top: 6px;
                }
              }
            }

            .rc-msg-card {
              min-width: 200px;
              max-width: 270px;
              background-color: #fff;
              border: 1px solid var(--border-soft, #E8E4DE);
              border-radius: 4px;
              overflow: hidden;
              margin-top: 6px;

              .rc-card-img {
                width: 100%;
                height: 120px;
                display: block;
              }

              .rc-card-body {
                padding: 8px 10px 6px;

                .rc-card-title {
                  font-size: 13px;
                  color: #333;
                  line-height: 1.4;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                  word-break: break-all;
                }

                .rc-card-price {
                  margin-top: 4px;
                  color: var(--primary, #FF5A1F);
                  font-size: 14px;
                  font-weight: bold;
                }
              }

              .rc-card-footer {
                font-size: 11px;
                color: #999;
                padding: 4px 10px;
                border-top: 1px solid #EBEEF3;
                text-align: right;
              }
            }
          }

          &.is-mi {
            flex-direction: row-reverse;

            .mes {
              margin-left: 0;
              margin-right: 12px;

              .user-name {
                text-align: right;
                display: flex;
                flex-direction: row-reverse;

                .add-time {
                  margin-left: 0 !important;
                  margin-right: 10px;
                }
              }

              .text-box {
                display: flex;
                justify-content: flex-end;

                &::before {
                  left: auto;
                  right: -8px;
                  border-right: none;
                  border-top: 5px solid transparent;
                  border-left: 10px solid var(--bg-dark, #1A1D24);
                  border-bottom: 5px solid transparent;
                }

                .text {
                  background: var(--bg-dark, #1A1D24);
                  color: #FFFFFF;
                }

              }
              .send-link-box{
                &::before{
                  border-left: 10px solid #fff;
                }
              }
              .file {

                &::before {
                  left: auto;
                  right: -8px;
                  border-right: none;
                  border-top: 5px solid transparent;
                  border-left: 10px solid #FFFFFF;
                  border-bottom: 5px solid transparent;
                }
              }

              .rc-msg-card {
                margin-left: auto;
              }
            }
          }
        }
        .recall_wrapper{
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ADADAD;
          text-align: center;
          margin: 10px 0;
        }
        .account-tip{
          margin: 30px 19px;
          height: 89px;
          min-height: 89px;
          background: #FFFFFF;
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          box-sizing: border-box;
          padding: 15px 9px;
          .account-tip-top{
            border-bottom: 1px solid var(--border-soft, #E8E4DE);
            text-indent: 5px;
            font-size: 14px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: var(--text-main, #1A1D24);
            padding-bottom: 10px;
          }
          .account-tip-bottom{
            padding-top: 12px;
            text-indent: 11px;
            font-size: 13px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #8C98A5;
          }
        }
      }
      .newMsg {
        position: absolute;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: var(--primary, #FF5A1F);
        display: flex;
        align-items: baseline;
        padding: 7px 15px 6px;
        background: #FFFFFF;
        box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        left: calc(50% - 50px);
        bottom: 219px;
        cursor: pointer;
        z-index: 999;

        img {
          margin: 0 4px 0 0;
        }
      }
      .aiteMsg{
        color: #F56B6C;
        left: calc(50% - 49px);
        &.el-button:active,&.el-button:focus,&.el-button:hover{
          border: none;
        }
        &.el-button{
          line-height: 17px;
        }
      }
      .score {
          margin: 19px 0 0;
          padding: 0 0 10px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .scoreHeader {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-family: PingFang SC-Light, PingFang SC;
            font-weight: 400;
            color: #A5ABB8;
            line-height: 14px;
            margin: 0 0 19px;

            > span {
              display: inline-block;
              margin: 0 10px;
              width: 83px;
              height: 1px;
              background: linear-gradient(270deg, #A5ABB8 0%, rgba(255, 255, 255, 0) 100%);
              border-radius: 4px 4px 4px 4px;
            }

            > span:last-of-type {
              background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #A5ABB8 100%);
            }
          }

          .scoreBody {
            height: 33px;

            /deep/ .el-rate__icon {
              font-size: 28px !important;
              margin: 0 10px !important;
            }

            /deep/ .el-rate__text {
              font-size: 12px;
              font-family: PingFang SC-Light, PingFang SC;
              font-weight: 400;
              color: #A5ABB8 !important;
              line-height: 14px;
              vertical-align: bottom;
            }

            /deep/ .el-rate__text::after {
              margin: 0 3px;
              content: ')';
            }

            /deep/ .el-rate__text::before {
              margin: 0 3px;
              content: '(';
            }

          }
        }
      .entrance-box {
        width: calc(100% - 40px);
        bottom: 0;
        height: 191px;
        padding: 10px 20px;
        background: var(--bg-card, #FFFFFF);
        // box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.1);
        &::before{
          border-top: 1px solid #E9E9E9;
          content: ' ';
          width: calc(100% + 20px);
          display: block;
          margin: 0 0 5px -10px;
        }
        &.is-mute {
          position: relative;
          cursor: not-allowed;

          &::before {
            position: absolute;
            z-index: 99;
            content: ' ';
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
          }

          .send-pc {
            background: #DBDBDB !important;
            color: #fff !important;
          }
        }

        .tool {
          user-select: none;
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .tool-box {
            display: flex;
            align-items: center;
            gap: 8px;
            .tool-item {
              position: relative;
              width: 34px;
              height: 34px;
              border: 1.5px solid var(--border-soft, #E8E4DE);
              border-radius: 4px;
              background: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: .2s var(--ease, ease);

              &:hover {
                border-color: var(--bg-dark, #1A1D24);
              }

              &::after {
                pointer-events: none;
                position: absolute;
                z-index: 50;
                display: none;
                left: 14px;
                bottom: 16px;
                content: attr(data-title);
                width: 51px;
                height: 22px;
                line-height: 22px;
                background: #FFFFFF;
                box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.15);
                border-radius: 4px;
                font-size: 12px;
                font-weight: 300;
                color: #9F9F9F;
                text-align: center;
              }

              &:hover {
                &::after {
                  display: inline-block;
                }
              }

              .tool-img {
                width: 18px;
                height: 18px;
                cursor: pointer;
                display: block;
              }
              ::v-deep .el-upload {
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
            .sendRemind{
              text-align: center;
              line-height: 34px;
              width: 78px;
              height: 34px;
              background: #FFFFFF;
              border: 1.5px solid var(--border-soft, #E8E4DE);
              border-radius: 4px;
              font-size: 12px;
              font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
              font-weight: normal;
              color: var(--text-secondary, #5A5F6B);
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: .2s var(--ease, ease);
              &:hover {
                border-color: var(--primary, #FF5A1F);
                color: var(--primary, #FF5A1F);
              }
              img{
                width: 10px;
                height: 13px;
                margin-right: 4px;
              }
            }
          }

          .send-pc {
            text-align: center;
            width: 70px;
            height: 30px;
            line-height: 30px;
            background: var(--primary, #FF5A1F);
            border-radius: 4px;
            cursor: pointer;
            font-size: 16px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            transition: background .2s ease;

            &:hover {
              background: var(--primary-hover, #E84A12);
            }
          }
        }

        .input-box {
          ::v-deep.edit-div {
            resize: none;
            max-width: 549px;
            height: 98px;
            background: var(--bg-card, #FFFFFF);
            border: none;

            &:focus {
              border-color: var(--primary, #FF5A1F);
            }
          }
        }

        .reminder {
          text-align: right;
          font-size: 12px;
          color: red;
          margin-top: 3px;
        }
      }

      .progress {
        position: absolute;
        right: 20px;
        top: 70px;
        width: 170px;
        font-size: 12px;
        background-color: #FFFFFF;
        z-index: 999;
        padding: 10px;
        border-radius: 4px;
        box-shadow: 0px 0px 10px 1px rgba(175, 98, 51, 0.13);

        .progress-title {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .file-name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100px;
          }
        }

        ::v-deep.el-progress-bar {
          margin-right: 0;
          padding-right: 0;
        }

        ::v-deep.el-progress__text {
          display: none;
        }
      }
      .chatBtn {
        display: flex;
        align-items: center;
        margin: 0 11px 0 0;

        .btn {
          display: flex;
          align-items: center;
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #696969;
          line-height: 17px;
          padding: 5px 16px;
          border-radius: 4px;
          border: 1px solid var(--border-soft, #E8E4DE);
          cursor: pointer;
          margin: 0 0 0 10px;

          img {
            margin: 0 3px 0 0;
          }
        }

        .btn:hover {
          border: 1px solid var(--primary, #FF5A1F);
          color: var(--primary, #FF5A1F);
        }
      }
      .refundCountdown{
        height: 40px;
        background: #FCEBEB;
        padding: 0 30px;
        line-height: 40px;
        font-size: 14px;
        font-family: Alibaba PuHuiTi 2.0-65 Medium, Alibaba PuHuiTi 20;
        font-weight: normal;
        color: #F56B6C;
        .count_down{
          margin-left: 5px;
          Letter-spacing: 3px
        }
      }
      .shop-link-info{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        background: #FFFFFF;
        padding: 10px;
        border-radius: 4px 4px 4px 4px;
        margin: 0 10px;
        .link-left{
          margin-right: 10px;
          img{
            width: 107px;
            height: 60px;
            border-radius: 2px 2px 2px 2px;
          }
        }
        .link-right{
          flex: 1;
          .link-title{
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            min-height: 34px;
          }
          .link-price{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .link-price-left{
              font-size: 12px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #000000;
              span{
                font-size: 16px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: var(--primary, #FF5A1F);
              }
            }
            .link-send{
              width: 69px;
              height: 20px;
              border-radius: 4px;
              border: 1px solid var(--primary, #FF5A1F);
              font-size: 12px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: var(--primary, #FF5A1F);
              text-align: center;
              cursor: pointer;
              margin-top: 5px;
            }
          }
        }
        .link-close{
          color: #E6E6E6;
          &:hover{
            color: #F56B6C
          }
        }
      }
    }

    .room-info {
      flex: 0 0 300px;
      width: 300px;
      height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      padding: 0px 10px 0 10px;
      box-sizing: border-box;
      &::-webkit-scrollbar {
        width: 5px;
      }
      ::v-deep.el-tabs__nav-scroll{
        padding: 0 10px;
      }
      ::v-deep.el-tabs__item {
        font-size: 15px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 800;
        color: var(--text-secondary, #5A5F6B);

        &:hover {
          color: var(--primary, #FF5A1F);
        }

        &.is-active {
          color: var(--primary, #FF5A1F);
        }
      }

      ::v-deep.el-tabs__active-bar {
        height: 3px;
        background-color: var(--primary, #FF5A1F);
      }

      ::v-deep.el-tabs__nav-wrap::after {
        height: 1px;
        background-color: var(--border-soft, #E8E4DE);
      }

      .form-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        padding: 0px 10px;

        .label {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: LEFT;
          color: #A4ABB8;
          width: 80px;
        }

        .input {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #51555E;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          ::v-deep.el-input__inner {
            height: 24px;
            line-height: 24px;

            &:focus {
              border-color: var(--primary, #FF5A1F);
            }
          }
        }
      }

      .announcement {
        .title {
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #000;
          margin-top: 13px;
        }

        .content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 5px;

          .text {
            display: -webkit-box; //谷歌
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; //显示几行
            overflow: hidden;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: LEFT;
            color: #595e63;
            word-break: break-all;
            height: 40px;
          }
        }
      }

      .text-1 {
        font-size: 14px;
        font-family: PingFang SC-Light, PingFang SC;
        font-weight: 300;
        color: #A5ACB4;
        line-height: 16px;
      }

      .text-2 {
        height: 48px;
        font-size: 13px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #595E63;
        line-height: 16px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }

      .remark {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #f6f6f6;
        padding: 5px 0;

        .remark-content {
          width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
          font-weight: 400;
          color: #80868E;

          ::v-deep.el-input__inner {
            border: none;
            background-color: #f6f6f6;
            font-size: 14px;
            height: auto;
            line-height: 100%;
            padding: 0 0 0 11px;
            font-size: 14px;
            font-weight: 400;
            color: #80868E;
          }
        }

        .point {
          font-size: 12px;
          font-family: PingFang SC-Light, PingFang SC;
          font-weight: 300;
          color: #BAC4CF;
          line-height: 14px;
        }
      }

      .edit-remark {
        border-radius: 4px 4px 4px 4px;
        border: 1px solid var(--primary, #FF5A1F);
        padding: 4px 0;
      }

      .create-time {
        margin-top: 13px;
        font-size: 14px;
        font-family: PingFang SC-Light, PingFang SC;
        font-weight: 300;
        color: #A5ACB4;
      }

      .room-divider {
        height: 1px;
        background-color: #ECECEC;
        margin: 20px 0;
      }

      .room-set {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;

        span {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #595E63;
        }

        ::v-deep.el-switch {
          height: 30px;

          &.is-checked {
            .el-switch__core::after {
              left: 83%;
            }
          }
        }

        ::v-deep.el-switch__core {
          width: 60px !important;
          height: 30px;
          border-radius: 4px 4px 4px 4px;

          &::after {
            top: 1px;
            left: 1px;
            width: 26px;
            height: 26px;
          }
        }
      }

      .members-title {
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        // align-items: center;
        margin: 20px 0 14px;
        border-bottom: 2px solid var(--border-soft, #E8E4DE);
        span{
          color: var(--text-main, #1A1D24);
          font-size: 16px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          margin-left: 10px;
          &::after{
            content: '';
            display: block;
            width: 64px;
            height: 2px;
            background: var(--primary, #FF5A1F);
            border-radius: 4px;
            margin: 5px 0 -2px;
          }
        }

        // .text {
        //   font-size: 18px;
        //   font-family: PingFang SC-Medium, PingFang SC;
        //   font-weight: 500;
        //   color: #435160;
        //   cursor: default;
        //   user-select: none;
        // }

        // .pack-up:hover {
        //   color: #FFC251;
        // }

        // .pack-up {
        //   user-select: none;
        //   cursor: pointer;
        //   font-size: 14px;
        //   font-family: PingFang SC-Regular, PingFang SC;
        //   font-weight: 400;
        //   color: #A5ACB4;
        //   display: flex;
        //   align-items: center;

        //   i {
        //     transition: transform 0.2s linear;
        //     margin-left: 5px;
        //   }
        // }

        // .expansion {
        //   i {
        //     transform: rotate(180deg);
        //   }
        // }
      }

      .members {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        left: -15px;
        width: calc(100% + 30px);
        user-select: none;
        margin-bottom: 10px;

        i {
          cursor: pointer;
          color: #E2E2E2;
          font-size: 20px;

          &:hover {
            color: #FFC251;
          }
        }

        .list {
          display: flex;
          overflow-y: auto;

          &::-webkit-scrollbar {
            width: 0;
            height: 0;
          }

          .item {
            min-width: 40px;
            max-width: 40px;
            min-height: 40px;
            max-height: 40px;
            background: #F0F2F4;
            border-radius: 4px 4px 4px 4px;
            margin: 0 4px;
          }
        }
      }

      .members-expansion {
        position: relative;
        width: 270px;
        // width: 335px;
        left: -10px;
        // height: 340px;
        overflow-y: auto;
        .mem-title{
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #A4ABB8;
          padding: 10px 20px 8px;
        }
        .item {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          padding: 4px 20px;
          height: 38px;
          box-sizing: border-box;

          &:hover {
            background: #F7F8FA;
          }

          .avatar {
            border-radius:50%;
            min-width: 30px;
            max-width: 30px;
            height: 30px;
            margin-right: 15px;
          }

          .name {
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #282828;
            max-width: 140px;
            line-height: 19px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .privateChat {
            font-size: 14px;
            font-family: PingFang SC-Light, PingFang SC;
            font-weight: 300;
            color: #A5ACB4;
            line-height: 16px;
            padding-left: 2px;
            margin-top: 2px;
          }

          .exchangeGroup {
            width: 51px;
            height: 22px;
            text-align: center;
            line-height: 22px;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            background: #F7F5F2;
            box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.15);
            border-radius: 4px;
          }

          .on-line-2 {
            width: 32px;
            height: 17px;
            background: #CDCDCD;
            border-radius: 4px;
            font-size: 12px;
            line-height: 17px;
            text-align: center;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
          }

          .on-line-0 {
            width: 32px;
            height: 17px;
            background: #CDCDCD;
            border-radius: 4px;
            font-size: 12px;
            line-height: 17px;
            text-align: center;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
          }
        }
      }
      .room-quit-box{
        position: sticky;
        bottom: 0;
        margin-top: auto;
        background: var(--bg-card, #FFFFFF);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50px;
      }
      .room-quit {
        cursor: pointer;
        width: 230px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        background: #F7F8FA;
        border-radius: 4px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 400;
        text-align: center;
        color: #D4D9E0;
      }
      .cardBody {
        margin: 0 0 0 10px;
        display: flex;
        align-items: center;

        .avatar {
          width: 50px;
          height: 50px;
          border-right: 25px;
          margin: 0 10px 0 0;
          border-radius: 50%;
        }

        .other {
          > div {
            font-size: 12px;
            font-family: PingFang SC-Light, PingFang SC;
            font-weight: 400;
            color: #000000;
            display: flex;
            align-items: center;
            margin: 4.5px 0;

            span {
              color: #8B8B8B;
            }

            /deep/ .el-rate {
              display: inline-block;
            }
          }
          .customer_name{
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
      .order-info-wrapper{
        .order_info_border{
          border-bottom: 5px solid var(--bg-tag, #F0EDE8);
          margin-bottom:10px;
          &:last-child{
            border: none;
            margin-bottom:0px;
          }
          .pay_btn_detail{
            margin:0 10px;
            padding: 10px 0;
            border-top: 1px solid #EFEFEF;
            display: flex;
            justify-content: space-between;
            align-items: center;
            div{
              width: 103px;
              height: 25px;
              background: var(--bg-tag, #F0EDE8);
              border-radius: 4px;
              font-size: 12px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              text-align: center;
              line-height: 25px;
              cursor: pointer;
            }
            .pay_detail{
              background: var(--primary, #FF5A1F);
              color: #fff;
              border: 1px solid var(--primary, #FF5A1F);
            }
            .refund_detail{
              background: #fff;
              color: var(--primary, #FF5A1F);
              border: 1px solid var(--primary, #FF5A1F);
            }
          }
        }
      }
      .sendLink{
        margin: 0 10px 5px;
        border-bottom: 1px solid #EFEFEF;
        padding-bottom: 10px;
        .link-top{
          display: flex;
          justify-content: space-between;
          align-items: center;
          img{
            width: 80px;
            height: 45px;
            border-radius: 2px 2px 2px 2px;
          }
          span{
            flex: 1;
            margin-left: 10px;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
        .link-bottom{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .link-price{
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            span{
              font-size: 16px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: var(--primary, #FF5A1F);
            }
          }
          .link-btn{
            width: 69px;
            height: 20px;
            line-height: 20px;
            border-radius: 4px;
            border: 1px solid var(--primary, #FF5A1F);
            font-size: 12px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: var(--primary, #FF5A1F);
            text-align: center;
            cursor: pointer;
          }
        }
      }
      .pay-status{
        border-bottom: 1px solid #EFEFEF;
        // border-left: none;
        // border-right: none;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #CFCFCF;
        height: 35px;
        line-height: 30px;
        margin:0 10px 10px;
        span{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          i{
            font-size: 18px;
            margin-right: 3px;
          }
        }
        .pay-success{
          color: #60C75E;
        }
        .pay-err{
          color: #F56B6C;
        }
        .pay-check{
          color: var(--primary, #FF5A1F);
          i{
            background-color: var(--primary, #FF5A1F);
            border-radius: 50%;
            color: #fff
          }
        }
        .wait-pay{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .countdown{
            margin-left: 10px;
            font-weight: 400;
          }
        }
      }
      .order-refund{
        margin-bottom: 10px;
        border-bottom: 1px solid #EFEFEF;
        padding-bottom: 10px;
        .refund-title{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          // border-top: 1px solid #EFEFEF;
          padding: 0 0 10px;
          margin: 0 10px;
          .title-left{
            font-size: 14px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #434343;
          }
        }
        .refund-btn{
          font-size: 12px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          margin: 0 10px;
          .title-red{
            width: 108px;
            height: 25px;
            line-height: 25px;
            border-radius: 4px;
            border: 1px solid var(--danger, #FF2D55);
            text-align: center;
            color: var(--danger, #FF2D55);
            cursor: pointer;
          }
          .title-save{
            width: 110px;
            width: 108px;
            height: 25px;
            line-height: 25px;
            border-radius: 4px;
            text-align: center;
            margin-left: 10px;
            background: var(--primary, #FF5A1F);
            color: #fff;
            cursor: pointer;
          }
        }
        .form-item{
          .input{
            width: 127px;
            /deep/.el-input__inner{
              padding: 0 10px;
              font-size: 12px;
              color: #C8C8C8;

            }
            /deep/.el-input__icon{
              line-height: inherit;
            }
          }
        }
      }
      .ratingStars{
        border-top: 1px #EFEFEF solid;
        margin-top: 10px;
        padding: 10px 0 0 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .ratingStars_title{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          img{
            width: 15px;
            height: 15px;
            margin-right: 3px;
          }
        }
      }
      .privateChat-about{
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #909AA5;
        line-height: 23px;
        padding: 0 10px;
        height: 350px;
        // overflow-y: auto;
      }
      .priva-img{
        width: 270px;
        height: 66px;
        margin-left: -10px;
        position: fixed;
        bottom: calc(50% - 350px);
        z-index: 3;
      }
      .priva-box{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: var(--text-muted, #9AA0AC);
        font-size: 12px;
        padding: 0 23px;
        box-sizing: border-box;
        width: calc(100% + 20px);
        height: 66px;
        margin-left: -10px;
        background: var(--bg-card, #FFFFFF);
        border-top: 1px solid var(--border-soft, #E8E4DE);
        position: absolute;
        bottom: 0;
        .priva-phone{
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .priva-box-phone{
            display: flex;
            align-items: center;
          }
          .priva-box-time{
            color: #F0EDE8;
          }
        }
        span{
          letter-spacing: 4px;
        }
        img{
          width: 20px;
          height: 20px;
        }
        >div:last-child{
          text-align: right;
        }
      }
      overflow-y: auto;
      overflow-x: hidden;
      padding-bottom: 80px;
    }
    .app_qrcode{
      position: absolute;
      top: 0;
      left: -231px;
      width: 231px;
      height: 298px;
      background: url(../../assets/image/chat/app_qrcode_bg.png);
      background-size: 100%;
      box-sizing: border-box;
      padding: 20px;
      &::before{
        position: absolute;
        top: 21%;
        left: 12.5%;
        z-index: 99999;
        content: '';
        width: 70%;
        height: 2px;
        background-color: #F0EDE8;
        animation-name: upDown;
        animation-duration: 3s;
        animation-fill-mode: forwards;
      }
      @keyframes upDown {
        0%{
          top: 21%;
        }
        23%{
          top: 81%;
        }
        48%{
          top: 21%;
        }
        100%{
          top: 81%;
          visibility: hidden;
        }
      }
      .qrcode-top{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 38px;
        img{
          width: 38px;
          height: 38px;
          margin-right: 9px;
        }
        .qrcode-top-text{
          font-family: PingFang SC-Medium, PingFang SC;
          &:first-child{
            font-size: 14px;
            font-weight: 500;
            color: #212121;
          }
          &:last-child{
            font-size: 12px;
            font-weight: 400;
            color: #414141;
            // line-height: 14px;
            letter-spacing: 3px;
          }
        }
      }
      .app-qrcode-img{
        width: 180px;
        height: 192px;
      }
      .qrcode-bottom{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 12px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        letter-spacing: 2px;
        img{
          width: 21px;
          height: 19px;
          margin-right: 9px;
        }
      }
    }
    .wx_qrcode{
      top: 318px;
      height: 282px;
      padding: 15px 40px 15px 30px;
      background: url(../../assets/image/chat/wx_qrcode_bg.png);
      background-size: 100%;
      box-sizing: border-box;
      &::before{
        position: static;
        z-index: 99999;
        content: '';
        width: auto;
        height: auto;
        background-color: transparent;
        animation: none;
      }
      .wx_qrcode_top{
        font-size: 12px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        text-align: center;
        word-wrap: break-word;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        max-height: 33px;
        margin-bottom: 10px;
        padding-right: 10px;
      }
      .app-qrcode-img{
        width: 150px;
        height: 150px;
      }
      .wx-qrcode-bottom{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        img{
          width: 13px;
          height: 15px;
          margin-right: 5px;
        }
        i{
          line-height: 21px;
        }
      }
      .wx-qrcode-bottom-last{
        color: #32B440;
        margin-top:10px;
        img{
          width:13px;
          height: 13px;
        }
      }
    }
  }
@media screen and (max-width: 1630px) {
  .room-box{
    margin-right: -100px;
    .app_qrcode{
      width: 200px;
      height: 258px;
      left: -200px;
      .qrcode-top{
        height: 33px;
        img{
          width: 33px;
          height: 33px;
        }
        .qrcode-top-text{
          &:last-child{
            letter-spacing: 1px;
          }
        }
      }
      .app-qrcode-img{
        width: 155px;
        height: 166px;
      }
      .qrcode-bottom{
        letter-spacing: 1px;
        img{
          width: 18px;
          height: 16px;
          margin-right: 6px;
        }
      }
    }
    .wx_qrcode{
      top: 268px;
      height: 244px;
      padding: 15px;
      .app-qrcode-img{
        width: 140px;
        height: 140px;
        display: block;
        transform: translate(50%);
        margin-left: -59px;
      }
      .wx_qrcode_top{
        margin-bottom: 10px;
      }
      .wx-qrcode-bottom-last{
        margin-top: 5px;
      }
    }
  }
}
 @media screen and (max-width: 1465px) {
  .room-box{
    // margin-right: -100px;
    .app_qrcode{
      width: 150px;
      height: 194px;
      left: -150px;
      padding: 10px;
      .qrcode-top{
        height: 33px;
        img{
          width: 33px;
          height: 33px;
        }
        .qrcode-top-text{
          &>div:last-child{
            display: none;
          }
        }
      }
      .app-qrcode-img{
        width: 122px;
        height: 122px;
      }
      .qrcode-bottom{
        letter-spacing: 0px;
        img{
          display: none;
        }
      }
    }
    .wx_qrcode{
      top: 204px;
      padding: 9px 15px 3px 0px;
      height: 183px;
      .wx_qrcode_top{
        transform: scale(0.8);
        width: 150px;
        margin-bottom: 0px;
      }
      .app-qrcode-img{
        width: 120px;
        height: 120px;
        display: block;
        transform: translate(50%);
        margin-left: -47px;
      }
      .wx-qrcode-bottom-none{
        display: none;
      }
      .wx-qrcode-bottom-last{
        margin: 0;
      }
    }
  }
}

  .menu {
    position: absolute;
    z-index: 999;
    padding: 5px 0;
    width: 78px;
    color: #CDCDCD;
    background: #FFFFFF;
    box-shadow: 0px 2px 3px 1px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;

    .contextmenu__item {
      cursor: default;
      padding: 2px 10px;

      &:hover {
        background: #EFF2F6;
        color: #686C74;
      }
    }

    .contextmenu__item:nth-last-child(1) {
      margin-bottom: 0;
    }
  }

  .msgRight {
    position: absolute;
    z-index: 999;
    width: 61px;
    background: #FFFFFF;
    box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;

    .item {
      text-align: center;
      height: 25px;
      line-height: 25px;
      font-size: 14px;
      font-family: PingFang SC-Light, PingFang SC;
      font-weight: 300;
      color: #9F9F9F;
      cursor: pointer;

      &:hover {
        background: var(--bg-tag, #F0EDE8);
      }
    }
  }
  .headImgRight{
    position: absolute;
    z-index: 999;
    width: 115px;
    background: #FFFFFF;
    box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;

    .item {
      text-align: center;
      height: 25px;
      line-height: 25px;
      font-size: 14px;
      font-family: PingFang SC-Light, PingFang SC;
      font-weight: 300;
      color: #9F9F9F;
      cursor: pointer;

      &:hover {
        background: #F6F7FA;
      }
    }
  }

  .quit-mark {
    position: fixed;
    z-index: 999999;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .quit-box {
      width: 285px;
      height: 152px;
      background: #ffffff;
      border-radius: 4px;
      padding: 25px;
      box-sizing: border-box;

      .quit-title {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #000000;
      }
      .quit-con{
        color: #999;
        text-align: center;
        margin-top: 10px;
      }
      .quit-btn {
        display: flex;
        justify-content: space-evenly;
        margin-top: 22px;

        .quit {
          width: 99px;
          height: 30px;
          line-height: 30px;
          border: 1px solid var(--danger, #FF2D55);
          border-radius: 4px;
          cursor: pointer;
          text-align: center;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          background: var(--danger, #FF2D55);
          color: #fff;
        }

        .retain {
          width: 99px;
          height: 30px;
          line-height: 30px;
          border-radius: 4px;
          border: 1px solid var(--bg-dark, #1A1D24);
          cursor: pointer;
          text-align: center;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-main, #1A1D24);
        }
      }
    }

    .quit-close {
      margin-top: 10px;
      color: white;
      font-size: 33px;

      i {
        cursor: pointer;
      }
    }
  }
}
#room-content{
  ::v-deep.dia_pay_refund{
    border-radius: 4px !important;
    .el-dialog__header{
      padding: 15px 0 0;
      .el-dialog__headerbtn{
        top: 7px;
        right: 7px;
      }
      .el-dialog__title{
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #232323;
      }
    }
    .el-dialog__body{
      padding: 15px;
      .pay_refund_item{
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #A4ABB8;
        border-bottom: 1px solid #E9E9E9;
        line-height: 26px;
        margin-bottom: 5px;
        padding-bottom: 5px;
        span{
          color: #51555E;
        }
      }
      .pay_refund_detail{
        font-size: 12px;
        line-height: 22px;
      }
      .pay_qrcode_wrapper{
        text-align: center;
        font-family: PingFang SC-Medium, PingFang SC;
        .pay_title{
          font-size: 16px;
          font-weight: 500;
          color: var(--text-main, #1A1D24);
          img{
            width: 20px;
            height: 20px;
            vertical-align: bottom;
            margin-right: 3px;
          }
        }
        .pay_price{
          font-size: 26px;
          font-weight: 600;
          color: var(--primary, #FF5A1F);
          margin: 5px 0;
        }
        .pay_qrcode{
          display: inline-block;
          width: 220px;
          height: 220px;
          background: url(../../assets/image/chat/qr_code_bg.png);
          padding: 10px;
          box-sizing: border-box;
          img{
            width: 200px;
            height: 200px;
          }
        }
        .pay_tip{
          font-size: 16px;
          font-weight: 500;
          color: #000000;
          margin: 10px 0 20px;
          span{
            font-weight: 600;
            color: var(--primary, #FF5A1F);
            margin: 0 5px;
          }
        }
        .pay_bottom{
          font-size: 12px;
          font-weight: 500;
          color: #000000;
          line-height: 20px;
          .pay_bottom_top{
            span{
              font-weight: 600;
              color: var(--primary, #FF5A1F);
            }
          }
          .pay_bottom_bottom{}
        }
      }
    }
  }

}
</style>
